import React, { FC } from "react"
import "./icons.css"
import ChartSliderIcon from "../icons/chart_slider.png"
import FavouriteIcon from "../icons/favourite.png"
import MapLocationIcon from "../icons/map_location.png"
import classNames from "classnames"

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string
}


export const IconSOPChecklist = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      className="IconSOPChecklist"
    >
        <path fill="currentColor" d="M5.55 19L2 15.45l1.4-1.4l2.125 2.125l4.25-4.25l1.4 1.425zm0-8L2 7.45l1.4-1.4l2.125 2.125l4.25-4.25l1.4 1.425zM13 17v-2h9v2zm0-8V7h9v2z"/>
    </svg>
  )
}

export const IconFolderAdd = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="#000000"
      className="IconFolderAdd"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M20 6h-8l-2-2H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-1 8h-3v3h-2v-3h-3v-2h3V9h2v3h3v2z" />
    </svg>
  )
}

export const IconLamp = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      enableBackground="new 0 0 24 24"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconLamp"
    >
      <g>
        <rect fill="none" height={24} width={24} />
      </g>
      <g>
        <g />
        <g>
          <path d="M12,3c-0.46,0-0.93,0.04-1.4,0.14C7.84,3.67,5.64,5.9,5.12,8.66c-0.48,2.61,0.48,5.01,2.22,6.56 C7.77,15.6,8,16.13,8,16.69V19c0,1.1,0.9,2,2,2h0.28c0.35,0.6,0.98,1,1.72,1s1.38-0.4,1.72-1H14c1.1,0,2-0.9,2-2v-2.31 c0-0.55,0.22-1.09,0.64-1.46C18.09,13.95,19,12.08,19,10C19,6.13,15.87,3,12,3z M14,17h-4v-1h4V17z M10,19v-1h4v1H10z M15.31,13.74c-0.09,0.08-0.16,0.18-0.24,0.26H8.92c-0.08-0.09-0.15-0.19-0.24-0.27c-1.32-1.18-1.91-2.94-1.59-4.7 c0.36-1.94,1.96-3.55,3.89-3.93C11.32,5.03,11.66,5,12,5c2.76,0,5,2.24,5,5C17,11.43,16.39,12.79,15.31,13.74z" />
        </g>
        <g>
          <rect height={3} width={1} x="11.5" y={11} />
          <rect
            height={3}
            transform="matrix(0.7071 -0.7071 0.7071 0.7071 -4.0312 10.8536)"
            width={1}
            x="10.59"
            y="8.79"
          />
          <rect
            height={3}
            transform="matrix(-0.7071 -0.7071 0.7071 -0.7071 14.7678 26.7028)"
            width={1}
            x="12.41"
            y="8.79"
          />
        </g>
      </g>
    </svg>
  )
}

export const IconTouch = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      enableBackground="new 0 0 24 24"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconTouch"
    >
      <g>
        <rect fill="none" height={24} width={24} />
      </g>
      <g>
        <g>
          <path d="M18.19,12.44l-3.24-1.62c1.29-1,2.12-2.56,2.12-4.32c0-3.03-2.47-5.5-5.5-5.5s-5.5,2.47-5.5,5.5c0,2.13,1.22,3.98,3,4.89 v3.26c-2.15-0.46-2.02-0.44-2.26-0.44c-0.53,0-1.03,0.21-1.41,0.59L4,16.22l5.09,5.09C9.52,21.75,10.12,22,10.74,22h6.3 c0.98,0,1.81-0.7,1.97-1.67l0.8-4.71C20.03,14.32,19.38,13.04,18.19,12.44z M17.84,15.29L17.04,20h-6.3 c-0.09,0-0.17-0.04-0.24-0.1l-3.68-3.68l4.25,0.89V6.5c0-0.28,0.22-0.5,0.5-0.5c0.28,0,0.5,0.22,0.5,0.5v6h1.76l3.46,1.73 C17.69,14.43,17.91,14.86,17.84,15.29z M8.07,6.5c0-1.93,1.57-3.5,3.5-3.5s3.5,1.57,3.5,3.5c0,0.95-0.38,1.81-1,2.44V6.5 c0-1.38-1.12-2.5-2.5-2.5c-1.38,0-2.5,1.12-2.5,2.5v2.44C8.45,8.31,8.07,7.45,8.07,6.5z" />
        </g>
      </g>
    </svg>
  )
}

export const IconSupport = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      enableBackground="new 0 0 24 24"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconSupport"
    >
      <g>
        <rect fill="none" height={24} width={24} />
      </g>
      <g>
        <g>
          <path d="M21,12.22C21,6.73,16.74,3,12,3c-4.69,0-9,3.65-9,9.28C2.4,12.62,2,13.26,2,14v2c0,1.1,0.9,2,2,2h1v-6.1 c0-3.87,3.13-7,7-7s7,3.13,7,7V19h-8v2h8c1.1,0,2-0.9,2-2v-1.22c0.59-0.31,1-0.92,1-1.64v-2.3C22,13.14,21.59,12.53,21,12.22z" />
          <circle cx={9} cy={13} r={1} />
          <circle cx={15} cy={13} r={1} />
          <path d="M18,11.03C17.52,8.18,15.04,6,12.05,6c-3.03,0-6.29,2.51-6.03,6.45c2.47-1.01,4.33-3.21,4.86-5.89 C12.19,9.19,14.88,11,18,11.03z" />
        </g>
      </g>
    </svg>
  )
}

export const IconSubtract = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconSubtract"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M18 13H6c-.55 0-1-.45-1-1s.45-1 1-1h12c.55 0 1 .45 1 1s-.45 1-1 1z" />
    </svg>
  )
}

export const IconAdd = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconAdd"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M18 13h-5v5c0 .55-.45 1-1 1s-1-.45-1-1v-5H6c-.55 0-1-.45-1-1s.45-1 1-1h5V6c0-.55.45-1 1-1s1 .45 1 1v5h5c.55 0 1 .45 1 1s-.45 1-1 1z" />
    </svg>
  )
}

export const IconAddBox = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconAddBox"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-3 10h-3v3c0 .55-.45 1-1 1s-1-.45-1-1v-3H8c-.55 0-1-.45-1-1s.45-1 1-1h3V8c0-.55.45-1 1-1s1 .45 1 1v3h3c.55 0 1 .45 1 1s-.45 1-1 1z" />
    </svg>
  )
}

export const IconAddCircle = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconAddCircle"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
    </svg>
  )
}

export const IconCamera = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconCamera"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M14.12 4l1.83 2H20v12H4V6h4.05l1.83-2h4.24M15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2zm-3 7c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3m0-2c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5z" />
    </svg>
  )
}

export const IconNews = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconNews"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M23 12l-2.44-2.78.34-3.68-3.61-.82-1.89-3.18L12 3 8.6 1.54 6.71 4.72l-3.61.81.34 3.68L1 12l2.44 2.78-.34 3.69 3.61.82 1.89 3.18L12 21l3.4 1.46 1.89-3.18 3.61-.82-.34-3.68L23 12zm-4.51 2.11l.26 2.79-2.74.62-1.43 2.41L12 18.82l-2.58 1.11-1.43-2.41-2.74-.62.26-2.8L3.66 12l1.85-2.12-.26-2.78 2.74-.61 1.43-2.41L12 5.18l2.58-1.11 1.43 2.41 2.74.62-.26 2.79L20.34 12l-1.85 2.11zM11 15h2v2h-2zm0-8h2v6h-2z" />
    </svg>
  )
}

export const IconPen = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      className="icon-component IconPen"
    >
      <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
      <path d="M0 0h24v24H0z" fill="none" />
    </svg>
  )
}

export const IconLock = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconLock"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10z" />
    </svg>
  )
}

export const IconLockSolid = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="#000000"
      className="IconLockSolid"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" />
    </svg>
  )
}

export const IconClockWarn = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1.1"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      className="IconClockWarn"
    >
      <path d="M11 7V13L16.2 16.1L17 14.9L12.5 12.2V7H11M20 12V18H22V12H20M20 20V22H22V20H20M18 20C16.3 21.3 14.3 22 12 22C6.5 22 2 17.5 2 12S6.5 2 12 2C16.8 2 20.9 5.4 21.8 10H19.7C18.8 6.6 15.7 4 12 4C7.6 4 4 7.6 4 12S7.6 20 12 20C14.4 20 16.5 18.9 18 17.3V20Z" />
    </svg>
  )
}

export const IconWarning = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      enableBackground="new 0 0 24 24"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="#000000"
      className="IconWarning"
    >
      <g>
        <rect fill="none" height={24} width={24} />
      </g>
      <g>
        <g>
          <g>
            <path d="M12,5.99L19.53,19H4.47L12,5.99 M12,2L1,21h22L12,2L12,2z" />
            <polygon points="13,16 11,16 11,18 13,18" />
            <polygon points="13,10 11,10 11,15 13,15" />
          </g>
        </g>
      </g>
    </svg>
  )
}

export const IconPhoneSolid = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1.1"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      className="IconPhoneSolid"
    >
      <path d="M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z" />
    </svg>
  )
}

export const Icon2FactorSMS = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      version="1.1"
      viewBox="0 0 400 550"
      className="Icon2FactorSMS"
    >
      <path d="m350 319.2c34.02 0 61.598 27.578 61.598 61.602 0 5.1953-3.6914 9.6562-8.7969 10.625l-1.6445 0.3125c-5.4102 1.0234-10.625-2.5273-11.652-7.9336-0.039063-0.21094-0.070313-0.42188-0.097657-0.63672l-1.0352-8.3516c0-21.199-16-32.484-37.023-33.195l-1.3477-0.019532c-21.199 0-38.469 16.824-39.18 37.852l-0.019532 1.3477v28h100.8c18.559 0 33.602 15.043 33.602 33.598v61.602c0 18.559-15.043 33.602-33.602 33.602h-128.8c-18.559 0-33.602-15.043-33.602-33.602v-61.602c0-18.555 15.043-33.598 33.602-33.598h5.5977v-28c0-34.023 27.578-61.602 61.602-61.602zm56 112h-117.6c-8.9453 0-16.258 6.9961-16.77 15.812l-0.03125 0.98828v50.398c0 8.9492 6.9961 16.262 15.812 16.773l0.98828 0.027344h117.6c8.9453 0 16.258-6.9922 16.77-15.812l0.03125-0.98828v-50.398c0-9.2773-7.5234-16.801-16.801-16.801z" />
      <path d="m300 33.602c37.113 0 67.203 30.086 67.203 67.199v184.8c0 6.1836-5.0156 11.199-11.203 11.199-6.1836 0-11.199-5.0156-11.199-11.199v-179.2c0-27.832-22.562-50.398-50.398-50.398h-207.2c-27.34 0-49.594 21.766-50.379 48.914l-0.023437 1.4844v341.6c0 27.34 21.766 49.594 48.914 50.379l1.4883 0.019532h123.2c6.1836 0 11.199 5.0156 11.199 11.203 0 6.1836-5.0156 11.199-11.199 11.199h-128.8c-37.113 0-67.199-30.086-67.199-67.199v-352.8c0-37.113 30.086-67.199 67.199-67.199z" />
      <path d="m210 408.8c0 12.371-10.027 22.398-22.398 22.398s-22.398-10.027-22.398-22.398c0-12.371 10.027-22.402 22.398-22.402s22.398 10.031 22.398 22.402" />
      <path d="m350 453.6c6.1836 0 11.199 5.0117 11.199 11.199 0 4.1406-2.25 7.7617-5.5938 9.6992l-0.007812 12.699c0 3.0938-2.5039 5.6016-5.5977 5.6016s-5.6016-2.5078-5.6016-5.6016v-12.699c-3.3477-1.9336-5.5977-5.5547-5.5977-9.6992 0-6.1875 5.0117-11.199 11.199-11.199z" />
    </svg>
  )
}

export const IconLockClosed = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="18px"
      height="18px"
      className="IconLockClosed"
    >
      <g fill="none">
        <path d="M0 0h24v24H0V0z" />
        <path d="M0 0h24v24H0V0z" opacity=".87" />
      </g>
      <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z" />
    </svg>
  )
}

export const IconOfficer = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="black"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M17 2.90961C12.8541 1.14073 10.6523 1.1217 7 2.90961L7.5 4.57581H16.4737L17 2.90961Z" />
      <path d="M8 5.57581C9.33333 8.24247 14.6667 8.24247 16 5.57581H8Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 8.00003C8 7.32986 8.1646 6.69832 8.4556 6.1436H11.0173C10.3526 6.4961 9.9 7.1951 9.9 8.00003C9.9 9.16003 10.84 10.1 12 10.1C13.16 10.1 14.1 9.16003 14.1 8.00003C14.1 7.1951 13.6474 6.4961 12.9827 6.1436H15.5444C15.8354 6.69832 16 7.32986 16 8.00003C16 10.21 14.21 12 12 12C9.79 12 8 10.21 8 8.00003ZM14 15.0974C16.2248 15.518 18.1 16.5047 18.1 17V18.1H14V20L20 20V17C20 14.9089 16.7061 13.6336 14 13.1837V15.0974ZM10 15.0974V13.1837C7.2939 13.6336 4 14.9089 4 17V20L10 20V18.1H5.9V17C5.9 16.5047 7.77522 15.518 10 15.0974Z"
      />
      <path d="M11 13.1028H13V20H11V13.1028Z" />
    </svg>
  )
}

export const IconPatrolAdd = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="IconPatrolAdd"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5 2V4.5L16 4.5V6.5H18.5V9H20.5V6.5L23 6.5V4.5L20.5 4.5V2H18.5ZM15 4.33381C10.8541 2.56492 8.6523 2.5459 5 4.33381L5.5 6H14.4737L15 4.33381ZM6.63287 7.83911C6.23231 8.46219 6 9.20384 6 10C6 12.21 7.79 14 10 14C12.21 14 14 12.21 14 10C14 9.20384 13.7677 8.46219 13.3671 7.83911C13.6258 7.59721 13.8412 7.31751 14 7H6C6.15875 7.31751 6.37421 7.59721 6.63287 7.83911ZM8.4109 8.78918C8.15338 9.12587 8 9.54589 8 10C8 11.1 8.9 12 10 12C11.1 12 12 11.1 12 10C12 9.54589 11.8466 9.12587 11.5891 8.78918C10.5753 9.07027 9.42467 9.07027 8.4109 8.78918ZM2 18C2 16.0541 4.85239 14.8146 7.42916 14.2893C7.90672 14.5762 8.43613 14.7855 9 14.9V21H2V18ZM11 14.9V21H18V18C18 16.0541 15.1476 14.8146 12.5708 14.2893C12.0933 14.5762 11.5639 14.7855 11 14.9Z"
      />
    </svg>
  )
}

export const IconProperty = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="IconProperty"
    >
      <path d="M8.14286 7.49219V6.00781C8.14286 5.76289 8.35982 5.5625 8.625 5.5625H10.2321C10.4973 5.5625 10.7143 5.76289 10.7143 6.00781V7.49219C10.7143 7.73711 10.4973 7.9375 10.2321 7.9375H8.625C8.35982 7.9375 8.14286 7.73711 8.14286 7.49219ZM13.7679 7.9375H15.375C15.6402 7.9375 15.8571 7.73711 15.8571 7.49219V6.00781C15.8571 5.76289 15.6402 5.5625 15.375 5.5625H13.7679C13.5027 5.5625 13.2857 5.76289 13.2857 6.00781V7.49219C13.2857 7.73711 13.5027 7.9375 13.7679 7.9375ZM8.625 11.5H10.2321C10.4973 11.5 10.7143 11.2996 10.7143 11.0547V9.57031C10.7143 9.32539 10.4973 9.125 10.2321 9.125H8.625C8.35982 9.125 8.14286 9.32539 8.14286 9.57031V11.0547C8.14286 11.2996 8.35982 11.5 8.625 11.5ZM13.7679 11.5H15.375C15.6402 11.5 15.8571 11.2996 15.8571 11.0547V9.57031C15.8571 9.32539 15.6402 9.125 15.375 9.125H13.7679C13.5027 9.125 13.2857 9.32539 13.2857 9.57031V11.0547C13.2857 11.2996 13.5027 11.5 13.7679 11.5ZM10.7143 14.6172V13.1328C10.7143 12.8879 10.4973 12.6875 10.2321 12.6875H8.625C8.35982 12.6875 8.14286 12.8879 8.14286 13.1328V14.6172C8.14286 14.8621 8.35982 15.0625 8.625 15.0625H10.2321C10.4973 15.0625 10.7143 14.8621 10.7143 14.6172ZM13.7679 15.0625H15.375C15.6402 15.0625 15.8571 14.8621 15.8571 14.6172V13.1328C15.8571 12.8879 15.6402 12.6875 15.375 12.6875H13.7679C13.5027 12.6875 13.2857 12.8879 13.2857 13.1328V14.6172C13.2857 14.8621 13.5027 15.0625 13.7679 15.0625ZM21 19.6641V21H3V19.6641C3 19.4191 3.21696 19.2187 3.48214 19.2187H4.26562V2.89062C4.26562 2.39707 4.69554 2 5.22991 2H18.7701C19.3045 2 19.7344 2.39707 19.7344 2.89062V19.2187H20.5179C20.783 19.2187 21 19.4191 21 19.6641ZM6.1942 19.1816H10.7143V16.6953C10.7143 16.4504 10.9313 16.25 11.1964 16.25H12.8036C13.0688 16.25 13.2857 16.4504 13.2857 16.6953V19.1816H17.8058V3.81836L6.21429 3.78125L6.1942 19.1816Z" />
    </svg>
  )
}

export const IconProperties = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="black"
      xmlns="http://www.w3.org/2000/svg"
      className="IconProperties"
    >
      <path d="M7.03581 9.91406V8.58594C7.03581 8.3668 7.22867 8.1875 7.46439 8.1875H8.89296C9.12867 8.1875 9.32153 8.3668 9.32153 8.58594V9.91406C9.32153 10.1332 9.12867 10.3125 8.89296 10.3125H7.46439C7.22867 10.3125 7.03581 10.1332 7.03581 9.91406ZM12.0358 10.3125H13.4644C13.7001 10.3125 13.893 10.1332 13.893 9.91406V8.58594C13.893 8.3668 13.7001 8.1875 13.4644 8.1875H12.0358C11.8001 8.1875 11.6072 8.3668 11.6072 8.58594V9.91406C11.6072 10.1332 11.8001 10.3125 12.0358 10.3125ZM7.46439 13.5H8.89296C9.12867 13.5 9.32153 13.3207 9.32153 13.1016V11.7734C9.32153 11.5543 9.12867 11.375 8.89296 11.375H7.46439C7.22867 11.375 7.03581 11.5543 7.03581 11.7734V13.1016C7.03581 13.3207 7.22867 13.5 7.46439 13.5ZM12.0358 13.5H13.4644C13.7001 13.5 13.893 13.3207 13.893 13.1016V11.7734C13.893 11.5543 13.7001 11.375 13.4644 11.375H12.0358C11.8001 11.375 11.6072 11.5543 11.6072 11.7734V13.1016C11.6072 13.3207 11.8001 13.5 12.0358 13.5ZM9.32153 16.2891V14.9609C9.32153 14.7418 9.12867 14.5625 8.89296 14.5625H7.46439C7.22867 14.5625 7.03581 14.7418 7.03581 14.9609V16.2891C7.03581 16.5082 7.22867 16.6875 7.46439 16.6875H8.89296C9.12867 16.6875 9.32153 16.5082 9.32153 16.2891ZM12.0358 16.6875H13.4644C13.7001 16.6875 13.893 16.5082 13.893 16.2891V14.9609C13.893 14.7418 13.7001 14.5625 13.4644 14.5625H12.0358C11.8001 14.5625 11.6072 14.7418 11.6072 14.9609V16.2891C11.6072 16.5082 11.8001 16.6875 12.0358 16.6875ZM18.4644 20.8047V22H2.46439V20.8047C2.46439 20.5855 2.65724 20.4062 2.89296 20.4062H3.58939V5.79688C3.58939 5.35527 3.97153 5 4.44653 5H16.4822C16.9572 5 17.3394 5.35527 17.3394 5.79688V20.4062H18.0358C18.2715 20.4062 18.4644 20.5855 18.4644 20.8047ZM5.30367 20.373H9.32153V18.1484C9.32153 17.9293 9.51439 17.75 9.7501 17.75H11.1787C11.4144 17.75 11.6072 17.9293 11.6072 18.1484V20.373H15.6251V6.62695L5.32153 6.59375L5.30367 20.373Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.5356 22V20.8047C21.5356 20.5855 21.3428 20.4062 21.107 20.4062H20.4106V2.79688C20.4106 2.35527 20.0285 2 19.5535 2H7.51776C7.04276 2 6.66061 2.35527 6.66061 2.79688V4.21273H8.39139L8.39276 3.59375L18.6963 3.62695V19.9453H18.756C18.9918 19.9453 19.1846 20.1246 19.1846 20.3438V22H21.5356Z"
      />
    </svg>
  )
}

export const IconPropertySearch = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="black"
      xmlns="http://www.w3.org/2000/svg"
      className="IconPropertySearch"
    >
      <path d="M8.57143 7.58594V8.91406C8.57143 9.1332 8.76429 9.3125 9 9.3125H10.4286C10.6643 9.3125 10.8571 9.1332 10.8571 8.91406V7.58594C10.8571 7.3668 10.6643 7.1875 10.4286 7.1875H9C8.76429 7.1875 8.57143 7.3668 8.57143 7.58594Z" />
      <path d="M15 9.3125H13.5714C13.3357 9.3125 13.1429 9.1332 13.1429 8.91406V7.58594C13.1429 7.3668 13.3357 7.1875 13.5714 7.1875H15C15.2357 7.1875 15.4286 7.3668 15.4286 7.58594V8.91406C15.4286 9.1332 15.2357 9.3125 15 9.3125Z" />
      <path d="M10.4286 12.5H9C8.76429 12.5 8.57143 12.3207 8.57143 12.1016V10.7734C8.57143 10.5543 8.76429 10.375 9 10.375H10.4286C10.6643 10.375 10.8571 10.5543 10.8571 10.7734V12.1016C10.8571 12.3207 10.6643 12.5 10.4286 12.5Z" />
      <path d="M10.8571 13.9609V15.2891C10.8571 15.5082 10.6643 15.6875 10.4286 15.6875H9C8.76429 15.6875 8.57143 15.5082 8.57143 15.2891V13.9609C8.57143 13.7418 8.76429 13.5625 9 13.5625H10.4286C10.6643 13.5625 10.8571 13.7418 10.8571 13.9609Z" />
      <path d="M18.875 10.2906V4.79688C18.875 4.35527 18.4929 4 18.0179 4H5.98214C5.50714 4 5.125 4.35527 5.125 4.79688V19.4062H4.42857C4.19286 19.4062 4 19.5855 4 19.8047V21H13.121V17.0231C13.0642 16.8649 12.903 16.75 12.7143 16.75H11.2857C11.05 16.75 10.8571 16.9293 10.8571 17.1484V19.373H6.83929L6.85714 5.59375L17.1607 5.62695V10.2906H18.875Z" />
      <path d="M21.43 18.02C21.79 17.43 22 16.74 22 16C22 13.79 20.21 12 18 12C15.79 12 14 13.79 14 16C14 18.21 15.79 20 18 20C18.74 20 19.43 19.78 20.02 19.43C20.95 20.36 21.64 21.05 22.59 22L24 20.59C22.5 19.09 23.21 19.79 21.43 18.02ZM18 18C16.9 18 16 17.1 16 16C16 14.9 16.9 14 18 14C19.1 14 20 14.9 20 16C20 17.1 19.1 18 18 18Z" />
    </svg>
  )
}

export const IconDailyOccurrences = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    className="IconDailyOccurrences"
  >
    <path d="M19 1L14 6V17L19 12.5V1M21 5V18.5C19.9 18.15 18.7 18 17.5 18C15.8 18 13.35 18.65 12 19.5V6C10.55 4.9 8.45 4.5 6.5 4.5C4.55 4.5 2.45 4.9 1 6V20.65C1 20.9 1.25 21.15 1.5 21.15C1.6 21.15 1.65 21.1 1.75 21.1C3.1 20.45 5.05 20 6.5 20C8.45 20 10.55 20.4 12 21.5C13.35 20.65 15.8 20 17.5 20C19.15 20 20.85 20.3 22.25 21.05C22.35 21.1 22.4 21.1 22.5 21.1C22.75 21.1 23 20.85 23 20.6V6C22.4 5.55 21.75 5.25 21 5M10 18.41C8.75 18.09 7.5 18 6.5 18C5.44 18 4.18 18.19 3 18.5V7.13C3.91 6.73 5.14 6.5 6.5 6.5C7.86 6.5 9.09 6.73 10 7.13V18.41Z"></path>
  </svg>
)

export const IconOccurrenceSearch = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 17 22'
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="IconOccurrenceSearch"
  >
    <path d="M0 2.75V19.25C0 19.9793 0.298511 20.6788 0.829864 21.1945C1.36122 21.7103 2.08189 22 2.83333 22H16.2917C16.4795 22 16.6597 21.9276 16.7925 21.7986C16.9254 21.6697 17 21.4948 17 21.3125C17 21.1302 16.9254 20.9553 16.7925 20.8264C16.6597 20.6974 16.4795 20.625 16.2917 20.625H2.83333C2.45761 20.625 2.09728 20.4801 1.8316 20.2223C1.56592 19.9644 1.41667 19.6147 1.41667 19.25H15.5833C15.9591 19.25 16.3194 19.1051 16.5851 18.8473C16.8507 18.5894 17 18.2397 17 17.875V2.75C17 2.02065 16.7015 1.32118 16.1701 0.805456C15.6388 0.289731 14.9181 0 14.1667 0H2.83333C2.08189 0 1.36122 0.289731 0.829864 0.805456C0.298511 1.32118 0 2.02065 0 2.75ZM14.1667 1.375C14.5424 1.375 14.9027 1.51987 15.1684 1.77773C15.4341 2.03559 15.5833 2.38533 15.5833 2.75V17.875H1.41667V2.75C1.41667 2.38533 1.56592 2.03559 1.8316 1.77773C2.09728 1.51987 2.45761 1.375 2.83333 1.375H14.1667ZM10.7468 10.8336C11.2308 10.123 11.4257 9.26321 11.2937 8.42103C11.1616 7.57885 10.7121 6.81424 10.0323 6.27546C9.35243 5.73668 8.49068 5.4621 7.6141 5.50496C6.73753 5.54781 5.90857 5.90506 5.28795 6.50742C4.66733 7.10979 4.29926 7.91437 4.25511 8.76516C4.21095 9.61596 4.49385 10.4524 5.04896 11.1122C5.60407 11.7721 6.39184 12.2083 7.25954 12.3365C8.12724 12.4646 9.01306 12.2755 9.74525 11.8058L11.5402 13.5492C11.606 13.6132 11.6842 13.6639 11.7703 13.6985C11.8563 13.7331 11.9485 13.7509 12.0417 13.7509C12.1348 13.7509 12.227 13.7331 12.3131 13.6985C12.3991 13.6639 12.4773 13.6132 12.5432 13.5492C12.609 13.4853 12.6613 13.4094 12.6969 13.3259C12.7325 13.2424 12.7509 13.1529 12.7509 13.0625C12.7509 12.9721 12.7325 12.8826 12.6969 12.7991C12.6613 12.7156 12.609 12.6397 12.5432 12.5758L10.7468 10.8336ZM5.66667 8.9375C5.66667 8.39049 5.89055 7.86589 6.28906 7.47909C6.68758 7.0923 7.22808 6.875 7.79167 6.875C8.35525 6.875 8.89575 7.0923 9.29427 7.47909C9.69278 7.86589 9.91667 8.39049 9.91667 8.9375C9.91667 9.48451 9.69278 10.0091 9.29427 10.3959C8.89575 10.7827 8.35525 11 7.79167 11C7.22808 11 6.68758 10.7827 6.28906 10.3959C5.89055 10.0091 5.66667 9.48451 5.66667 8.9375Z" />
  </svg>
)

export const IconCommand = () => (
  <svg 
  width={24}
  height={24}
  viewBox="0 0 24 24" 
  xmlns="http://www.w3.org/2000/svg" 
  className="IconCommand"
  >
    <path clip-rule="evenodd" d="M11 8.275V7.85C10.2667 7.63333 9.66667 7.22083 9.2 6.6125C8.73333 6.00417 8.5 5.3 8.5 4.5C8.5 3.53333 8.84167 2.70833 9.525 2.025C10.2083 1.34167 11.0333 1 12 1C12.9667 1 13.7917 1.34167 14.475 2.025C15.1583 2.70833 15.5 3.53333 15.5 4.5C15.5 5.3 15.2667 6.00417 14.8 6.6125C14.3333 7.22083 13.7333 7.63333 13 7.85V8.275L20 12.3C20.3167 12.4833 20.5625 12.7292 20.7375 13.0375C20.9125 13.3458 21 13.6833 21 14.05V15.95C21 16.3167 20.9125 16.6542 20.7375 16.9625C20.5625 17.2708 20.3167 17.5167 20 17.7L13 21.725C12.6833 21.9083 12.35 22 12 22C11.65 22 11.3167 21.9083 11 21.725L4 17.7C3.68333 17.5167 3.4375 17.2708 3.2625 16.9625C3.0875 16.6542 3 16.3167 3 15.95V14.05C3 13.6833 3.0875 13.3458 3.2625 13.0375C3.4375 12.7292 3.68333 12.4833 4 12.3L11 8.275ZM6.8 13L12 16L17.2 13L13 10.575V14H11V10.575L6.8 13Z" fill-rule="evenodd" data-sentry-element="path" data-sentry-source-file="DeviceIcons.tsx"></path>
  </svg>
)

export const IconSiteAssessments = () => (
  <svg
    className="IconSiteAssessments"
    style={{ height: 18 }}
    viewBox="0 0 20 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      d="M2 0H6C7.1046 0 8 0.8954 8 2V6C8 7.1046 7.1046 8 6 8H2C0.8954 8 0 7.1046 0 6V2C0 0.8954 0.8954 0 2 0ZM2 2V6H6V2H2Z"
    />
    <rect x="10" y="1" width="10" height="2" />
    <rect x="10" y="7" width="10" height="2" />
    <rect x="10" y="13" width="10" height="2" />
    <path d="M0 13L1.41 11.59L3 13.17L6.59 9.59L8 11L3 16L0 13Z" />
  </svg>
)

export const IconPropertyMobilisation = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 28 28"
    xmlns="http://www.w3.org/2000/svg"
    className="IconPropertyMobilisation"
  >
    <path d="M4.66602 21H6.99952V23.3335H4.66602V21Z" />
    <path d="M4.66602 16.3338H6.99952V18.6668H4.66602V16.3338Z" />
    <path d="M4.66602 11.6663H6.99952V13.9998H4.66602V11.6663Z" />
    <path d="M14 21H17.5V23.3335H14V21Z" />
    <path d="M19.834 21H23.334V23.3335H19.834V21Z" />
    <path d="M14 16.3338H17.5V18.6668H14V16.3338Z" />
    <path d="M19.834 16.3338H23.334V18.6668H19.834V16.3338Z" />
    <path d="M14 11.6663H17.5V13.9998H14V11.6663Z" />
    <path d="M19.834 11.6663H23.334V13.9998H19.834V11.6663Z" />
    <path d="M19.834 7H23.334V9.3335H19.834V7Z" />
    <path d="M14 7H17.5V9.3335H14V7Z" />
    <path d="M9.33376 0V6.27125L0 8.02126V28H28V3.5L9.33376 0ZM2.33375 25.6663V9.95751L9.33376 8.64501V25.6663H2.33375ZM11.6669 25.6663V2.81188L25.6669 5.43688V25.6669L11.6669 25.6663Z" />
  </svg>
)

export const IconPropertyAdd = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="black"
      xmlns="http://www.w3.org/2000/svg"
      className="IconPropertyAdd"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.875 10.7012V19.4063H19.5714C19.8071 19.4063 20 19.5856 20 19.8047V21H4V19.8047C4 19.5856 4.19286 19.4063 4.42857 19.4063H5.125V4.79688C5.125 4.35528 5.50714 4 5.98214 4H11.083C11.0284 4.32521 11 4.65929 11 5C11 5.20497 11.0103 5.40753 11.0303 5.6072L6.85714 5.59375L6.83929 19.3731H10.8571V17.1484C10.8571 16.9293 11.05 16.75 11.2857 16.75H12.7143C12.95 16.75 13.1429 16.9293 13.1429 17.1484V19.3731H17.1607V10.9979C17.758 10.9822 18.3335 10.8792 18.875 10.7012ZM14.3307 10.375C14.6788 10.5482 15.0461 10.6886 15.4286 10.7921V12.1016C15.4286 12.3207 15.2357 12.5 15 12.5H13.5714C13.3357 12.5 13.1429 12.3207 13.1429 12.1016V10.7734C13.1429 10.5543 13.3357 10.375 13.5714 10.375H14.3307ZM8.57143 7.58594V8.91407C8.57143 9.13321 8.76429 9.3125 9 9.3125H10.4286C10.6643 9.3125 10.8571 9.13321 10.8571 8.91407V7.58594C10.8571 7.3668 10.6643 7.1875 10.4286 7.1875H9C8.76429 7.1875 8.57143 7.3668 8.57143 7.58594ZM10.4286 12.5H9C8.76429 12.5 8.57143 12.3207 8.57143 12.1016V10.7734C8.57143 10.5543 8.76429 10.375 9 10.375H10.4286C10.6643 10.375 10.8571 10.5543 10.8571 10.7734V12.1016C10.8571 12.3207 10.6643 12.5 10.4286 12.5ZM10.8571 13.9609V15.2891C10.8571 15.5082 10.6643 15.6875 10.4286 15.6875H9C8.76429 15.6875 8.57143 15.5082 8.57143 15.2891V13.9609C8.57143 13.7418 8.76429 13.5625 9 13.5625H10.4286C10.6643 13.5625 10.8571 13.7418 10.8571 13.9609ZM15 15.6875H13.5714C13.3357 15.6875 13.1429 15.5082 13.1429 15.2891V13.9609C13.1429 13.7418 13.3357 13.5625 13.5714 13.5625H15C15.2357 13.5625 15.4286 13.7418 15.4286 13.9609V15.2891C15.4286 15.5082 15.2357 15.6875 15 15.6875Z"
      />
      <path d="M13.2665 4.46143H20.2665V6.0787H13.2665V4.46143Z" />
      <path d="M17.5751 1.77007V8.77007H15.9578L15.9578 1.77007L17.5751 1.77007Z" />
    </svg>
  )
}

export const IconQuestion = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconQuestion"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" />
    </svg>
  )
}

export const IconQuestionOutline = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="#000000"
      className="IconQuestionOutline"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z" />
    </svg>
  )
}

export const IconInfo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconInfo"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
    </svg>
  )
}

export const IconInfoSolid = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="#000000"
      className="IconInfo"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
    </svg>
  )
}

export const IconPropertyCircle = () => {
  return (
    <svg
      width={24}
      height={25}
      viewBox="0 0 24 25"
      fill="black"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8.42601 7.04657V8.43102C8.42601 8.65945 8.62705 8.84635 8.87276 8.84635H10.3619C10.6076 8.84635 10.8087 8.65945 10.8087 8.43102V7.04657C10.8087 6.81814 10.6076 6.63124 10.3619 6.63124H8.87276C8.62705 6.63124 8.42601 6.81814 8.42601 7.04657Z" />
      <path d="M15.1272 8.84635H13.638C13.3923 8.84635 13.1913 8.65945 13.1913 8.43102V7.04657C13.1913 6.81814 13.3923 6.63124 13.638 6.63124H15.1272C15.3729 6.63124 15.5739 6.81814 15.5739 7.04657V8.43102C15.5739 8.65945 15.3729 8.84635 15.1272 8.84635Z" />
      <path d="M8.87276 12.169H10.3619C10.6076 12.169 10.8087 11.9821 10.8087 11.7537V10.3692C10.8087 10.1408 10.6076 9.95391 10.3619 9.95391H8.87276C8.62705 9.95391 8.42601 10.1408 8.42601 10.3692V11.7537C8.42601 11.9821 8.62705 12.169 8.87276 12.169Z" />
      <path d="M15.1272 12.169H13.638C13.3923 12.169 13.1913 11.9821 13.1913 11.7537V10.3692C13.1913 10.1408 13.3923 9.95391 13.638 9.95391H15.1272C15.3729 9.95391 15.5739 10.1408 15.5739 10.3692V11.7537C15.5739 11.9821 15.3729 12.169 15.1272 12.169Z" />
      <path d="M10.8087 15.0764V13.6919C10.8087 13.4635 10.6076 13.2766 10.3619 13.2766H8.87276C8.62705 13.2766 8.42601 13.4635 8.42601 13.6919V15.0764C8.42601 15.3048 8.62705 15.4917 8.87276 15.4917H10.3619C10.6076 15.4917 10.8087 15.3048 10.8087 15.0764Z" />
      <path d="M15.1272 15.4917H13.638C13.3923 15.4917 13.1913 15.3048 13.1913 15.0764V13.6919C13.1913 13.4635 13.3923 13.2766 13.638 13.2766H15.1272C15.3729 13.2766 15.5739 13.4635 15.5739 13.6919V15.0764C15.5739 15.3048 15.3729 15.4917 15.1272 15.4917Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7382 3.30856C13.868 3.06136 12.9494 2.92905 12 2.92905C11.0506 2.92905 10.132 3.06136 9.26181 3.30856C7.55628 3.79307 6.03634 4.71888 4.83343 5.95474C3.07999 7.75622 2 10.2165 2 12.929C2 15.3819 2.8831 17.6284 4.34869 19.3681C4.84246 19.9543 5.40234 20.4828 6.01684 20.9424C7.68527 22.1901 9.75634 22.929 12 22.929C17.5228 22.929 22 18.4519 22 12.929C22 10.2165 20.92 7.75622 19.1665 5.95473C18.8002 5.57841 18.4045 5.23081 17.9832 4.91569C17.0208 4.19596 15.9244 3.64553 14.7382 3.30856ZM7.2052 19.3335H10.8087V17.0146C10.8087 16.7862 11.0097 16.5993 11.2554 16.5993H12.7446C12.9903 16.5993 13.1913 16.7862 13.1913 17.0146V19.3335H16.7948C16.9974 19.1816 17.1925 19.0203 17.3795 18.8503V7.00778C16.19 5.92644 14.6733 5.19864 12.9955 4.99038L11.0562 4.98413C9.36533 5.18286 7.83577 5.90889 6.63641 6.99332L6.62104 18.8508C6.8079 19.0207 7.00284 19.1818 7.2052 19.3335ZM4.83343 16.4883V9.36975C4.29999 10.4418 4 11.6504 4 12.929C4 14.2077 4.29999 15.4163 4.83343 16.4883ZM19.1665 9.36967V16.4884C19.7 15.4164 20 14.2078 20 12.929C20 11.6503 19.7 10.4417 19.1665 9.36967Z"
      />
    </svg>
  )
}

export const IconPropertyInfo = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="black"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.57143 7.58594V8.91406C8.57143 9.1332 8.76429 9.3125 9 9.3125H10.4286C10.6643 9.3125 10.8571 9.1332 10.8571 8.91406V7.58594C10.8571 7.3668 10.6643 7.1875 10.4286 7.1875H9C8.76429 7.1875 8.57143 7.3668 8.57143 7.58594ZM15 9.3125H13.5714C13.3357 9.3125 13.1429 9.1332 13.1429 8.91406V7.58594C13.1429 7.3668 13.3357 7.1875 13.5714 7.1875H15C15.2357 7.1875 15.4286 7.3668 15.4286 7.58594V8.91406C15.4286 9.1332 15.2357 9.3125 15 9.3125ZM10.4286 12.5H9C8.76429 12.5 8.57143 12.3207 8.57143 12.1016V10.7734C8.57143 10.5543 8.76429 10.375 9 10.375H10.4286C10.6643 10.375 10.8571 10.5543 10.8571 10.7734V12.1016C10.8571 12.3207 10.6643 12.5 10.4286 12.5ZM10.8571 13.9609V15.2891C10.8571 15.5082 10.6643 15.6875 10.4286 15.6875H9C8.76429 15.6875 8.57143 15.5082 8.57143 15.2891V13.9609C8.57143 13.7418 8.76429 13.5625 9 13.5625H10.4286C10.6643 13.5625 10.8571 13.7418 10.8571 13.9609ZM18.875 9.44603V4.79688C18.875 4.35527 18.4929 4 18.0179 4H5.98214C5.50714 4 5.125 4.35527 5.125 4.79688V19.4062H4.42857C4.19286 19.4062 4 19.5855 4 19.8047V21H13.121V17.0232C13.0642 16.8649 12.903 16.75 12.7143 16.75H11.2857C11.05 16.75 10.8571 16.9293 10.8571 17.1484V19.373H6.83929L6.85714 5.59375L17.1607 5.62695V9.44603H18.875Z"
      />
      <path d="M20.5805 22.8044H15.6919V22.2397C15.826 22.2294 15.9575 22.2165 16.0864 22.2011C16.2153 22.1856 16.3262 22.1598 16.419 22.1237C16.584 22.0618 16.7001 21.9742 16.7671 21.8607C16.8341 21.7421 16.8677 21.5874 16.8677 21.3966V16.8947C16.8677 16.7143 16.8264 16.557 16.7439 16.4229C16.6614 16.2837 16.5583 16.1728 16.4345 16.0903C16.3417 16.0284 16.1999 15.9691 16.0091 15.9124C15.8234 15.8557 15.6532 15.8196 15.4985 15.8041V15.2394L19.2888 15.0383L19.4048 15.1543V21.296C19.4048 21.4765 19.4435 21.6312 19.5208 21.7601C19.5982 21.8839 19.709 21.9767 19.8534 22.0386C19.9566 22.085 20.07 22.1263 20.1938 22.1624C20.3175 22.1985 20.4465 22.2243 20.5805 22.2397V22.8044ZM19.4512 12.2537C19.4512 12.6456 19.2991 12.9808 18.9948 13.2592C18.6957 13.5325 18.3399 13.6692 17.9274 13.6692C17.5097 13.6692 17.1487 13.5325 16.8445 13.2592C16.5454 12.9808 16.3958 12.6456 16.3958 12.2537C16.3958 11.8617 16.5454 11.5265 16.8445 11.2481C17.1487 10.9696 17.5097 10.8304 17.9274 10.8304C18.3451 10.8304 18.7035 10.9696 19.0026 11.2481C19.3016 11.5265 19.4512 11.8617 19.4512 12.2537Z" />
    </svg>
  )
}

export const IconEventNote = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconEventNote"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M17 10H7v2h10v-2zm2-7h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zm-5-5H7v2h7v-2z" />
    </svg>
  )
}

export const IconRotate = () => {
  return (
    <svg
      width={19}
      height={19}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="IconRotate"
    >
      <path d="M19 1.58333V7.125C19 7.33941 18.9217 7.52496 18.765 7.68164C18.6083 7.83832 18.4227 7.91667 18.2083 7.91667H12.6667C12.3203 7.91667 12.077 7.75174 11.9368 7.42188C11.7967 7.10026 11.8544 6.81576 12.11 6.56836L13.8171 4.86133C12.5966 3.73155 11.1576 3.16667 9.5 3.16667C8.64236 3.16667 7.82389 3.33366 7.0446 3.66764C6.2653 4.00163 5.59115 4.45312 5.02214 5.02214C4.45312 5.59115 4.00163 6.2653 3.66764 7.0446C3.33366 7.82389 3.16667 8.64236 3.16667 9.5C3.16667 10.3576 3.33366 11.1761 3.66764 11.9554C4.00163 12.7347 4.45312 13.4089 5.02214 13.9779C5.59115 14.5469 6.2653 14.9984 7.0446 15.3324C7.82389 15.6663 8.64236 15.8333 9.5 15.8333C10.4813 15.8333 11.4091 15.6189 12.2832 15.1901C13.1573 14.7613 13.8954 14.1552 14.4974 13.3717C14.5551 13.2893 14.65 13.2398 14.7819 13.2233C14.8974 13.2233 15.0004 13.2604 15.0911 13.3346L16.7858 15.0417C16.86 15.1076 16.8992 15.1922 16.9033 15.2952C16.9074 15.3983 16.8765 15.4911 16.8105 15.5736C15.9117 16.6621 14.8231 17.5053 13.5449 18.1032C12.2667 18.7011 10.9184 19 9.5 19C8.21354 19 6.98481 18.7485 5.8138 18.2454C4.6428 17.7424 3.6326 17.0662 2.7832 16.2168C1.93381 15.3674 1.2576 14.3572 0.754557 13.1862C0.251519 12.0152 0 10.7865 0 9.5C0 8.21354 0.251519 6.98481 0.754557 5.8138C1.2576 4.6428 1.93381 3.6326 2.7832 2.7832C3.6326 1.93381 4.6428 1.2576 5.8138 0.754557C6.98481 0.251519 8.21354 0 9.5 0C10.7122 0 11.8853 0.228841 13.0192 0.686523C14.1531 1.14421 15.1612 1.7895 16.0436 2.6224L17.6517 1.02669C17.8908 0.77105 18.1795 0.713325 18.5176 0.853516C18.8392 0.993707 19 1.23698 19 1.58333Z" />
    </svg>
  )
}

export const IconRotateFlipped = () => {
  return (
    <svg
      width={19}
      height={19}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="IconRotateFlipped"
    >
      <path d="M0 1.58333V7.125C0 7.33941 0.0783405 7.52496 0.235025 7.68164C0.39171 7.83832 0.577257 7.91667 0.791666 7.91667H6.33333C6.67969 7.91667 6.92296 7.75174 7.06315 7.42188C7.20334 7.10026 7.14562 6.81576 6.88997 6.56836L5.18294 4.86133C6.40343 3.73155 7.84245 3.16667 9.5 3.16667C10.3576 3.16667 11.1761 3.33366 11.9554 3.66764C12.7347 4.00163 13.4089 4.45312 13.9779 5.02214C14.5469 5.59115 14.9984 6.2653 15.3324 7.0446C15.6663 7.82389 15.8333 8.64236 15.8333 9.5C15.8333 10.3576 15.6663 11.1761 15.3324 11.9554C14.9984 12.7347 14.5469 13.4089 13.9779 13.9779C13.4089 14.5469 12.7347 14.9984 11.9554 15.3324C11.1761 15.6663 10.3576 15.8333 9.5 15.8333C8.51866 15.8333 7.59093 15.6189 6.7168 15.1901C5.84266 14.7613 5.1046 14.1552 4.5026 13.3717C4.44488 13.2893 4.35004 13.2398 4.2181 13.2233C4.10265 13.2233 3.99957 13.2604 3.90885 13.3346L2.21419 15.0417C2.13997 15.1076 2.1008 15.1922 2.09668 15.2952C2.09256 15.3983 2.12348 15.4911 2.18945 15.5736C3.08832 16.6621 4.17687 17.5053 5.45508 18.1032C6.73329 18.7011 8.0816 19 9.5 19C10.7865 19 12.0152 18.7485 13.1862 18.2454C14.3572 17.7424 15.3674 17.0662 16.2168 16.2168C17.0662 15.3674 17.7424 14.3572 18.2454 13.1862C18.7485 12.0152 19 10.7865 19 9.5C19 8.21354 18.7485 6.98481 18.2454 5.8138C17.7424 4.6428 17.0662 3.6326 16.2168 2.7832C15.3674 1.93381 14.3572 1.2576 13.1862 0.754557C12.0152 0.251519 10.7865 0 9.5 0C8.28776 0 7.11469 0.228841 5.98079 0.686523C4.8469 1.14421 3.83876 1.7895 2.95638 2.6224L1.34831 1.02669C1.10916 0.77105 0.82053 0.713325 0.482422 0.853516C0.160807 0.993707 0 1.23698 0 1.58333Z" />
    </svg>
  )
}

export const IconMenu = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 26"
      className="IconMenu"
    >
      <path fill="none" d="M0 0h24v24H0V0z" />
      <path d="M4 18h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm0-5h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zM3 7c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1z" />
    </svg>
  )
}

export const IconNight = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9.37 5.51C9.19 6.15 9.1 6.82 9.1 7.5C9.1 11.58 12.42 14.9 16.5 14.9C17.18 14.9 17.85 14.81 18.49 14.63C17.45 17.19 14.93 19 12 19C8.14 19 5 15.86 5 12C5 9.07 6.81 6.55 9.37 5.51ZM12 3C7.03 3 3 7.03 3 12C3 16.97 7.03 21 12 21C16.97 21 21 16.97 21 12C21 11.54 20.96 11.08 20.9 10.64C19.92 12.01 18.32 12.9 16.5 12.9C13.52 12.9 11.1 10.48 11.1 7.5C11.1 5.69 11.99 4.08 13.36 3.1C12.92 3.04 12.46 3 12 3Z" />
    </svg>
  )
}

export const IconDay = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconDay"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M6.76 4.84l-1.8-1.79-1.41 1.41 1.79 1.79zM1 10.5h3v2H1zM11 .55h2V3.5h-2zm8.04 2.495l1.408 1.407-1.79 1.79-1.407-1.408zm-1.8 15.115l1.79 1.8 1.41-1.41-1.8-1.79zM20 10.5h3v2h-3zm-8-5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm-1 4h2v2.95h-2zm-7.45-.96l1.41 1.41 1.79-1.8-1.41-1.41z" />
    </svg>
  )
}

export const IconDayNight = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="black"
      xmlns="http://www.w3.org/2000/svg"
      className="IconDayNight"
    >
      <path
        d="M10.9999 20L10.9999 22C10.9999 22.55 11.4499 23 11.9999 23C12.5499 23 12.9999 22.55 12.9999 22L12.9999 20C12.9999 19.45 12.5499 19 11.9999 19C11.4499 19 10.9999 19.45 10.9999 20ZM3.9999 11L1.9999 11C1.4499 11 0.999903 11.45 0.999903 12C0.999903 12.55 1.4499 13 1.9999 13L3.9999 13C4.5499 13 4.9999 12.55 4.9999 12C4.9999 11.45 4.5499 11 3.9999 11ZM7.0499 18.36C7.4399 17.97 7.4399 17.33 7.0499 16.95C6.6599 16.56 6.0199 16.56 5.6399 16.95L4.5799 18.01C4.1899 18.4 4.1899 19.04 4.5799 19.42C4.9699 19.81 5.6099 19.81 5.9899 19.42L7.0499 18.36ZM18.0099 19.42C18.3999 19.81 19.0399 19.81 19.4199 19.42C19.8099 19.03 19.8099 18.39 19.4199 18.01L18.3599 16.95C17.9699 16.56 17.3299 16.56 16.9499 16.95C16.5699 17.34 16.5599 17.98 16.9499 18.36L18.0099 19.42Z"
        fill="#C7BA4B"
        className="IconDayNight__sun"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0169 11.9999C17.0169 14.7706 14.7709 17.0167 12.0002 17.0167C9.22948 17.0167 6.9834 14.7706 6.9834 11.9999C6.9834 9.7739 8.43319 7.88651 10.44 7.23047C10.6323 8.95951 12.0986 10.304 13.8789 10.304C14.8026 10.304 15.6417 9.94213 16.2623 9.35237C16.7406 10.1208 17.0169 11.0281 17.0169 11.9999Z"
      />
      <path
        d="M17.0169 12.0002C17.0169 13.3307 16.4884 14.6067 15.5476 15.5476C14.6067 16.4884 13.3307 17.0169 12.0002 17.0169C10.6696 17.0169 9.3936 16.4884 8.45278 15.5476C7.51195 14.6067 6.9834 13.3307 6.9834 12.0002L12.0002 12.0002L17.0169 12.0002Z"
        fill="#C7BA4B"
        className="IconDayNight__sun"
      />
      <path d="M21.4715 6.62737L19.3524 6.42502L18.5051 8.37791L18.0427 6.29997L15.9235 6.09762L17.7569 5.01573L17.2945 2.93779L18.89 4.34708L20.7233 3.26519L19.876 5.21807L21.4715 6.62737Z" />
      <path d="M12.0001 0L12.6578 2.0241L14.786 2.0241L13.0642 3.27507L13.7219 5.29917L12.0001 4.04821L10.2783 5.29917L10.936 3.27507L9.21417 2.0241L11.3424 2.0241L12.0001 0Z" />
    </svg>
  )
}

export const IconCrossNice = () => {
  return (
    <svg
      width={25}
      height={24}
      viewBox="0 0 25 24"
      fill="black"
      xmlns="http://www.w3.org/2000/svg"
      className="IconCross"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.93952 3.43934C4.52531 2.85355 5.47506 2.85355 6.06084 3.43934L12.5002 9.87868L18.9395 3.43934C19.5253 2.85355 20.4751 2.85355 21.0608 3.43934C21.6466 4.02513 21.6466 4.97487 21.0608 5.56066L14.6215 12L21.0608 18.4393C21.6466 19.0251 21.6466 19.9749 21.0608 20.5607C20.4751 21.1464 19.5253 21.1464 18.9395 20.5607L12.5002 14.1213L6.06084 20.5607C5.47506 21.1464 4.52531 21.1464 3.93952 20.5607C3.35374 19.9749 3.35374 19.0251 3.93952 18.4393L10.3789 12L3.93952 5.56066C3.35374 4.97487 3.35374 4.02513 3.93952 3.43934Z"
      />
    </svg>
  )
}

export const IconCross = () => {
  return (
    <svg
      className="IconCross"
      width={10}
      height={10}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 0L0 1.50001L3.5 5L0 8.49999L1.5 10L5 6.49999L8.5 10L10 8.49999L6.5 5L10 1.50001L8.5 0L5 3.50001L1.5 0Z"
      />
    </svg>
  )
}

export const IconClose = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      className="IconClose"
      fill="#999"
    >
      <path fill="none" d="M0 0h24v24H0V0z" />
      <path d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z" />
    </svg>
  )
}

export const IconDownload = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className="icon-component IconDownload"
    >
      <path fill="none" d="M0 0h24v24H0V0z" />
      <path d="M16.59 9H15V4c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v5H7.41c-.89 0-1.34 1.08-.71 1.71l4.59 4.59c.39.39 1.02.39 1.41 0l4.59-4.59c.63-.63.19-1.71-.7-1.71zM5 19c0 .55.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1z" />
    </svg>
  )
}

export const IconUploadFile = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="#000000"
      className="IconUploadFile"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11zM8 15.01l1.41 1.41L11 14.84V19h2v-4.16l1.59 1.59L16 15.01 12.01 11z" />
    </svg>
  )
}

export const IconCancel = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className="icon-component IconCancel"
    >
      <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" />
      <path d="M0 0h24v24H0z" fill="none" />
    </svg>
  )
}

export const IconEdit = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 22"
      className="icon-component IconEdit"
    >
      <path fill="none" d="M0 0h20v20H0V0z" />
      <path d="M15.95 10.78c.03-.25.05-.51.05-.78s-.02-.53-.06-.78l1.69-1.32c.15-.12.19-.34.1-.51l-1.6-2.77c-.1-.18-.31-.24-.49-.18l-1.99.8c-.42-.32-.86-.58-1.35-.78L12 2.34c-.03-.2-.2-.34-.4-.34H8.4c-.2 0-.36.14-.39.34l-.3 2.12c-.49.2-.94.47-1.35.78l-1.99-.8c-.18-.07-.39 0-.49.18l-1.6 2.77c-.1.18-.06.39.1.51l1.69 1.32c-.04.25-.07.52-.07.78s.02.53.06.78L2.37 12.1c-.15.12-.19.34-.1.51l1.6 2.77c.1.18.31.24.49.18l1.99-.8c.42.32.86.58 1.35.78l.3 2.12c.04.2.2.34.4.34h3.2c.2 0 .37-.14.39-.34l.3-2.12c.49-.2.94-.47 1.35-.78l1.99.8c.18.07.39 0 .49-.18l1.6-2.77c.1-.18.06-.39-.1-.51l-1.67-1.32zM10 13c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z" />
    </svg>
  )
}

export const IconArrowUp = (props: IconProps) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="black"
      xmlns="http://www.w3.org/2000/svg"
      className="IconArrowUp"
      style={{ transform: "rotate(180deg)" }}
      {...props}
    >
      <path d="M13.8873 18.2602C13.3968 18.7506 12.6016 18.7505 12.1113 18.26L3.36826 9.51464C2.87793 9.02417 2.87803 8.22897 3.3685 7.73864C3.85897 7.24831 4.65407 7.24841 5.1445 7.73888L12.9996 15.5962L20.8569 7.74099C21.3474 7.25065 22.1425 7.25076 22.6329 7.74123C23.1232 8.23169 23.1231 9.02689 22.6327 9.51723L13.8873 18.2602Z" />
    </svg>
  )
}

export const IconCalendarOld = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1.1"
      id="Capa_1"
      x="0px"
      y="0px"
      width={24}
      height={24}
      viewBox="0 0 511.634 511.634"
      xmlSpace="preserve"
      className="IconCalendarOld"
    >
      <g>
        <path
          d="M482.513,83.942c-7.225-7.233-15.797-10.85-25.694-10.85h-36.541v-27.41c0-12.56-4.477-23.315-13.422-32.261   C397.906,4.475,387.157,0,374.591,0h-18.268c-12.565,0-23.318,4.475-32.264,13.422c-8.949,8.945-13.422,19.701-13.422,32.261v27.41   h-109.63v-27.41c0-12.56-4.475-23.315-13.422-32.261C178.64,4.475,167.886,0,155.321,0H137.05   c-12.562,0-23.317,4.475-32.264,13.422c-8.945,8.945-13.421,19.701-13.421,32.261v27.41H54.823c-9.9,0-18.464,3.617-25.697,10.85   c-7.233,7.232-10.85,15.8-10.85,25.697v365.453c0,9.89,3.617,18.456,10.85,25.693c7.232,7.231,15.796,10.849,25.697,10.849h401.989   c9.897,0,18.47-3.617,25.694-10.849c7.234-7.234,10.852-15.804,10.852-25.693V109.639   C493.357,99.739,489.743,91.175,482.513,83.942z M137.047,475.088H54.823v-82.23h82.224V475.088z M137.047,374.59H54.823v-91.358   h82.224V374.59z M137.047,264.951H54.823v-82.223h82.224V264.951z M130.627,134.333c-1.809-1.809-2.712-3.946-2.712-6.423V45.686   c0-2.474,0.903-4.617,2.712-6.423c1.809-1.809,3.946-2.712,6.423-2.712h18.271c2.474,0,4.617,0.903,6.423,2.712   c1.809,1.807,2.714,3.949,2.714,6.423v82.224c0,2.478-0.909,4.615-2.714,6.423c-1.807,1.809-3.946,2.712-6.423,2.712H137.05   C134.576,137.046,132.436,136.142,130.627,134.333z M246.683,475.088h-91.365v-82.23h91.365V475.088z M246.683,374.59h-91.365   v-91.358h91.365V374.59z M246.683,264.951h-91.365v-82.223h91.365V264.951z M356.323,475.088h-91.364v-82.23h91.364V475.088z    M356.323,374.59h-91.364v-91.358h91.364V374.59z M356.323,264.951h-91.364v-82.223h91.364V264.951z M349.896,134.333   c-1.807-1.809-2.707-3.946-2.707-6.423V45.686c0-2.474,0.9-4.617,2.707-6.423c1.808-1.809,3.949-2.712,6.427-2.712h18.268   c2.478,0,4.617,0.903,6.427,2.712c1.808,1.807,2.707,3.949,2.707,6.423v82.224c0,2.478-0.903,4.615-2.707,6.423   c-1.807,1.809-3.949,2.712-6.427,2.712h-18.268C353.846,137.046,351.697,136.142,349.896,134.333z M456.812,475.088h-82.228v-82.23   h82.228V475.088z M456.812,374.59h-82.228v-91.358h82.228V374.59z M456.812,264.951h-82.228v-82.223h82.228V264.951z"
          fill="#a1a1a1"
        />
      </g>
    </svg>
  )
}

export const IconCalendar = () => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="far"
      data-icon="calendar-alt"
      className="IconCalendar"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
      width={24}
      height={24}
    >
      <path d="M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z" />
    </svg>
  )
}

export const IconDate = () => {
  return (
    <svg
      width={25}
      height={25}
      viewBox="0 0 25 25"
      fill="#666666"
      xmlns="http://www.w3.org/2000/svg"
      className="IconDate"
    >
      <path d="M19.0732 3.32812H18.0732V1.32812H16.0732V3.32812H8.07324V1.32812H6.07324V3.32812H5.07324C3.96324 3.32812 3.07324 4.22813 3.07324 5.32812V19.3281C3.07324 20.4281 3.96324 21.3281 5.07324 21.3281H19.0732C20.1732 21.3281 21.0732 20.4281 21.0732 19.3281V5.32812C21.0732 4.22813 20.1732 3.32812 19.0732 3.32812ZM19.0732 19.3281H5.07324V9.32812H19.0732V19.3281ZM19.0732 7.32812H5.07324V5.32812H19.0732V7.32812ZM7.07324 11.3281H12.0732V16.3281H7.07324V11.3281Z" />
    </svg>
  )
}

export const IconArrowDown = (props: IconProps) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="black"
      xmlns="http://www.w3.org/2000/svg"
      className="IconArrowDown"
      {...props}
    >
      <path d="M13.8873 18.2602C13.3968 18.7506 12.6016 18.7505 12.1113 18.26L3.36826 9.51464C2.87793 9.02417 2.87803 8.22897 3.3685 7.73864C3.85897 7.24831 4.65407 7.24841 5.1445 7.73888L12.9996 15.5962L20.8569 7.74099C21.3474 7.25065 22.1425 7.25076 22.6329 7.74123C23.1232 8.23169 23.1231 9.02689 22.6327 9.51723L13.8873 18.2602Z" />
    </svg>
  )
}

export const IconDelete = (props: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="icon-component IconDelete"
      width={24}
      height={24}
      viewBox="0 0 24 24"
    >
      <path
        fill={props.fillColor}
        d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
      />
      <path d="M0 0h24v24H0z" fill="none" />
    </svg>
  )
}

export const IconAddPerson = (props: IconProps) => {
  return (
    <svg
      className="icon-component IconAddPerson"
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
    >
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        fill={props.fillColor}
        d="M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
      />
    </svg>
  )
}

export const IconSearch = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
    </svg>
  )
}

export const IconLocation = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="#000000"
      className="IconLocation"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
    </svg>
  )
}

export const IconCreditCard = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="#000000"
      className="IconCreditCard"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z" />
    </svg>
  )
}

export const IconMap = () => {
  return <img className="IconMap" src={MapLocationIcon} alt="IconMap" />
}

export const IconChart = () => {
  return <img className="IconChart" src={ChartSliderIcon} alt="IconChart" />
}

export const IconStar = () => {
  return <img className="IconStar" src={FavouriteIcon} alt="IconStar" />
}

export const IconRemoteCircle = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="black"
      xmlns="http://www.w3.org/2000/svg"
      className="IconRemoteCircle"
    >
      <path d="M13.005 18.2146C13.005 18.7669 12.5573 19.2146 12.005 19.2146C11.4527 19.2146 11.005 18.7669 11.005 18.2146C11.005 17.6623 11.4527 17.2146 12.005 17.2146C12.5573 17.2146 13.005 17.6623 13.005 18.2146Z" />
      <path d="M7.894 11.4986L9.06477 12.6694C9.82037 11.9221 10.8583 11.4571 12.0041 11.4571C13.15 11.4571 14.1879 11.9221 14.9435 12.6694L16.1143 11.4986C15.0598 10.4441 13.6067 9.79646 12.0041 9.79646C10.4016 9.79646 8.94852 10.4441 7.894 11.4986Z" />
      <path d="M12.0041 6.47513C9.47994 6.47513 7.19652 7.49644 5.54416 9.1488L6.71493 10.3196C8.06837 8.97443 9.93662 8.13579 12.0041 8.13579C14.0717 8.13579 15.9399 8.97443 17.2851 10.3279L18.4558 9.1571C16.8118 7.49644 14.5284 6.47513 12.0041 6.47513Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM13.6648 19.8265C13.1278 19.9402 12.5709 20 12 20C11.4321 20 10.8779 19.9408 10.3435 19.8283V15.6088H13.6648V19.8265ZM15.3255 19.2782V14.7785C15.3255 14.3218 14.9518 13.9481 14.4951 13.9481H9.51315C9.05647 13.9481 8.68282 14.3218 8.68282 14.7785V19.282C5.92011 18.0215 4 15.235 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 15.2317 18.0837 18.0159 15.3255 19.2782Z"
      />
    </svg>
  )
}

export const IconRemoteInfo = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="black"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5301 7.96L7.1201 6.55C8.3901 5.28 10.1401 4.5 12.0701 4.5C14.0001 4.5 15.7501 5.28 17.0201 6.55L15.6101 7.96C14.7001 7.06 13.4501 6.5 12.0701 6.5C10.6901 6.5 9.4401 7.06 8.5301 7.96ZM4.2901 3.72C6.2801 1.73 9.0301 0.5 12.0701 0.5C15.1101 0.5 17.8601 1.73 19.8401 3.73L18.4301 5.14C16.8101 3.51 14.5601 2.5 12.0701 2.5C9.5801 2.5 7.3301 3.51 5.7001 5.13L4.2901 3.72ZM8.0701 10.5C8.0701 9.95 8.5201 9.5 9.0701 9.5H15.0701C15.6201 9.5 16.0701 9.95 16.0701 10.5V12H14.0701V11.5H10.0701V21.5H12V23.5H9.0701C8.5201 23.5 8.0701 23.05 8.0701 22.5V10.5Z"
      />
      <path d="M18.0463 23.5H14.0346V23.0366C14.1446 23.0282 14.2525 23.0176 14.3583 23.0049C14.4641 22.9922 14.5551 22.971 14.6313 22.9414C14.7667 22.8906 14.8619 22.8187 14.9169 22.7256C14.9719 22.6283 14.9995 22.5013 14.9995 22.3447V18.6504C14.9995 18.5023 14.9656 18.3732 14.8979 18.2632C14.8302 18.1489 14.7455 18.0579 14.644 17.9902C14.5678 17.9395 14.4514 17.8908 14.2949 17.8442C14.1425 17.7977 14.0029 17.7681 13.8759 17.7554V17.292L16.9863 17.127L17.0815 17.2222V22.2622C17.0815 22.4103 17.1132 22.5373 17.1767 22.6431C17.2402 22.7446 17.3312 22.8208 17.4496 22.8716C17.5343 22.9097 17.6274 22.9435 17.7289 22.9731C17.8305 23.0028 17.9363 23.0239 18.0463 23.0366V23.5ZM17.1196 14.8418C17.1196 15.1634 16.9947 15.4385 16.7451 15.667C16.4996 15.8913 16.2076 16.0034 15.8691 16.0034C15.5263 16.0034 15.2301 15.8913 14.9804 15.667C14.735 15.4385 14.6122 15.1634 14.6122 14.8418C14.6122 14.5202 14.735 14.2451 14.9804 14.0166C15.2301 13.7881 15.5263 13.6738 15.8691 13.6738C16.2119 13.6738 16.506 13.7881 16.7514 14.0166C16.9968 14.2451 17.1196 14.5202 17.1196 14.8418Z" />
    </svg>
  )
}

export const IconRemote = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconRemote"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M15 9H9c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1zm-3 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM7.05 6.05l1.41 1.41C9.37 6.56 10.62 6 12 6s2.63.56 3.54 1.46l1.41-1.41C15.68 4.78 13.93 4 12 4s-3.68.78-4.95 2.05zM12 0C8.96 0 6.21 1.23 4.22 3.22l1.41 1.41C7.26 3.01 9.51 2 12 2s4.74 1.01 6.36 2.64l1.41-1.41C17.79 1.23 15.04 0 12 0z" />
    </svg>
  )
}

export const IconRemoteOutline = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconRemoteOutline"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M15 9H9c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1zm-1 12h-4V11h4v10z" />
      <circle cx={12} cy={13} r={1} />
      <path d="M7.05 6.05l1.41 1.41C9.37 6.56 10.62 6 12 6s2.63.56 3.54 1.46l1.41-1.41C15.68 4.78 13.93 4 12 4s-3.68.78-4.95 2.05zM12 0C8.96 0 6.21 1.23 4.22 3.22l1.41 1.41C7.26 3.01 9.51 2 12 2s4.74 1.01 6.36 2.64l1.41-1.41C17.79 1.23 15.04 0 12 0z" />
    </svg>
  )
}

export const IconSmartlock = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="IconSmartlock"
    >
      <g clipPath="url(#clip0)">
        <path d="M15.9314 13.0757H15.2762V11.7652C15.2762 9.95683 13.8085 8.48914 12.0001 8.48914C10.1917 8.48914 8.72397 9.95683 8.72397 11.7652V13.0757H8.06875C7.348 13.0757 6.7583 13.6654 6.7583 14.3861V20.9384C6.7583 21.6591 7.348 22.2488 8.06875 22.2488H15.9314C16.6522 22.2488 17.2419 21.6591 17.2419 20.9384V14.3861C17.2419 13.6654 16.6522 13.0757 15.9314 13.0757ZM10.0344 11.7652C10.0344 10.6776 10.9124 9.79958 12.0001 9.79958C13.0877 9.79958 13.9657 10.6776 13.9657 11.7652V13.0757H10.0344V11.7652ZM15.9314 20.9384H8.06875V14.3861H15.9314V20.9384ZM12.0001 18.9727C12.7208 18.9727 13.3105 18.383 13.3105 17.6623C13.3105 16.9415 12.7208 16.3518 12.0001 16.3518C11.2793 16.3518 10.6896 16.9415 10.6896 17.6623C10.6896 18.383 11.2793 18.9727 12.0001 18.9727Z" />
        <path d="M5.66221 8.05584C5.39672 7.79035 5.39522 7.35788 5.67875 7.11175C6.4614 6.43235 7.34962 5.88257 8.30985 5.48483C9.47977 5.00023 10.7337 4.75081 12 4.75081C13.2663 4.75081 14.5202 5.00023 15.6901 5.48483C16.6504 5.88257 17.5386 6.43235 18.3212 7.11175C18.6048 7.35788 18.6033 7.79035 18.3378 8.05584V8.05584C18.0723 8.32133 17.6435 8.31892 17.3572 8.07609C16.7028 7.52117 15.9651 7.07038 15.1698 6.74099C14.1649 6.32472 13.0878 6.11047 12 6.11047C10.9122 6.11047 9.83513 6.32472 8.83017 6.74099C8.03494 7.07038 7.29721 7.52117 6.64281 8.07609C6.35645 8.31892 5.9277 8.32133 5.66221 8.05584V8.05584Z" />
        <path d="M3.20185 6.08321C2.94452 5.82587 2.94343 5.40729 3.21338 5.16322C4.32405 4.159 5.59994 3.35149 6.98631 2.77723C8.57584 2.11883 10.2795 1.77995 12 1.77995C13.7205 1.77995 15.4242 2.11883 17.0137 2.77723C18.4001 3.35149 19.6759 4.159 20.7866 5.16322C21.0566 5.40729 21.0555 5.82587 20.7981 6.08321V6.08321C20.5408 6.34054 20.1248 6.33902 19.8535 6.09647C18.8661 5.21381 17.7358 4.50282 16.5094 3.99481C15.0797 3.40263 13.5474 3.09784 12 3.09784C10.4526 3.09784 8.92029 3.40263 7.49065 3.99481C6.26419 4.50282 5.13388 5.21381 4.14654 6.09647C3.87522 6.33902 3.45919 6.34054 3.20185 6.08321V6.08321Z" />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width={24} height={24} fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconEyeCrossed = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconEyeCrossed"
    >
      <path
        d="M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0z"
        fill="none"
      />
      <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" />
    </svg>
  )
}

export const IconEye = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconEye"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
    </svg>
  )
}

export const ValidationCrossOutline = () => {
  return (
    <svg
      width={36}
      height={36}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35 18C35 27.3888 27.3888 35 18 35C8.61116 35 1 27.3888 1 18C1 8.61116 8.61116 1 18 1C27.3888 1 35 8.61116 35 18Z"
        stroke="#D95D5D"
        strokeWidth={2}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5403 17.9545L9 10.4142L10.4142 9L17.9545 16.5403L25.4949 9.00002L26.9091 10.4142L19.3688 17.9545L26.7827 25.3685L25.3685 26.7827L17.9545 19.3688L10.5405 26.7828L9.12634 25.3685L16.5403 17.9545Z"
        fill="#D95D5D"
      />
    </svg>
  )
}

export const ValidationCross = () => {
  return (
    <svg
      width={36}
      height={36}
      viewBox="0 0 36 36"
      className="IconValidationCross"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35 18C35 27.3888 27.3888 35 18 35C8.61116 35 1 27.3888 1 18C1 8.61116 8.61116 1 18 1C27.3888 1 35 8.61116 35 18Z"
        fill="#D95D5D"
        stroke="#D95D5D"
        strokeWidth={2}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5403 17.9545L9 10.4142L10.4142 9L17.9545 16.5403L25.4949 9.00002L26.9091 10.4142L19.3688 17.9545L26.7827 25.3685L25.3685 26.7827L17.9545 19.3688L10.5405 26.7828L9.12634 25.3685L16.5403 17.9545Z"
        fill="white"
      />
    </svg>
  )
}

export const ValidationWarning = () => (
  <svg
    className={"IconValidationWarning"}
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.9154 0C8.037 0 0 8.0748 0 18C0 27.9252 8.0748 36 18 36C27.9252 36 36 27.9252 36 18C36 8.0748 27.8874 0 17.9154 0ZM19.8 27H16.2V23.4H19.8V27ZM19.8 19.8H16.2V9H19.8V19.8Z"
      fill="#EB5757"
    />
  </svg>
)

export const ValidationCheckmark = () => {
  return (
    <svg
      width={36}
      height={36}
      viewBox="0 0 36 36"
      className="IconValidationCheckmark"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 35C27.3888 35 35 27.3888 35 18C35 8.61116 27.3888 1 18 1C8.61116 1 1 8.61116 1 18C1 27.3888 8.61116 35 18 35Z"
        stroke="#28A745"
        strokeWidth={2}
      />
      <path
        d="M9.93896 20.5804L15.332 26.0179L25.1219 11.7064"
        stroke="#28A745"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const IconCheckmark = () => {
  return (
    <svg
      width={21}
      height={23}
      viewBox="0 0 21 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="IconCheckmark"
    >
      <path d="M4.56396 23C4.56396 22.7411 4.51582 22.6117 4.41953 22.6117L3.75516 22.9403C3.75516 22.8009 3.67813 22.7013 3.52407 22.6416L3.29298 22.6117C3.13893 22.6117 2.94635 22.6814 2.71527 22.8208C2.67675 22.7212 2.62861 22.6216 2.57084 22.5221C2.51307 22.4225 2.46492 22.3329 2.42641 22.2532C2.17607 21.7554 1.92572 21.2078 1.67538 20.6104C1.44429 19.9931 1.22283 19.4056 1.011 18.8481C0.818432 18.2905 0.664374 17.8524 0.548831 17.5338C0.471802 17.2749 0.385144 16.8866 0.288858 16.3688C0.192572 15.8511 0.0962861 15.1939 0 14.3974C0.211829 14.5368 0.375516 14.6065 0.491059 14.6065C0.62586 14.6065 0.751032 14.3974 0.866575 13.9792C0.924347 14.0589 1.03026 14.0987 1.18432 14.0987C1.29986 14.0987 1.38652 14.0589 1.44429 13.9792L1.90646 13.2623L2.42641 13.4416H2.4553C2.49381 13.4416 2.53232 13.4216 2.57084 13.3818C2.60935 13.342 2.66713 13.3022 2.74415 13.2623C2.89821 13.1628 3.01376 13.113 3.09078 13.113L3.17744 13.1429C3.65887 13.3818 3.96699 13.8199 4.10179 14.4571C4.44842 15.9706 4.79505 16.7273 5.14168 16.7273C5.48831 16.7273 5.89271 16.3489 6.35488 15.5922C6.58597 15.2139 6.81706 14.7758 7.04814 14.2779C7.29849 13.7801 7.54883 13.2225 7.79917 12.6052C7.83769 12.8442 7.8762 12.9636 7.91472 12.9636C8.011 12.9636 8.17469 12.7147 8.40578 12.2169C8.65612 11.719 9.05089 11.032 9.5901 10.1558C9.89821 9.61818 10.2834 9.01082 10.7455 8.33377C11.227 7.65671 11.7373 6.95974 12.2765 6.24286C12.8157 5.52597 13.3356 4.84892 13.8363 4.21169C14.3563 3.57446 14.8184 3.02684 15.2228 2.56883C15.6272 2.11082 15.9257 1.81212 16.1183 1.67273C16.8501 1.15498 17.4278 0.657142 17.8514 0.17922C17.8322 0.318614 17.8033 0.448051 17.7648 0.567532C17.7455 0.667099 17.7359 0.736796 17.7359 0.776622C17.7359 0.856276 17.7744 0.896103 17.8514 0.896103L18.6602 0.477921V0.597402C18.6602 0.75671 18.6988 0.836364 18.7758 0.836364C18.8336 0.836364 18.9491 0.746753 19.1224 0.567532C19.2957 0.388311 19.392 0.258874 19.4113 0.17922L19.3535 0.597402L20.3356 0L20.1045 0.537663C20.4127 0.318614 20.6341 0.20909 20.7689 0.20909C20.8459 0.20909 20.9037 0.258873 20.9422 0.35844C20.9807 0.438094 21 0.517748 21 0.597402C21 0.716882 20.9519 0.856276 20.8556 1.01558C20.7593 1.17489 20.6341 1.36407 20.4801 1.58312C20.3645 1.74242 20.1719 1.98138 19.9023 2.3C19.652 2.5987 19.2669 3.04675 18.7469 3.64416C18.227 4.22164 17.5337 5.02814 16.6671 6.06364C16.436 6.32251 16.0798 6.78052 15.5983 7.43766C15.1169 8.07489 14.5681 8.82164 13.9519 9.67792C13.3549 10.5143 12.7579 11.3606 12.1609 12.2169C11.564 13.0732 11.0344 13.8498 10.5722 14.5468C10.11 15.2238 9.78267 15.7316 9.5901 16.0701L7.79917 19.2065C7.41403 19.8835 7.09629 20.4411 6.84594 20.8792C6.5956 21.2974 6.40303 21.5861 6.26823 21.7455C5.97937 22.1039 5.66162 22.4225 5.31499 22.7013L5.05502 22.5519L4.82393 22.7013L4.56396 23Z" />
    </svg>
  )
}

export const IconChevron = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconChevron"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59z" />
    </svg>
  )
}

export const IconExit = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconExit"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />
    </svg>
  )
}

export const IconReceipt = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="IconReceipt"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 19.0001C19 19.5513 18.5515 19.9998 18.0003 19.9998H6.0006C5.44887 19.9998 5 19.5513 5 19.0001V4.9997C5 4.44846 5.44887 4 6.0006 4H13.0006C13.0006 4 13.0009 7.0006 13.0006 8.0003C13.0003 9 14.0003 10 15.0006 10.0003C16.0009 10.0006 19 10.0003 19 10.0003V19.0001ZM6.0006 21.9998H18.0003C19.6543 21.9998 21 20.6541 21 19.0001V8.0003L15.0006 2H6.0006C4.34606 2 3 3.34566 3 4.9997V19.0001C3 20.6541 4.34606 21.9998 6.0006 21.9998ZM15.0006 4.5V8.0003H18.5L15.0006 4.5ZM7 5C6.44772 5 6 5.44772 6 6C6 6.55228 6.44772 7 7 7H11C11.5523 7 12 6.55228 12 6C12 5.44772 11.5523 5 11 5H7ZM7 8C6.44772 8 6 8.44772 6 9C6 9.55228 6.44772 10 7 10H11C11.5523 10 12 9.55228 12 9C12 8.44772 11.5523 8 11 8H7ZM12.2828 16.0169C12.2828 16.1808 12.2551 16.3192 12.1996 16.4322C12.1503 16.5395 12.0733 16.6441 11.9686 16.7458C11.9563 16.7571 11.9532 16.7684 11.9593 16.7797C11.9655 16.791 11.9778 16.7966 11.9963 16.7966H14.8614C14.8922 16.7966 14.9168 16.8079 14.9353 16.8305C14.96 16.8475 14.9723 16.8701 14.9723 16.8983V17.8983C14.9723 17.9266 14.96 17.952 14.9353 17.9746C14.9168 17.9915 14.8922 18 14.8614 18H10.4159C10.3851 18 10.3574 17.9915 10.3327 17.9746C10.3142 17.952 10.305 17.9266 10.305 17.8983V16.8729C10.305 16.822 10.3296 16.7825 10.3789 16.7542C10.5145 16.6582 10.61 16.5537 10.6654 16.4407C10.7209 16.3277 10.7486 16.1864 10.7486 16.0169V15.6695C10.7486 15.6412 10.7332 15.6271 10.7024 15.6271H10.1109C10.0801 15.6271 10.0524 15.6186 10.0277 15.6017C10.0092 15.5791 10 15.5537 10 15.5254V14.6017C10 14.5734 10.0092 14.5508 10.0277 14.5339C10.0524 14.5113 10.0801 14.5 10.1109 14.5H10.7024C10.7332 14.5 10.7486 14.4859 10.7486 14.4576V13.9153C10.7486 13.3051 10.9427 12.8333 11.3309 12.5C11.7252 12.1667 12.2551 12 12.9205 12C13.4504 12 13.8879 12.1271 14.2329 12.3814C14.5841 12.6299 14.8367 12.9746 14.9908 13.4153C14.9969 13.4266 15 13.4407 15 13.4576C15 13.4972 14.9692 13.5226 14.9076 13.5339L13.6876 13.7288H13.6599C13.6168 13.7288 13.5798 13.7034 13.549 13.6525C13.4812 13.4831 13.398 13.3672 13.2994 13.3051C13.2009 13.2373 13.0746 13.2034 12.9205 13.2034C12.4954 13.2147 12.2828 13.4435 12.2828 13.8898V14.4576C12.2828 14.4859 12.2982 14.5 12.329 14.5H13.9926C14.0234 14.5 14.0481 14.5113 14.0665 14.5339C14.0912 14.5508 14.1035 14.5734 14.1035 14.6017V15.5254C14.1035 15.5537 14.0912 15.5791 14.0665 15.6017C14.0481 15.6186 14.0234 15.6271 13.9926 15.6271H12.329C12.2982 15.6271 12.2828 15.6412 12.2828 15.6695V16.0169Z"
      />
    </svg>
  )
}

export const IconInvoice = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="IconInvoice"
    >
      <path d="M18.0003 19.9998C18.5515 19.9998 19 19.5513 19 19.0001V10.0003C19 10.0003 16.0009 10.0006 15.0006 10.0003C14.0003 10 13.0003 9 13.0006 8.0003C13.0009 7.0006 13.0006 4 13.0006 4H6.0006C5.44887 4 5 4.44846 5 4.9997V19.0001C5 19.5513 5.44887 19.9998 6.0006 19.9998H18.0003ZM18.0003 21.9998H6.0006C4.34606 21.9998 3 20.6541 3 19.0001V4.9997C3 3.34566 4.34606 2 6.0006 2H15.0006V4.5V8.0003H18.5H21V19.0001C21 20.6541 19.6543 21.9998 18.0003 21.9998Z" />
      <path d="M15.0006 2V4.5L18.5 8.0003H21L15.0006 2Z" />
      <path d="M9.432 15.336C9.432 15.784 9.284 16.164 8.988 16.476C8.972 16.492 8.968 16.508 8.976 16.524C8.984 16.54 9 16.548 9.024 16.548H12.852C12.892 16.548 12.924 16.564 12.948 16.596C12.98 16.62 12.996 16.652 12.996 16.692V17.856C12.996 17.896 12.98 17.932 12.948 17.964C12.924 17.988 12.892 18 12.852 18H7.26C7.22 18 7.184 17.988 7.152 17.964C7.128 17.932 7.116 17.896 7.116 17.856V16.656C7.116 16.592 7.148 16.536 7.212 16.488C7.404 16.36 7.54 16.204 7.62 16.02C7.7 15.836 7.74 15.608 7.74 15.336V14.616C7.74 14.576 7.72 14.556 7.68 14.556H6.876C6.836 14.556 6.8 14.544 6.768 14.52C6.744 14.488 6.732 14.452 6.732 14.412V13.332C6.732 13.292 6.744 13.26 6.768 13.236C6.8 13.204 6.836 13.188 6.876 13.188H7.68C7.72 13.188 7.74 13.168 7.74 13.128V12.12C7.74 11.296 7.984 10.656 8.472 10.2C8.96 9.736 9.616 9.504 10.44 9.504C11.088 9.504 11.624 9.672 12.048 10.008C12.48 10.336 12.792 10.796 12.984 11.388C12.992 11.404 12.996 11.424 12.996 11.448C12.996 11.496 12.956 11.532 12.876 11.556L11.58 11.796H11.544C11.488 11.796 11.44 11.76 11.4 11.688C11.312 11.424 11.188 11.236 11.028 11.124C10.876 11.012 10.688 10.956 10.464 10.956C10.144 10.956 9.892 11.048 9.708 11.232C9.524 11.416 9.432 11.7 9.432 12.084V13.128C9.432 13.168 9.452 13.188 9.492 13.188H11.676C11.716 13.188 11.748 13.204 11.772 13.236C11.804 13.26 11.82 13.292 11.82 13.332V14.412C11.82 14.452 11.804 14.488 11.772 14.52C11.748 14.544 11.716 14.556 11.676 14.556H9.492C9.452 14.556 9.432 14.576 9.432 14.616V15.336Z" />
    </svg>
  )
}

export const IconAccount = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconAccount"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM7.07 18.28c.43-.9 3.05-1.78 4.93-1.78s4.51.88 4.93 1.78C15.57 19.36 13.86 20 12 20s-3.57-.64-4.93-1.72zm11.29-1.45c-1.43-1.74-4.9-2.33-6.36-2.33s-4.93.59-6.36 2.33C4.62 15.49 4 13.82 4 12c0-4.41 3.59-8 8-8s8 3.59 8 8c0 1.82-.62 3.49-1.64 4.83zM12 6c-1.94 0-3.5 1.56-3.5 3.5S10.06 13 12 13s3.5-1.56 3.5-3.5S13.94 6 12 6zm0 5c-.83 0-1.5-.67-1.5-1.5S11.17 8 12 8s1.5.67 1.5 1.5S12.83 11 12 11z" />
    </svg>
  )
}

export const IconStats = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconStats"
    >
      <path d="M9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4zm2.5 2.1h-15V5h15v14.1zm0-16.1h-15c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />
      <path d="M0 0h24v24H0z" fill="none" />
    </svg>
  )
}

export const IconSpinner = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="IconSpinner"
    >
      <path d="M20 4.22182C18.9494 3.20038 17.7022 2.39013 16.3296 1.83732C14.9569 1.28452 13.4857 1 12 1C10.5143 1 9.04307 1.28452 7.67043 1.83733C6.29779 2.39013 5.05057 3.20038 4 4.22183L6.55322 6.70426C7.2685 6.00881 8.11767 5.45715 9.05222 5.08077C9.98678 4.7044 10.9884 4.51068 12 4.51068C13.0116 4.51068 14.0132 4.7044 14.9478 5.08077C15.8823 5.45715 16.7315 6.00881 17.4468 6.70425L20 4.22182Z" />
      <path d="M4 19.7782C5.05058 20.7996 6.29779 21.6099 7.67043 22.1627C9.04308 22.7155 10.5143 23 12 23C13.4857 23 14.9569 22.7155 16.3296 22.1627C17.7022 21.6099 18.9494 20.7996 20 19.7782L17.4468 17.2957C16.7315 17.9912 15.8823 18.5429 14.9478 18.9192C14.0132 19.2956 13.0116 19.4893 12 19.4893C10.9884 19.4893 9.98679 19.2956 9.05223 18.9192C8.11767 18.5429 7.26851 17.9912 6.55323 17.2957L4 19.7782Z" />
    </svg>
  )
}

export const IconLogo = () => {
  return (
    <svg
      width="118"
      height="118"
      viewBox="0 0 118 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="IconLogo"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M75.6704 58.7381L27.4852 10.5535C19.9257 2.99396 6.99997 8.34795 6.99997 19.0388L6.99989 98.4185C6.99989 109.109 19.9257 114.463 27.4852 106.904L75.6606 58.7284L75.6704 58.7381ZM32.435 5.6038L80.6201 53.7884L80.6104 63.6781L32.435 111.854C20.4656 123.823 -9.65946e-05 115.346 -9.58547e-05 98.4185L-3.89792e-05 19.0388C-3.95879e-05 2.11162 20.4657 -6.36554 32.435 5.6038Z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M50.2804 67.2131L89.9702 106.903C97.5298 114.463 110.455 109.109 110.455 98.4177L117.455 98.4177C117.455 115.345 96.9898 123.822 85.0205 111.853L45.3306 72.1629C37.9106 64.7429 37.9106 52.7128 45.3306 45.2928L85.0205 5.60294C96.9898 -6.36639 117.456 2.11081 117.456 19.038L110.456 19.038C110.456 8.3471 97.5298 2.99313 89.9702 10.5527L50.2803 50.2426C45.594 54.9289 45.5941 62.5268 50.2804 67.2131Z"
        fill="url(#paint1_linear)"
      />
      <path
        d="M98.4187 110.456C109.11 110.456 114.464 97.5307 106.904 89.9711L58.7285 41.7957L58.7382 41.786L63.6783 36.8459L111.854 85.0214C123.823 96.9907 115.346 117.456 98.4187 117.456V110.456Z"
        fill="url(#paint2_linear)"
      />
      <path
        d="M53.7764 80.6042L106.901 27.4856C114.461 19.926 109.107 7.00009 98.416 7.00009L98.416 8.2259e-05C115.343 8.37388e-05 123.82 20.466 111.851 32.4353L58.7217 85.5574L53.7764 80.6042Z"
        fill="url(#paint3_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="114.998"
          y1="58.7287"
          x2="-9.49799e-05"
          y2="58.7287"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FA6100" />
          <stop offset="1" stopColor="#FA6100" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="39.7656"
          y1="58.7279"
          x2="93.8498"
          y2="4.64372"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBA500" />
          <stop offset="1" stopColor="#DE9200" />
        </linearGradient>
        <linearGradient
          id="paint2_linear"
          x1="54.2786"
          y1="36.8459"
          x2="108.375"
          y2="88.968"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FA8700" />
          <stop offset="1" stopColor="#FBA500" />
        </linearGradient>
        <linearGradient
          id="paint3_linear"
          x1="55.5439"
          y1="81.9423"
          x2="112.979"
          y2="24.874"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FA6100" />
          <stop offset="1" stopColor="#DE9200" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export const IconJob = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="IconJob"
    >
      <path d="M17.9691 15.4736L19.0802 14.2238C19.2538 14.0285 19.5559 14.1652 19.5559 14.4464V20.1253C19.5559 21.1603 18.8093 22 17.8892 22H5.6667C4.74654 22 4 21.1603 4 20.1253V6.37729C4 5.34228 4.74654 4.50256 5.6667 4.50256H15.1634C15.41 4.50256 15.535 4.83845 15.3614 5.03764L14.2502 6.28746C14.1981 6.34604 14.1287 6.37729 14.0523 6.37729H5.6667V20.1253H17.8892V15.6923C17.8892 15.6103 17.917 15.5322 17.9691 15.4736ZM23.4067 7.59195L14.2884 17.8483L11.1495 18.2388C10.2397 18.3521 9.4654 17.4889 9.56609 16.4578L9.91332 12.9271L19.0316 2.6708C19.8267 1.7764 21.1115 1.7764 21.9032 2.6708L23.4032 4.35805C24.1984 5.25245 24.1984 6.70146 23.4067 7.59195V7.59195ZM19.976 8.79881L17.9586 6.52961L11.5071 13.7903L11.2536 16.3407L13.521 16.0556L19.976 8.79881ZM22.2261 5.68598L20.7261 3.99873C20.5837 3.8386 20.351 3.8386 20.2122 3.99873L19.1392 5.20558L21.1566 7.47478L22.2296 6.26793C22.3685 6.10389 22.3685 5.84612 22.2261 5.68598V5.68598Z" />
    </svg>
  )
}

export const IconEnvelope = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconEnvelope"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M21.99 8c0-.72-.37-1.35-.94-1.7L12 1 2.95 6.3C2.38 6.65 2 7.28 2 8v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2l-.01-10zM12 13L3.74 7.84 12 3l8.26 4.84L12 13z" />
    </svg>
  )
}

export const IconBooking = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="IconBooking"
    >
      <path d="M7.90815 3.14705C7.86896 3.10044 7.82238 3.06346 7.77111 3.03822C7.71983 3.01299 7.66485 3 7.60932 3C7.5538 3 7.49882 3.01299 7.44754 3.03822C7.39626 3.06346 7.34969 3.10044 7.31049 3.14705L5.07174 5.78479L4.27369 4.86318C4.2345 4.81657 4.18793 4.77959 4.13665 4.75436C4.08537 4.72912 4.03039 4.71613 3.97486 4.71613C3.91934 4.71613 3.86436 4.72912 3.81308 4.75436C3.7618 4.77959 3.71523 4.81657 3.67604 4.86318L3.12408 5.51814C3.08475 5.56459 3.05355 5.61978 3.03225 5.68055C3.01096 5.74132 3 5.80648 3 5.87228C3 5.93808 3.01096 6.00324 3.03225 6.06401C3.05355 6.12478 3.08475 6.17998 3.12408 6.22642L4.79717 8.20129C4.88068 8.29537 4.9915 8.34783 5.10672 8.34783C5.22194 8.34783 5.33276 8.29537 5.41627 8.20129L5.96436 7.5505L8.50264 4.54279C8.58173 4.44899 8.62642 4.32202 8.62701 4.18942C8.6276 4.05682 8.58405 3.92929 8.50581 3.8345L7.90815 3.14705ZM7.90815 9.77952C7.86896 9.73291 7.82238 9.69592 7.77111 9.67069C7.71983 9.64545 7.66485 9.63246 7.60932 9.63246C7.5538 9.63246 7.49882 9.64545 7.44754 9.67069C7.39626 9.69592 7.34969 9.73291 7.31049 9.77952L5.07174 12.4343L4.27369 11.5136C4.2345 11.467 4.18793 11.43 4.13665 11.4047C4.08537 11.3795 4.03039 11.3665 3.97486 11.3665C3.91934 11.3665 3.86436 11.3795 3.81308 11.4047C3.7618 11.43 3.71523 11.467 3.67604 11.5136L3.12408 12.1673C3.08475 12.2137 3.05355 12.2689 3.03225 12.3297C3.01096 12.3905 3 12.4556 3 12.5214C3 12.5872 3.01096 12.6524 3.03225 12.7131C3.05355 12.7739 3.08475 12.8291 3.12408 12.8756L4.79295 14.8546C4.8764 14.9486 4.98716 15.0011 5.10233 15.0011C5.21749 15.0011 5.32825 14.9486 5.4117 14.8546L5.96366 14.2009L8.50194 11.1919C8.58072 11.0988 8.62526 10.9725 8.62585 10.8406C8.62645 10.7088 8.58305 10.5819 8.5051 10.4878L7.90815 9.77952ZM5.24998 17.0003C4.31869 17.0003 3.54174 17.896 3.54174 19.0001C3.54174 20.1042 4.3194 21 5.24998 21C5.69754 21 6.12676 20.7893 6.44323 20.4143C6.7597 20.0392 6.93749 19.5305 6.93749 19.0001C6.93749 18.4697 6.7597 17.9611 6.44323 17.586C6.12676 17.211 5.69754 17.0003 5.24998 17.0003ZM20.4375 17.6669H10.3125C10.1633 17.6669 10.0202 17.7371 9.91474 17.8621C9.80925 17.9872 9.74999 18.1567 9.74999 18.3335V19.6668C9.74999 19.8436 9.80925 20.0131 9.91474 20.1381C10.0202 20.2631 10.1633 20.3334 10.3125 20.3334H20.4375C20.5867 20.3334 20.7298 20.2631 20.8352 20.1381C20.9407 20.0131 21 19.8436 21 19.6668V18.3335C21 18.1567 20.9407 17.9872 20.8352 17.8621C20.7298 17.7371 20.5867 17.6669 20.4375 17.6669ZM20.4375 4.33447H10.3125C10.1633 4.33447 10.0202 4.4047 9.91474 4.52972C9.80925 4.65473 9.74999 4.82429 9.74999 5.00109V6.33433C9.74999 6.51113 9.80925 6.68069 9.91474 6.80571C10.0202 6.93072 10.1633 7.00095 10.3125 7.00095H20.4375C20.5867 7.00095 20.7298 6.93072 20.8352 6.80571C20.9407 6.68069 21 6.51113 21 6.33433V5.00109C21 4.82429 20.9407 4.65473 20.8352 4.52972C20.7298 4.4047 20.5867 4.33447 20.4375 4.33447ZM20.4375 11.0007H10.3125C10.1633 11.0007 10.0202 11.0709 9.91474 11.1959C9.80925 11.3209 9.74999 11.4905 9.74999 11.6673V13.0005C9.74999 13.1773 9.80925 13.3469 9.91474 13.4719C10.0202 13.5969 10.1633 13.6672 10.3125 13.6672H20.4375C20.5867 13.6672 20.7298 13.5969 20.8352 13.4719C20.9407 13.3469 21 13.1773 21 13.0005V11.6673C21 11.4905 20.9407 11.3209 20.8352 11.1959C20.7298 11.0709 20.5867 11.0007 20.4375 11.0007Z" />
    </svg>
  )
}

export const IconHome = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      enableBackground="new 0 0 24 24"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconHome"
    >
      <g>
        <rect fill="none" height={24} width={24} />
      </g>
      <g>
        <g>
          <path d="M19,9.3V4h-3v2.6L12,3L2,12h3v8h6v-6h2v6h6v-8h3L19,9.3z M17,18h-2v-6H9v6H7v-7.81l5-4.5l5,4.5V18z" />
          <path d="M10,10h4c0-1.1-0.9-2-2-2S10,8.9,10,10z" />
        </g>
      </g>
    </svg>
  )
}

export const IconSettings = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconSettings"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.09-.16-.26-.25-.44-.25-.06 0-.12.01-.17.03l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.06-.02-.12-.03-.18-.03-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.09.16.26.25.44.25.06 0 .12-.01.17-.03l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-1.98-1.71c.04.31.05.52.05.73 0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7.14 1.13zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
    </svg>
  )
}

export const IconAssignment = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconAssignment"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M7 15h7v2H7zm0-4h10v2H7zm0-4h10v2H7zm12-4h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04-.39.08-.74.28-1.01.55-.18.18-.33.4-.43.64-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z" />
    </svg>
  )
}

export const IconCollectionBookmark = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconCollectionBookmark"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-3 2v5l-1-.75L15 9V4h2zm3 12H8V4h5v9l3-2.25L19 13V4h1v12z" />
    </svg>
  )
}

export const IconPersonDevice = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="black"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2128 4C12.4228 4 14.2128 5.79 14.2128 8C14.2128 10.21 12.4228 12 10.2128 12C8.00277 12 6.21277 10.21 6.21277 8C6.21277 5.79 8.00277 4 10.2128 4ZM10.2128 10C11.3128 10 12.2128 9.1 12.2128 8C12.2128 6.9 11.3128 6 10.2128 6C9.11277 6 8.21277 6.9 8.21277 8C8.21277 9.1 9.11277 10 10.2128 10ZM2.21277 20V18C2.21277 15.34 7.54277 14 10.2128 14C10.5847 14 11.0082 14.026 11.4617 14.0779C11.1211 14.6617 10.8925 15.3187 10.8051 16.0196C10.6065 16.0068 10.4086 16 10.2128 16C7.51277 16 4.41277 17.29 4.21277 18H10.7766C10.8237 18.7168 11.0179 19.3934 11.3293 20H2.21277Z"
      />
      <path d="M12.787 13.3734C13.378 12.7824 14.0796 12.3136 14.8517 11.9938C15.6238 11.674 16.4514 11.5094 17.2871 11.5094C18.1229 11.5094 18.9504 11.674 19.7225 11.9938C20.4947 12.3136 21.1962 12.7824 21.7872 13.3734L20.4172 14.7434C20.0061 14.3323 19.5182 14.0063 18.9811 13.7838C18.444 13.5614 17.8684 13.4469 17.2871 13.4469C16.7058 13.4469 16.1302 13.5614 15.5931 13.7838C15.0561 14.0063 14.5681 14.3323 14.157 14.7434L12.787 13.3734Z" />
      <path d="M14.6957 15.4886C15.4154 14.8795 16.3266 14.5434 17.2694 14.5392C18.2122 14.535 19.1263 14.8631 19.8513 15.4658L18.5772 16.9985C18.2124 16.6953 17.7525 16.5302 17.2782 16.5323C16.8039 16.5344 16.3454 16.7035 15.9834 17.01L14.6957 15.4886Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4002 17.8735C16.124 17.8735 15.9002 18.0973 15.9002 18.3735V21.8016C15.9002 22.0777 16.124 22.3016 16.4002 22.3016H18.174C18.4502 22.3016 18.674 22.0777 18.674 21.8016V18.3735C18.674 18.0973 18.4502 17.8735 18.174 17.8735H16.4002ZM17.6376 20.0875C17.6376 20.2811 17.4807 20.4381 17.2871 20.4381C17.0935 20.4381 16.9366 20.2811 16.9366 20.0875C16.9366 19.8939 17.0935 19.737 17.2871 19.737C17.4807 19.737 17.6376 19.8939 17.6376 20.0875Z"
      />
    </svg>
  )
}

export const IconPersonSearchOutline = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      enableBackground="new 0 0 24 24"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconPersonSearchOutline"
    >
      <g>
        <rect fill="none" height={24} width={24} />
      </g>
      <g>
        <g>
          <path d="M10,12c2.21,0,4-1.79,4-4c0-2.21-1.79-4-4-4S6,5.79,6,8C6,10.21,7.79,12,10,12z M10,6c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2 S8,9.1,8,8C8,6.9,8.9,6,10,6z" />
          <path d="M4,18c0.22-0.72,3.31-2,6-2c0-0.7,0.13-1.37,0.35-1.99C7.62,13.91,2,15.27,2,18v2h9.54c-0.52-0.58-0.93-1.25-1.19-2H4z" />
          <path d="M19.43,18.02C19.79,17.43,20,16.74,20,16c0-2.21-1.79-4-4-4s-4,1.79-4,4c0,2.21,1.79,4,4,4c0.74,0,1.43-0.22,2.02-0.57 c0.93,0.93,1.62,1.62,2.57,2.57L22,20.59C20.5,19.09,21.21,19.79,19.43,18.02z M16,18c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2s2,0.9,2,2 C18,17.1,17.1,18,16,18z" />
        </g>
      </g>
    </svg>
  )
}

export const IconPersonOutline = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconPersonOutline"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z" />
    </svg>
  )
}

export const IconPeopleOutline = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconPeopleOutline"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M16.5 13c-1.2 0-3.07.34-4.5 1-1.43-.67-3.3-1-4.5-1C5.33 13 1 14.08 1 16.25V19h22v-2.75c0-2.17-4.33-3.25-6.5-3.25zm-4 4.5h-10v-1.25c0-.54 2.56-1.75 5-1.75s5 1.21 5 1.75v1.25zm9 0H14v-1.25c0-.46-.2-.86-.52-1.22.88-.3 1.96-.53 3.02-.53 2.44 0 5 1.21 5 1.75v1.25zM7.5 12c1.93 0 3.5-1.57 3.5-3.5S9.43 5 7.5 5 4 6.57 4 8.5 5.57 12 7.5 12zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 5.5c1.93 0 3.5-1.57 3.5-3.5S18.43 5 16.5 5 13 6.57 13 8.5s1.57 3.5 3.5 3.5zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z" />
    </svg>
  )
}

export const IconPerson = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconPerson"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
    </svg>
  )
}

export const IconPeople = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconPeople"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
    </svg>
  )
}

export const IconGroup = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconGroup"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M9 13.75c-2.34 0-7 1.17-7 3.5V19h14v-1.75c0-2.33-4.66-3.5-7-3.5zM4.34 17c.84-.58 2.87-1.25 4.66-1.25s3.82.67 4.66 1.25H4.34zM9 12c1.93 0 3.5-1.57 3.5-3.5S10.93 5 9 5 5.5 6.57 5.5 8.5 7.07 12 9 12zm0-5c.83 0 1.5.67 1.5 1.5S9.83 10 9 10s-1.5-.67-1.5-1.5S8.17 7 9 7zm7.04 6.81c1.16.84 1.96 1.96 1.96 3.44V19h4v-1.75c0-2.02-3.5-3.17-5.96-3.44zM15 12c1.93 0 3.5-1.57 3.5-3.5S16.93 5 15 5c-.54 0-1.04.13-1.5.35.63.89 1 1.98 1 3.15s-.37 2.26-1 3.15c.46.22.96.35 1.5.35z" />
    </svg>
  )
}

export const IconUserGroup = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      enableBackground="new 0 0 24 24"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="#000000"
      className="IconUserGroup"
    >
      <rect fill="none" height={24} width={24} />
      <g>
        <path d="M4,13c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2s-2,0.9-2,2C2,12.1,2.9,13,4,13z M5.13,14.1C4.76,14.04,4.39,14,4,14 c-0.99,0-1.93,0.21-2.78,0.58C0.48,14.9,0,15.62,0,16.43V18l4.5,0v-1.61C4.5,15.56,4.73,14.78,5.13,14.1z M20,13c1.1,0,2-0.9,2-2 c0-1.1-0.9-2-2-2s-2,0.9-2,2C18,12.1,18.9,13,20,13z M24,16.43c0-0.81-0.48-1.53-1.22-1.85C21.93,14.21,20.99,14,20,14 c-0.39,0-0.76,0.04-1.13,0.1c0.4,0.68,0.63,1.46,0.63,2.29V18l4.5,0V16.43z M16.24,13.65c-1.17-0.52-2.61-0.9-4.24-0.9 c-1.63,0-3.07,0.39-4.24,0.9C6.68,14.13,6,15.21,6,16.39V18h12v-1.61C18,15.21,17.32,14.13,16.24,13.65z M8.07,16 c0.09-0.23,0.13-0.39,0.91-0.69c0.97-0.38,1.99-0.56,3.02-0.56s2.05,0.18,3.02,0.56c0.77,0.3,0.81,0.46,0.91,0.69H8.07z M12,8 c0.55,0,1,0.45,1,1s-0.45,1-1,1s-1-0.45-1-1S11.45,8,12,8 M12,6c-1.66,0-3,1.34-3,3c0,1.66,1.34,3,3,3s3-1.34,3-3 C15,7.34,13.66,6,12,6L12,6z" />
      </g>
    </svg>
  )
}

export const IconVideo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="#000000"
      className="IconVideo"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M15 8v8H5V8h10m1-2H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4V7c0-.55-.45-1-1-1z" />
    </svg>
  )
}

export const IconVideoSolid = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="#000000"
      className="IconVideoSolid"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z" />
    </svg>
  )
}

export const IconUsers = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconUsers"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M12.5 10c0-1.65-1.35-3-3-3s-3 1.35-3 3 1.35 3 3 3 3-1.35 3-3zm-3 1c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm6.5 2c1.11 0 2-.89 2-2 0-1.11-.89-2-2-2-1.11 0-2.01.89-2 2 0 1.11.89 2 2 2zM11.99 2.01c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zM5.84 17.12c.68-.54 2.27-1.11 3.66-1.11.07 0 .15.01.23.01.24-.64.67-1.29 1.3-1.86-.56-.1-1.09-.16-1.53-.16-1.3 0-3.39.45-4.73 1.43-.5-1.04-.78-2.2-.78-3.43 0-4.41 3.59-8 8-8s8 3.59 8 8c0 1.2-.27 2.34-.75 3.37-1-.59-2.36-.87-3.24-.87-1.52 0-4.5.81-4.5 2.7v2.78c-2.27-.13-4.29-1.21-5.66-2.86z" />
    </svg>
  )
}

export const IconGroups = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      enableBackground="new 0 0 24 24"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconGroups"
    >
      <rect fill="none" height={24} width={24} />
      <g>
        <path d="M4,13c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2s-2,0.9-2,2C2,12.1,2.9,13,4,13z M5.13,14.1C4.76,14.04,4.39,14,4,14 c-0.99,0-1.93,0.21-2.78,0.58C0.48,14.9,0,15.62,0,16.43V18l4.5,0v-1.61C4.5,15.56,4.73,14.78,5.13,14.1z M20,13c1.1,0,2-0.9,2-2 c0-1.1-0.9-2-2-2s-2,0.9-2,2C18,12.1,18.9,13,20,13z M24,16.43c0-0.81-0.48-1.53-1.22-1.85C21.93,14.21,20.99,14,20,14 c-0.39,0-0.76,0.04-1.13,0.1c0.4,0.68,0.63,1.46,0.63,2.29V18l4.5,0V16.43z M16.24,13.65c-1.17-0.52-2.61-0.9-4.24-0.9 c-1.63,0-3.07,0.39-4.24,0.9C6.68,14.13,6,15.21,6,16.39V18h12v-1.61C18,15.21,17.32,14.13,16.24,13.65z M8.07,16 c0.09-0.23,0.13-0.39,0.91-0.69c0.97-0.38,1.99-0.56,3.02-0.56s2.05,0.18,3.02,0.56c0.77,0.3,0.81,0.46,0.91,0.69H8.07z M12,8 c0.55,0,1,0.45,1,1s-0.45,1-1,1s-1-0.45-1-1S11.45,8,12,8 M12,6c-1.66,0-3,1.34-3,3c0,1.66,1.34,3,3,3s3-1.34,3-3 C15,7.34,13.66,6,12,6L12,6z" />
      </g>
    </svg>
  )
}

export const IconMore = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="#000000"
      className="IconMore"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
    </svg>
  )
}

export const IconDrag = (
  props?: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="#000000"
      className="IconDrag"
      {...props}
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
    </svg>
  )
}

export const IconMiscSettings = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      enableBackground="new 0 0 24 24"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconMiscSettings"
    >
      <g>
        <rect fill="none" height={24} width={24} />
      </g>
      <g>
        <g>
          <path d="M14.17,13.71l1.4-2.42c0.09-0.15,0.05-0.34-0.08-0.45l-1.48-1.16c0.03-0.22,0.05-0.45,0.05-0.68s-0.02-0.46-0.05-0.69 l1.48-1.16c0.13-0.11,0.17-0.3,0.08-0.45l-1.4-2.42c-0.09-0.15-0.27-0.21-0.43-0.15L12,4.83c-0.36-0.28-0.75-0.51-1.18-0.69 l-0.26-1.85C10.53,2.13,10.38,2,10.21,2h-2.8C7.24,2,7.09,2.13,7.06,2.3L6.8,4.15C6.38,4.33,5.98,4.56,5.62,4.84l-1.74-0.7 c-0.16-0.06-0.34,0-0.43,0.15l-1.4,2.42C1.96,6.86,2,7.05,2.13,7.16l1.48,1.16C3.58,8.54,3.56,8.77,3.56,9s0.02,0.46,0.05,0.69 l-1.48,1.16C2,10.96,1.96,11.15,2.05,11.3l1.4,2.42c0.09,0.15,0.27,0.21,0.43,0.15l1.74-0.7c0.36,0.28,0.75,0.51,1.18,0.69 l0.26,1.85C7.09,15.87,7.24,16,7.41,16h2.8c0.17,0,0.32-0.13,0.35-0.3l0.26-1.85c0.42-0.18,0.82-0.41,1.18-0.69l1.74,0.7 C13.9,13.92,14.08,13.86,14.17,13.71z M8.81,11c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2s2,0.9,2,2C10.81,10.1,9.91,11,8.81,11z" />
          <path d="M21.92,18.67l-0.96-0.74c0.02-0.14,0.04-0.29,0.04-0.44c0-0.15-0.01-0.3-0.04-0.44l0.95-0.74 c0.08-0.07,0.11-0.19,0.05-0.29l-0.9-1.55c-0.05-0.1-0.17-0.13-0.28-0.1l-1.11,0.45c-0.23-0.18-0.48-0.33-0.76-0.44l-0.17-1.18 C18.73,13.08,18.63,13,18.53,13h-1.79c-0.11,0-0.21,0.08-0.22,0.19l-0.17,1.18c-0.27,0.12-0.53,0.26-0.76,0.44l-1.11-0.45 c-0.1-0.04-0.22,0-0.28,0.1l-0.9,1.55c-0.05,0.1-0.04,0.22,0.05,0.29l0.95,0.74c-0.02,0.14-0.03,0.29-0.03,0.44 c0,0.15,0.01,0.3,0.03,0.44l-0.95,0.74c-0.08,0.07-0.11,0.19-0.05,0.29l0.9,1.55c0.05,0.1,0.17,0.13,0.28,0.1l1.11-0.45 c0.23,0.18,0.48,0.33,0.76,0.44l0.17,1.18c0.02,0.11,0.11,0.19,0.22,0.19h1.79c0.11,0,0.21-0.08,0.22-0.19l0.17-1.18 c0.27-0.12,0.53-0.26,0.75-0.44l1.12,0.45c0.1,0.04,0.22,0,0.28-0.1l0.9-1.55C22.03,18.86,22,18.74,21.92,18.67z M17.63,18.83 c-0.74,0-1.35-0.6-1.35-1.35s0.6-1.35,1.35-1.35s1.35,0.6,1.35,1.35S18.37,18.83,17.63,18.83z" />
        </g>
      </g>
    </svg>
  )
}

export const IconProfile = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconProfile"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M19 5v14H5V5h14m0-2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 9c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm6 10H6v-1.53c0-2.5 3.97-3.58 6-3.58s6 1.08 6 3.58V18zm-9.69-2h7.38c-.69-.56-2.38-1.12-3.69-1.12s-3.01.56-3.69 1.12z" />
    </svg>
  )
}

export const IconUser = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconUser"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z" />
    </svg>
  )
}

export const IconCopy = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="black"
      width={24}
      height={24}
      className="IconCopy"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
    </svg>
  )
}

export const IconSort: FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
      className="IconSort"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.02219 13.7825C6.17466 13.4041 6.54175 13.1562 6.94974 13.1562L17.05 13.1563C17.4579 13.1563 17.825 13.4041 17.9775 13.7825C18.13 14.161 18.0372 14.5941 17.7432 14.8769L12.6931 19.7349C12.306 20.1073 11.6937 20.1073 11.3066 19.7349L6.25648 14.8769C5.96244 14.5941 5.86972 14.161 6.02219 13.7825Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.9773 10.217C17.8248 10.5954 17.4578 10.8433 17.0498 10.8433L6.94956 10.8433C6.54157 10.8433 6.17448 10.5954 6.02201 10.217C5.86954 9.83853 5.96226 9.40542 6.2563 9.12257L11.3064 4.26464C11.6936 3.89222 12.3058 3.89222 12.6929 4.26464L17.743 9.12258C18.0371 9.40542 18.1298 9.83853 17.9773 10.217Z"
      />
    </svg>
  )
}

export const IconSortDown: FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
      className="IconSortDown"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.43073 7.69406C5.59829 7.1127 6.00169 6.73193 6.45005 6.73193L17.5495 6.73194C17.9979 6.73194 18.4013 7.1127 18.5688 7.69406C18.7364 8.27542 18.6345 8.94078 18.3114 9.3753L12.7616 16.8382C12.3362 17.4103 11.6634 17.4103 11.2379 16.8382L5.6882 9.3753C5.36507 8.94078 5.26318 8.27542 5.43073 7.69406Z"
      />
    </svg>
  )
}

export const IconNotFound = () => {
  return (
    <svg
      width={277}
      height={78}
      viewBox="0 0 277 78"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="IconNotFound"
    >
      <path
        d="M92.5269 34.6416L137 72.0001H49L92.5269 34.6416Z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M47.5269 27L92 72H4L47.5269 27Z"
        fill="#B5C7D0"
        fillOpacity="0.26"
      />
      <path
        d="M220 32.0942L254 71.9999H186L220 32.0942Z"
        fill="#CBCBCB"
        fillOpacity="0.17"
      />
      <path
        d="M180 66C180 64.8954 180.895 64 182 64H200C201.105 64 202 64.8954 202 66V70C202 70.5523 201.552 71 201 71H181C180.448 71 180 70.5523 180 70V66Z"
        fill="url(#paint1_linear)"
      />
      <rect x={26} y={51} width={2} height={21} fill="#C1BFBF" />
      <rect x={238} y={54} width={1} height={18} fill="#C1BFBF" />
      <rect x={50} y={47} width={2} height={25} fill="#C1BFBF" />
      <rect
        x={18}
        y={40}
        width={19}
        height={28}
        rx="9.5"
        fill="url(#paint2_linear)"
      />
      <rect
        x={230}
        y={49}
        width={17}
        height={17}
        rx="8.5"
        fill="url(#paint3_linear)"
      />
      <rect
        x={41}
        y={34}
        width={19}
        height={34}
        rx="9.5"
        fill="url(#paint4_linear)"
      />
      <rect x={195} y={71} width={4} height={1} fill="#C4C4C4" />
      <rect x={183} y={71} width={4} height={1} fill="#C4C4C4" />
      <line
        x1={54}
        y1="4.5"
        x2={99}
        y2="4.5"
        stroke="#82ADBB"
        strokeOpacity="0.5"
      />
      <line
        x1={65}
        y1="0.5"
        x2={92}
        y2="0.5"
        stroke="#82ADBB"
        strokeOpacity="0.5"
      />
      <line
        x1={171}
        y1="24.5"
        x2={205}
        y2="24.5"
        stroke="#82ADBB"
        strokeOpacity="0.5"
      />
      <line
        x1={156}
        y1="20.5"
        x2={208}
        y2="20.5"
        stroke="#82ADBB"
        strokeOpacity="0.5"
      />
      <line
        x1={164}
        y1="16.5"
        x2={216}
        y2="16.5"
        stroke="#82ADBB"
        strokeOpacity="0.5"
      />
      <line
        x1={166}
        y1="12.5"
        x2={232}
        y2="12.5"
        stroke="#82ADBB"
        strokeOpacity="0.5"
      />
      <line
        x1={194}
        y1="8.5"
        x2={228}
        y2="8.5"
        stroke="#82ADBB"
        strokeOpacity="0.5"
      />
      <line
        x1={61}
        y1="8.5"
        x2={132}
        y2="8.5"
        stroke="#82ADBB"
        strokeOpacity="0.5"
      />
      <line
        x1={52}
        y1="12.5"
        x2={110}
        y2="12.5"
        stroke="#82ADBB"
        strokeOpacity="0.5"
      />
      <path d="M0 72H277V78H0V72Z" fill="#9FB3BC" fillOpacity="0.29" />
      <rect x={137} y={31} width={3} height={44} fill="#68645F" />
      <rect x={125} y={33} width={27} height={16} rx={2} fill="#F2F2F2" />
      <path
        d="M137.407 42.504C137.367 42.088 137.387 41.736 137.467 41.448C137.547 41.152 137.655 40.9 137.791 40.692C137.935 40.476 138.095 40.292 138.271 40.14C138.455 39.98 138.623 39.828 138.775 39.684C138.935 39.54 139.067 39.392 139.171 39.24C139.275 39.08 139.327 38.892 139.327 38.676C139.327 38.396 139.247 38.172 139.087 38.004C138.935 37.836 138.659 37.752 138.259 37.752C138.131 37.752 137.995 37.768 137.851 37.8C137.707 37.824 137.563 37.864 137.419 37.92C137.275 37.968 137.135 38.028 136.999 38.1C136.871 38.164 136.755 38.232 136.651 38.304L136.051 37.152C136.355 36.944 136.703 36.772 137.095 36.636C137.495 36.5 137.975 36.432 138.535 36.432C139.287 36.432 139.875 36.616 140.299 36.984C140.723 37.344 140.935 37.832 140.935 38.448C140.935 38.856 140.879 39.196 140.767 39.468C140.663 39.732 140.531 39.96 140.371 40.152C140.211 40.336 140.035 40.5 139.843 40.644C139.651 40.788 139.475 40.944 139.315 41.112C139.155 41.272 139.019 41.46 138.907 41.676C138.795 41.892 138.739 42.168 138.739 42.504H137.407ZM137.167 44.208C137.167 43.928 137.255 43.708 137.431 43.548C137.607 43.38 137.839 43.296 138.127 43.296C138.431 43.296 138.671 43.38 138.847 43.548C139.023 43.708 139.111 43.928 139.111 44.208C139.111 44.488 139.023 44.712 138.847 44.88C138.671 45.048 138.431 45.132 138.127 45.132C137.839 45.132 137.607 45.048 137.431 44.88C137.255 44.712 137.167 44.488 137.167 44.208Z"
        fill="#4E4E4E"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="100.097"
          y1="40.9855"
          x2="75.1076"
          y2="68.9367"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0864582" stopColor="#CCCCCC" stopOpacity="0.2" />
          <stop offset="0.951042" stopColor="#0684C2" stopOpacity="0.11" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="188.5"
          y1={64}
          x2={190}
          y2={70}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#30C1FF" />
          <stop offset={1} stopColor="#1E83A4" />
        </linearGradient>
        <linearGradient
          id="paint2_linear"
          x1={39}
          y1={40}
          x2="21.5"
          y2={68}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6FF0E1" />
          <stop offset={1} stopColor="#36806E" />
        </linearGradient>
        <linearGradient
          id="paint3_linear"
          x1={230}
          y1="54.5435"
          x2="242.481"
          y2="64.1121"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#61DABD" />
          <stop offset={1} stopColor="#27997E" />
        </linearGradient>
        <linearGradient
          id="paint4_linear"
          x1={69}
          y1={38}
          x2="39.5"
          y2="77.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7AEACF" />
          <stop offset={1} stopColor="#12785F" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export const IconKey = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconKey"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M22 19h-6v-4h-2.68c-1.14 2.42-3.6 4-6.32 4-3.86 0-7-3.14-7-7s3.14-7 7-7c2.72 0 5.17 1.58 6.32 4H24v6h-2v4zm-4-2h2v-4h2v-2H11.94l-.23-.67C11.01 8.34 9.11 7 7 7c-2.76 0-5 2.24-5 5s2.24 5 5 5c2.11 0 4.01-1.34 4.71-3.33l.23-.67H18v4zM7 15c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z" />
    </svg>
  )
}

export const IconAlarm = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconAlarm"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6zM7.58 4.08L6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2c.15-2.65 1.51-4.97 3.55-6.42zm12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43c2.02 1.45 3.39 3.77 3.54 6.42z" />
    </svg>
  )
}

export const IconAlert = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconAlert"
    >
      <path d="M10.01 21.01c0 1.1.89 1.99 1.99 1.99s1.99-.89 1.99-1.99h-3.98zM12 6c2.76 0 5 2.24 5 5v7H7v-7c0-2.76 2.24-5 5-5zm0-4.5c-.83 0-1.5.67-1.5 1.5v1.17C7.36 4.85 5 7.65 5 11v6l-2 2v1h18v-1l-2-2v-6c0-3.35-2.36-6.15-5.5-6.83V3c0-.83-.67-1.5-1.5-1.5zM11 8h2v4h-2zm0 6h2v2h-2z" />
    </svg>
  )
}

export const IconAccess = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      enableBackground="new 0 0 24 24"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconAccess"
    >
      <g>
        <rect fill="none" height={24} width={24} />
      </g>
      <g>
        <path d="M11,7L9.6,8.4l2.6,2.6H2v2h10.2l-2.6,2.6L11,17l5-5L11,7z M20,19h-8v2h8c1.1,0,2-0.9,2-2V5c0-1.1-0.9-2-2-2h-8v2h8V19z" />
      </g>
    </svg>
  )
}

export const IconPackage = () => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fas"
      data-icon="box"
      className="IconPackage"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <path
        fill="currentColor"
        d="M509.5 184.6L458.9 32.8C452.4 13.2 434.1 0 413.4 0H272v192h238.7c-.4-2.5-.4-5-1.2-7.4zM240 0H98.6c-20.7 0-39 13.2-45.5 32.8L2.5 184.6c-.8 2.4-.8 4.9-1.2 7.4H240V0zM0 224v240c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V224H0z"
      />
    </svg>
  )
}

export const IconBriefcase = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconBriefcase"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z" />
    </svg>
  )
}

export const IconMail = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconMail"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0l-8 5-8-5h16zm0 12H4V8l8 5 8-5v10z" />
    </svg>
  )
}

export const IconShield = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      enableBackground="new 0 0 24 24"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconShield"
    >
      <g>
        <rect fill="none" height={24} width={24} />
      </g>
      <g>
        <path d="M12,2L4,5v6.09c0,5.05,3.41,9.76,8,10.91c4.59-1.15,8-5.86,8-10.91V5L12,2z M18,11.09c0,4-2.55,7.7-6,8.83 c-3.45-1.13-6-4.82-6-8.83v-4.7l6-2.25l6,2.25V11.09z" />
      </g>
    </svg>
  )
}

export const IconArrow = () => {
  return (
    <svg
      width={27}
      height={16}
      viewBox="0 0 27 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="IconArrow"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.0811 1.04582L26.445 7.40978C26.8356 7.80031 26.8356 8.43347 26.445 8.824L20.0811 15.188C19.6906 15.5785 19.0574 15.5785 18.6669 15.188C18.2763 14.7974 18.2763 14.1643 18.6669 13.7737L23.3237 9.11689H0.385742V7.11689H23.3237L18.6669 2.46004C18.2763 2.06951 18.2763 1.43635 18.6669 1.04582C19.0574 0.655299 19.6906 0.655299 20.0811 1.04582Z"
        fill="#C4C4C4"
      />
    </svg>
  )
}

export const IconAssignmentDone = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconAssignmentDone"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M18 9l-1.41-1.42L10 14.17l-2.59-2.58L6 13l4 4zm1-6h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04-.39.08-.74.28-1.01.55-.18.18-.33.4-.43.64-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z" />
    </svg>
  )
}

export const IconHouse = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      enableBackground="new 0 0 24 24"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconHouse"
    >
      <rect fill="none" height={24} width={24} />
      <path d="M13,18h-2v-2h2V18z M15,14H9v6h6V14L15,14z M19,9.3L19,9.3V4h-3v2.6v0L12,3L2,12h3l7-6.31L19,12h3L19,9.3z" />
    </svg>
  )
}

export const DashedBox = () => {
  return (
    <svg
      className={"DashedBox"}
      width={776}
      height={200}
      viewBox="0 0 776 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x={2}
        y={2}
        width={772}
        height={196}
        rx={22}
        strokeWidth={4}
        strokeDasharray="16 8"
      />
    </svg>
  )
}

export const IconToday = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="#000000"
      className="IconToday"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z" />
    </svg>
  )
}

export const IconClock = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="#000000"
      className="IconClock"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
      <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
    </svg>
  )
}

export const IconDeny = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      enableBackground="new 0 0 24 24"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="#000000"
      className="IconDeny"
    >
      <g>
        <path d="M0,0h24v24H0V0z" fill="none" />
      </g>
      <g>
        <g>
          <path d="M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M17,13H7v-2h10V13z" />
        </g>
      </g>
    </svg>
  )
}

export const IconPassword = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      enableBackground="new 0 0 24 24"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="#000000"
      className="IconPassword"
    >
      <g>
        <path d="M0,0h24v24H0V0z" fill="none" />
      </g>
      <g>
        <g>
          <path d="M2,17h20v2H2V17z M3.15,12.95L4,11.47l0.85,1.48l1.3-0.75L5.3,10.72H7v-1.5H5.3l0.85-1.47L4.85,7L4,8.47L3.15,7l-1.3,0.75 L2.7,9.22H1v1.5h1.7L1.85,12.2L3.15,12.95z M9.85,12.2l1.3,0.75L12,11.47l0.85,1.48l1.3-0.75l-0.85-1.48H15v-1.5h-1.7l0.85-1.47 L12.85,7L12,8.47L11.15,7l-1.3,0.75l0.85,1.47H9v1.5h1.7L9.85,12.2z M23,9.22h-1.7l0.85-1.47L20.85,7L20,8.47L19.15,7l-1.3,0.75 l0.85,1.47H17v1.5h1.7l-0.85,1.48l1.3,0.75L20,11.47l0.85,1.48l1.3-0.75l-0.85-1.48H23V9.22z" />
        </g>
      </g>
    </svg>
  )
}

export const IconPassword2 = () => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="47px"
      height="47px"
      viewBox="0 0 47 47"
      className="IconPassword"
      xmlSpace="preserve"
    >
      <g>
        <g>
          <path d="M37.076,19.748c-0.824,0-1.494,0.672-1.494,1.499v1.46h2.991v-1.46C38.573,20.42,37.9,19.748,37.076,19.748z" />
          <path
            d="M41.227,12.635H5.773C2.6,12.635,0,15.237,0,18.41v10.18c0,3.178,2.6,5.775,5.773,5.775h35.454
			C44.4,34.365,47,31.768,47,28.59V18.41C47,15.237,44.4,12.635,41.227,12.635z M12.56,25.077l1.385,1.508l-2.399,1.8l-0.984-1.8
			c-0.145-0.257-0.372-0.761-0.691-1.508c-0.349,0.821-0.581,1.321-0.696,1.508l-0.998,1.8l-2.466-1.8l1.491-1.508
			c0.42-0.415,0.827-0.771,1.229-1.063c-0.41-0.037-0.949-0.113-1.614-0.238l-2.065-0.336l0.958-2.812l1.852,0.842
			c0.195,0.088,0.68,0.365,1.452,0.824c-0.165-0.747-0.271-1.302-0.319-1.666l-0.263-2.013h2.941l-0.238,2.013
			c-0.052,0.49-0.166,1.045-0.335,1.666c0.339-0.17,0.563-0.283,0.669-0.345c0.372-0.207,0.659-0.35,0.852-0.442l1.853-0.879
			l0.918,2.812l-2.049,0.428c-0.375,0.072-0.931,0.119-1.67,0.146C11.874,24.406,12.266,24.758,12.56,25.077z M26.137,25.077
			l1.387,1.508l-2.399,1.799l-0.983-1.799c-0.145-0.257-0.372-0.761-0.69-1.508c-0.35,0.821-0.58,1.321-0.695,1.508l-1,1.799
			l-2.465-1.799l1.491-1.508c0.42-0.415,0.826-0.771,1.229-1.063c-0.408-0.037-0.949-0.113-1.614-0.238l-2.066-0.336l0.959-2.812
			l1.853,0.842c0.193,0.088,0.68,0.365,1.451,0.824c-0.169-0.747-0.275-1.302-0.32-1.666l-0.264-2.011h2.942l-0.239,2.011
			c-0.054,0.49-0.166,1.045-0.333,1.666c0.337-0.17,0.561-0.283,0.668-0.345c0.37-0.207,0.658-0.35,0.852-0.442l1.854-0.879
			l0.919,2.812l-2.051,0.428c-0.375,0.072-0.929,0.119-1.669,0.146C25.451,24.406,25.844,24.758,26.137,25.077z M41.35,27.625
			c0,0.619-0.507,1.125-1.125,1.125H33.93c-0.619,0-1.125-0.506-1.125-1.125v-3.794c0-0.619,0.506-1.125,1.125-1.125h0.152v-1.46
			c0-1.653,1.343-2.998,2.994-2.998c1.652,0,2.996,1.344,2.996,2.998v1.46h0.152c0.617,0,1.125,0.506,1.125,1.125V27.625z"
          />
        </g>
      </g>
    </svg>
  )
}

export const IconLockGradient = () => {
  return (
    <svg
      width={90}
      height={112}
      viewBox="0 0 90 112"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="IconLockGradient"
    >
      <path
        d="M45.0021 4.5C60.3852 4.5 72.9 16.9452 72.9 32.241L73.0332 56.0001C73.0332 57.3714 71.8542 55.4838 70.4832 55.4838C69.1122 55.4838 68.0496 57.2214 68.0496 55.8501L67.9332 32.241C67.9332 19.6842 57.6462 9.4671 45.0021 9.4671C32.3556 9.4671 22.0671 19.6842 22.0671 32.241V57.5001H17.1V32.241C17.1 16.9452 29.6163 4.5 45.0021 4.5ZM45.0021 0C27.1356 0 12.6 14.4633 12.6 32.241V57.5001H16.6881H26.5671V32.241C26.5671 22.1646 34.8369 13.9671 45.0021 13.9671C55.1649 13.9671 63.4332 22.1646 63.4332 32.241L63.5496 55.8501C63.5496 59.7009 66.7824 58.3338 70.6332 58.3338C74.484 58.3338 77.5332 59.8509 77.5332 56.0001L77.4 32.241C77.4 14.4633 62.8665 0 45.0021 0Z"
        fill="#F96300"
      />
      <path
        d="M45.0021 4.5C60.3852 4.5 72.9 16.9452 72.9 32.241L73.0332 56.0001C73.0332 57.3714 71.8542 55.4838 70.4832 55.4838C69.1122 55.4838 68.0496 57.2214 68.0496 55.8501L67.9332 32.241C67.9332 19.6842 57.6462 9.4671 45.0021 9.4671C32.3556 9.4671 22.0671 19.6842 22.0671 32.241V57.5001H17.1V32.241C17.1 16.9452 29.6163 4.5 45.0021 4.5ZM45.0021 0C27.1356 0 12.6 14.4633 12.6 32.241V57.5001H16.6881H26.5671V32.241C26.5671 22.1646 34.8369 13.9671 45.0021 13.9671C55.1649 13.9671 63.4332 22.1646 63.4332 32.241L63.5496 55.8501C63.5496 59.7009 66.7824 58.3338 70.6332 58.3338C74.484 58.3338 77.5332 59.8509 77.5332 56.0001L77.4 32.241C77.4 14.4633 62.8665 0 45.0021 0Z"
        fill="url(#paint0_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.0047 75.9177C43.0808 75.9177 41.5289 77.4697 41.5289 79.3887C41.5289 81.3089 43.082 82.8621 45.0047 82.8621C46.9214 82.8621 48.4757 81.3102 48.4757 79.3887C48.4757 77.4685 46.9226 75.9177 45.0047 75.9177ZM37.0289 79.3887C37.0289 74.9795 40.6004 71.4177 45.0047 71.4177C49.4054 71.4177 52.9757 74.9808 52.9757 79.3887C52.9757 83.7955 49.4067 87.3621 45.0047 87.3621C40.5992 87.3621 37.0289 83.7967 37.0289 79.3887Z"
        fill="url(#paint1_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.39144 59.6919C7.12761 59.6919 5.26404 61.5556 5.26404 63.819V102.587C5.26404 104.852 7.1272 106.714 9.39144 106.714H80.6084C82.8743 106.714 84.7358 104.853 84.7358 102.587V63.819C84.7358 61.5551 82.8739 59.6919 80.6084 59.6919H9.39144ZM0.764038 63.819C0.764038 59.0702 4.64247 55.1919 9.39144 55.1919H80.6084C85.36 55.1919 89.2358 59.0707 89.2358 63.819V102.587C89.2358 107.338 85.3596 111.214 80.6084 111.214H9.39144C4.64288 111.214 0.764038 107.339 0.764038 102.587V63.819Z"
        fill="url(#paint2_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.7548 92.7576V86.4036H47.2548V92.7576H42.7548Z"
        fill="url(#paint3_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.0048 84.1536C46.2474 84.1536 47.2548 85.1609 47.2548 86.4036V92.7576C47.2548 94.0002 46.2474 95.0076 45.0048 95.0076C43.7621 95.0076 42.7548 94.0002 42.7548 92.7576V86.4036C42.7548 85.1609 43.7621 84.1536 45.0048 84.1536Z"
        fill="#F96300"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1={45}
          y1="32.2419"
          x2={75}
          y2="32.2419"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.15" stopColor="#FA5F00" />
          <stop offset="0.81" stopColor="#FA8200" />
          <stop offset={1} stopColor="#FAA500" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="45.0023"
          y1="79.3899"
          x2="75.0023"
          y2="79.3899"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.15" stopColor="#FA5F00" />
          <stop offset="0.81" stopColor="#FA8200" />
          <stop offset={1} stopColor="#FAA500" />
        </linearGradient>
        <linearGradient
          id="paint2_linear"
          x1="44.9999"
          y1="83.2032"
          x2="74.9999"
          y2="83.2032"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FA5F00" />
          <stop offset="0.78" stopColor="#FA8200" />
          <stop offset={1} stopColor="#FAA500" />
        </linearGradient>
        <linearGradient
          id="paint3_linear"
          x1="45.0048"
          y1="89.5806"
          x2="45.3048"
          y2="89.5806"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FA5F00" />
          <stop offset="0.78" stopColor="#FA8200" />
          <stop offset={1} stopColor="#FAA500" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export const IconSentrykey = () => {
  return (
    <svg
      width={247}
      height={247}
      viewBox="0 0 247 247"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="IconSentrykey"
    >
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={247}
        height={247}
      >
        <circle cx="123.646" cy="123.048" r="123.048" fill="#F3F3F3" />
      </mask>
      <g mask="url(#mask0)">
        <circle
          cx="123.646"
          cy="123.048"
          r="123.048"
          fill="url(#paint0_linear)"
        />
        <rect x="-1.54761" width="191.79" height="246.379" fill="#F3F3F3" />
        <path
          d="M54.3066 57.6645C54.3066 54.4778 56.89 51.8944 60.0768 51.8944H127.63C130.816 51.8944 133.4 54.4778 133.4 57.6645V183.613C133.4 186.8 130.816 189.384 127.63 189.384H60.0768C56.89 189.384 54.3066 186.8 54.3066 183.613V57.6645Z"
          fill="url(#paint1_linear)"
        />
        <path
          d="M139.777 56.9402L129.919 52.3564L130.151 56.3551L138.051 63.6937L139.777 56.9402Z"
          fill="#969696"
        />
        <path
          d="M57.5007 188.758L67.3589 193.341L67.1271 189.343L59.227 182.004L57.5007 188.758Z"
          fill="#3D3D3D"
        />
        <path
          d="M106.017 121.855L98.3257 116.465L94.4478 119.908L102.348 127.247L106.017 121.855Z"
          fill="#9C9C9C"
        />
        <path
          d="M63.7886 62.0573C63.7886 58.8705 66.372 56.2871 69.5587 56.2871H137.112C140.298 56.2871 142.882 58.8705 142.882 62.0572V188.006C142.882 191.193 140.298 193.776 137.112 193.776H69.5587C66.372 193.776 63.7886 191.193 63.7886 188.006V62.0573Z"
          fill="#CCCCCC"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M63.7886 62.0572C63.7886 58.8704 66.3719 56.2871 69.5587 56.2871H137.112C140.298 56.2871 142.882 58.8704 142.882 62.0572L142.882 68.3605C142.882 68.3605 136.229 78.2695 136.229 86.113C136.229 93.9566 136.229 193.776 136.229 193.776H70.4414C70.4414 193.776 70.4414 90.5771 70.4414 86.113C70.4414 81.649 63.7886 68.3605 63.7886 68.3605V62.0572Z"
          fill="#D6D6D6"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M78.6116 97.6228L78.6106 97.8369C78.6106 97.8377 78.6106 97.8385 78.6106 97.8394C78.612 110.957 89.7667 121.68 103.64 121.68C117.509 121.68 128.661 110.964 128.67 97.8531C128.413 88.7741 128.955 82.2076 130.822 76.1607C132.522 70.6549 135.297 65.6507 139.439 59.6189L67.3403 59.619C71.1261 64.7088 73.8907 69.2016 75.7284 74.5664C77.7843 80.5681 78.6519 87.5761 78.6116 97.6228ZM65.8986 59.619C65.612 59.2385 65.3194 58.8541 65.0208 58.4649L141.649 58.4648C141.374 58.8543 141.105 59.2388 140.841 59.6189C131.848 72.5739 129.325 80.2874 129.824 97.8369C129.824 111.642 118.101 122.834 103.64 122.834C89.1795 122.834 77.4566 111.642 77.4566 97.8369L77.4576 97.6176C77.535 78.3105 74.2319 70.6784 65.8986 59.619Z"
          fill="url(#paint2_linear)"
        />
        <path
          d="M76.6013 185.881C97.5446 182.36 109.425 182.449 130.808 185.881V193.732H76.6013V185.881Z"
          fill="#7E7E7E"
        />
        <path
          d="M94.2966 68.1248C94.2966 66.2128 95.8467 64.6627 97.7587 64.6627H108.911C110.823 64.6627 112.373 66.2127 112.373 68.1248V78.9469C112.373 80.859 110.823 82.409 108.911 82.409H97.7587C95.8467 82.409 94.2966 80.859 94.2966 78.9469V68.1248Z"
          fill="#7AACC8"
        />
        <path
          d="M94.2966 68.1248C94.2966 66.2128 95.8467 64.6627 97.7587 64.6627H108.911C110.823 64.6627 112.373 66.2127 112.373 68.1248V78.9469C112.373 80.859 110.823 82.409 108.911 82.409H97.7587C95.8467 82.409 94.2966 80.859 94.2966 78.9469V68.1248Z"
          fill="#7AACC8"
        />
        <path
          d="M94.2969 68.0104C94.2969 66.1615 95.7892 64.6627 97.63 64.6627H108.367C110.208 64.6627 111.7 66.1615 111.7 68.0104V78.475C111.7 80.3239 110.208 81.8227 108.367 81.8227H97.63C95.7892 81.8227 94.2969 80.3239 94.2969 78.475V68.0104Z"
          fill="#7AACC8"
        />
        <path
          d="M94.2969 68.0104C94.2969 66.1615 95.7892 64.6627 97.63 64.6627H108.367C110.208 64.6627 111.7 66.1615 111.7 68.0104V78.475C111.7 80.3239 110.208 81.8227 108.367 81.8227H97.63C95.7892 81.8227 94.2969 80.3239 94.2969 78.475V68.0104Z"
          fill="#85B9D6"
        />
        <path
          d="M97.8341 131.053C97.688 129.861 98.6182 128.809 99.8193 128.809H106.664C107.868 128.809 108.799 129.865 108.648 131.06L107.957 136.531C107.831 137.53 106.981 138.28 105.973 138.28H100.49C99.4795 138.28 98.6278 137.526 98.5049 136.523L97.8341 131.053Z"
          fill="#B9B9B9"
        />
        <path
          d="M91.9184 128.809H85.4616C85.2704 128.809 85.0741 128.837 84.8929 128.898C79.4272 130.734 83.1797 136.579 85.3654 136.848L92.2769 137.864C93.5873 138.057 94.7196 136.946 94.5516 135.632L93.9022 130.556C93.7745 129.557 92.9249 128.809 91.9184 128.809Z"
          fill="#B9B9B9"
        />
        <path
          d="M114.574 128.809H121.03C121.222 128.809 121.418 128.837 121.599 128.898C127.065 130.734 123.312 136.579 121.127 136.848L114.215 137.864C112.905 138.057 111.772 136.946 111.94 135.632L112.59 130.556C112.717 129.557 113.567 128.809 114.574 128.809Z"
          fill="#B9B9B9"
        />
        <path
          d="M98.5888 131.511C98.4426 130.319 99.3728 129.268 100.574 129.268H107.419C108.623 129.268 109.554 130.324 109.403 131.518L108.712 136.989C108.586 137.989 107.736 138.738 106.728 138.738H101.245C100.234 138.738 99.3825 137.985 99.2595 136.982L98.5888 131.511Z"
          fill="#FBFBFB"
        />
        <path
          d="M92.673 129.268H86.2162C86.025 129.268 85.8288 129.295 85.6475 129.356C80.1818 131.192 83.9343 137.037 86.1201 137.307L93.0315 138.323C94.3419 138.515 95.4743 137.404 95.3062 136.09L94.6569 131.014C94.5292 130.015 93.6795 129.268 92.673 129.268Z"
          fill="#FBFBFB"
        />
        <path
          d="M115.328 129.268H121.785C121.976 129.268 122.172 129.295 122.354 129.356C127.819 131.192 124.067 137.037 121.881 137.307L114.97 138.323C113.659 138.515 112.527 137.404 112.695 136.09L113.344 131.014C113.472 130.015 114.322 129.268 115.328 129.268Z"
          fill="#FBFBFB"
        />
        <path
          d="M97.8341 143.906C97.688 142.714 98.6182 141.663 99.8193 141.663H106.664C107.868 141.663 108.799 142.719 108.648 143.913L107.957 149.384C107.831 150.384 106.981 151.133 105.973 151.133H100.49C99.4795 151.133 98.6278 150.38 98.5049 149.377L97.8341 143.906Z"
          fill="#B9B9B9"
        />
        <path
          d="M91.9184 141.663H85.4616C85.2704 141.663 85.0741 141.69 84.8929 141.751C79.4272 143.587 83.1797 149.432 85.3654 149.702L92.2769 150.718C93.5873 150.91 94.7196 149.799 94.5516 148.485L93.9022 143.409C93.7745 142.411 92.9249 141.663 91.9184 141.663Z"
          fill="#B9B9B9"
        />
        <path
          d="M114.574 141.663H121.03C121.222 141.663 121.418 141.69 121.599 141.751C127.065 143.587 123.312 149.432 121.127 149.702L114.215 150.718C112.905 150.91 111.772 149.799 111.94 148.485L112.59 143.409C112.717 142.411 113.567 141.663 114.574 141.663Z"
          fill="#B9B9B9"
        />
        <path
          d="M98.5888 144.364C98.4426 143.172 99.3728 142.121 100.574 142.121H107.419C108.623 142.121 109.554 143.177 109.403 144.371L108.712 149.842C108.586 150.842 107.736 151.591 106.728 151.591H101.245C100.234 151.591 99.3825 150.838 99.2595 149.835L98.5888 144.364Z"
          fill="#FBFBFB"
        />
        <path
          d="M92.673 142.121H86.2162C86.025 142.121 85.8288 142.148 85.6475 142.209C80.1818 144.045 83.9343 149.89 86.1201 150.16L93.0315 151.176C94.3419 151.368 95.4743 150.257 95.3062 148.943L94.6569 143.867C94.5292 142.869 93.6795 142.121 92.673 142.121Z"
          fill="#FBFBFB"
        />
        <path
          d="M115.328 142.121H121.785C121.976 142.121 122.172 142.148 122.354 142.209C127.819 144.045 124.067 149.89 121.881 150.16L114.97 151.176C113.659 151.368 112.527 150.257 112.695 148.943L113.344 143.867C113.472 142.869 114.322 142.121 115.328 142.121Z"
          fill="#FBFBFB"
        />
        <path
          d="M97.8341 156.76C97.688 155.568 98.6182 154.516 99.8193 154.516H106.664C107.868 154.516 108.799 155.572 108.648 156.767L107.957 162.238C107.831 163.237 106.981 163.987 105.973 163.987H100.49C99.4795 163.987 98.6278 163.233 98.5049 162.23L97.8341 156.76Z"
          fill="#B9B9B9"
        />
        <path
          d="M91.9184 154.516H85.4616C85.2704 154.516 85.0741 154.544 84.8929 154.605C79.4272 156.441 83.1797 162.286 85.3654 162.556L92.2769 163.571C93.5873 163.764 94.7196 162.653 94.5516 161.339L93.9022 156.263C93.7745 155.264 92.9249 154.516 91.9184 154.516Z"
          fill="#B9B9B9"
        />
        <path
          d="M114.574 154.516H121.03C121.222 154.516 121.418 154.544 121.599 154.605C127.065 156.441 123.312 162.286 121.127 162.556L114.215 163.571C112.905 163.764 111.772 162.653 111.94 161.339L112.59 156.263C112.717 155.264 113.567 154.516 114.574 154.516Z"
          fill="#B9B9B9"
        />
        <path
          d="M98.5888 157.218C98.4426 156.026 99.3728 154.975 100.574 154.975H107.419C108.623 154.975 109.554 156.031 109.403 157.225L108.712 162.696C108.586 163.696 107.736 164.445 106.728 164.445H101.245C100.234 164.445 99.3825 163.692 99.2595 162.689L98.5888 157.218Z"
          fill="#FBFBFB"
        />
        <path
          d="M92.673 154.975H86.2162C86.025 154.975 85.8288 155.002 85.6475 155.063C80.1818 156.899 83.9343 162.744 86.1201 163.014L93.0315 164.03C94.3419 164.222 95.4743 163.111 95.3062 161.797L94.6569 156.721C94.5292 155.723 93.6795 154.975 92.673 154.975Z"
          fill="#FBFBFB"
        />
        <path
          d="M115.328 154.975H121.785C121.976 154.975 122.172 155.002 122.354 155.063C127.819 156.899 124.067 162.744 121.881 163.014L114.97 164.03C113.659 164.222 112.527 163.111 112.695 161.797L113.344 156.721C113.472 155.723 114.322 154.975 115.328 154.975Z"
          fill="#FBFBFB"
        />
        <path
          d="M97.8341 169.613C97.688 168.421 98.6182 167.37 99.8193 167.37H106.664C107.868 167.37 108.799 168.426 108.648 169.62L107.957 175.091C107.831 176.091 106.981 176.84 105.973 176.84H100.49C99.4795 176.84 98.6278 176.087 98.5049 175.084L97.8341 169.613Z"
          fill="#B9B9B9"
        />
        <path
          d="M91.9184 167.37H85.4616C85.2704 167.37 85.0741 167.397 84.8929 167.458C79.4272 169.294 83.1797 175.139 85.3654 175.409L92.2769 176.425C93.5873 176.617 94.7196 175.506 94.5516 174.192L93.9022 169.116C93.7745 168.118 92.9249 167.37 91.9184 167.37Z"
          fill="#B9B9B9"
        />
        <path
          d="M114.574 167.37H121.03C121.222 167.37 121.418 167.397 121.599 167.458C127.065 169.294 123.312 175.139 121.127 175.409L114.215 176.425C112.905 176.617 111.772 175.506 111.94 174.192L112.59 169.116C112.717 168.118 113.567 167.37 114.574 167.37Z"
          fill="#B9B9B9"
        />
        <path
          d="M98.5888 170.072C98.4426 168.879 99.3728 167.828 100.574 167.828H107.419C108.623 167.828 109.554 168.884 109.403 170.079L108.712 175.549C108.586 176.549 107.736 177.299 106.728 177.299H101.245C100.234 177.299 99.3825 176.545 99.2595 175.542L98.5888 170.072Z"
          fill="#FBFBFB"
        />
        <path
          d="M92.673 167.828H86.2162C86.025 167.828 85.8288 167.855 85.6475 167.916C80.1818 169.753 83.9343 175.597 86.1201 175.867L93.0315 176.883C94.3419 177.076 95.4743 175.964 95.3062 174.651L94.6569 169.574C94.5292 168.576 93.6795 167.828 92.673 167.828Z"
          fill="#FBFBFB"
        />
        <path
          d="M115.328 167.828H121.785C121.976 167.828 122.172 167.855 122.354 167.916C127.819 169.753 124.067 175.597 121.881 175.867L114.97 176.883C113.659 177.076 112.527 175.964 112.695 174.651L113.344 169.574C113.472 168.576 114.322 167.828 115.328 167.828Z"
          fill="#FBFBFB"
        />
        <path
          d="M84.8818 94.097C84.8818 92.7187 85.9992 91.6013 87.3775 91.6013H99.0716C100.45 91.6013 101.567 92.7187 101.567 94.097C101.567 95.4753 100.45 96.5926 99.0716 96.5926H87.3775C85.9992 96.5926 84.8818 95.4753 84.8818 94.097Z"
          fill="#7E7E7E"
        />
        <path
          d="M84.8816 101.396C84.8816 100.018 85.9989 98.9004 87.3773 98.9004H99.0714C100.45 98.9004 101.567 100.018 101.567 101.396C101.567 102.774 100.45 103.892 99.0714 103.892H87.3773C85.9989 103.892 84.8816 102.774 84.8816 101.396Z"
          fill="#7E7E7E"
        />
        <path
          d="M84.8816 108.696C84.8816 107.317 85.9989 106.2 87.3773 106.2H99.0714C100.45 106.2 101.567 107.317 101.567 108.696C101.567 110.074 100.45 111.191 99.0714 111.191H87.3773C85.9989 111.191 84.8816 110.074 84.8816 108.696Z"
          fill="#7E7E7E"
        />
        <path
          d="M105.104 94.097C105.104 92.7187 106.222 91.6013 107.6 91.6013H119.294C120.673 91.6013 121.79 92.7187 121.79 94.097C121.79 95.4753 120.673 96.5926 119.294 96.5926H107.6C106.222 96.5926 105.104 95.4753 105.104 94.097Z"
          fill="#7E7E7E"
        />
        <path
          d="M105.104 101.396C105.104 100.018 106.221 98.9005 107.6 98.9005H119.294C120.672 98.9005 121.789 100.018 121.789 101.396C121.789 102.774 120.672 103.892 119.294 103.892H107.6C106.221 103.892 105.104 102.774 105.104 101.396Z"
          fill="#7E7E7E"
        />
        <path
          d="M105.104 108.696C105.104 107.317 106.221 106.2 107.6 106.2H119.294C120.672 106.2 121.789 107.317 121.789 108.696C121.789 110.074 120.672 111.191 119.294 111.191H107.6C106.221 111.191 105.104 110.074 105.104 108.696Z"
          fill="#7E7E7E"
        />
        <path
          d="M230.915 201.033C230.338 199.212 229.632 197.438 228.807 195.718L199.74 151.642C198.635 149.994 196.961 148.947 195.156 148.589C193.316 148.228 191.333 148.577 189.661 149.737C186.412 151.994 185.675 156.507 187.877 159.791L185.703 156.548C183.146 152.736 177.985 151.721 174.172 154.277C172.268 155.554 171.056 157.485 170.645 159.572C170.233 161.658 170.619 163.902 171.896 165.807L168.704 161.046C166.148 157.234 160.987 156.214 157.174 158.77C155.267 160.049 154.061 161.976 153.647 164.065C153.238 166.154 153.621 168.395 154.9 170.303L138.721 146.719C136.164 142.906 131.003 141.891 127.193 144.445C125.286 145.724 124.077 147.654 123.664 149.737C123.252 151.829 123.635 154.069 124.914 155.977L146.824 188.107C145.538 188.329 144.27 188.764 143.08 189.425C142.764 189.593 142.458 189.781 142.157 189.982C138.783 192.245 137.962 196.775 140.159 200.051C140.341 200.322 140.547 200.586 140.772 200.837C142.653 202.959 143.547 205.786 143.216 208.605L142.65 213.465C142.216 217.192 144.002 220.829 147.216 222.762L166.01 234.072C168.805 235.754 172.011 236.642 175.272 236.628C177.025 236.62 178.864 236.553 180.179 236.354C181.539 236.147 182.902 236.343 184.111 236.876C185.326 237.406 186.385 238.277 187.153 239.421L206.656 265.793L252.694 234.922C251.181 232.666 235.08 211.021 233.908 208.583C232.731 206.145 231.731 203.622 230.915 201.033Z"
          fill="#FFC6AB"
          stroke="#F1B18F"
          strokeWidth={2}
          strokeMiterlimit={16}
          strokeLinejoin="round"
        />
        <path
          d="M145.69 188.375L158.145 206.949C158.621 206.63 158.846 206.033 158.825 205.33C158.803 204.623 158.536 203.806 158.026 203.047L146.939 186.512C146.386 187.002 145.97 187.637 145.69 188.375Z"
          fill="#F1B18F"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="246.694"
          y1="111.724"
          x2="153.882"
          y2="111.724"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BCD5DF" />
          <stop offset={1} stopColor="#90B2C1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="105.501"
          y1="43.5596"
          x2="52.2687"
          y2="187.569"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#969696" />
          <stop offset="0.159564" stopColor="#9B9B9B" />
          <stop offset="0.201231" stopColor="#424242" />
          <stop offset={1} stopColor="#3E3E3E" />
        </linearGradient>
        <linearGradient
          id="paint2_linear"
          x1="103.274"
          y1="57.0208"
          x2="103.274"
          y2="122.834"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CACACA" stopOpacity={0} />
          <stop offset={1} stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export const IconMarker = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12.0996 12.2515C10.9996 12.2515 10.0996 11.3515 10.0996 10.2515C10.0996 9.15146 10.9996 8.25146 12.0996 8.25146C13.1996 8.25146 14.0996 9.15146 14.0996 10.2515C14.0996 11.3515 13.1996 12.2515 12.0996 12.2515ZM18.0996 10.4515C18.0996 6.82146 15.4496 4.25146 12.0996 4.25146C8.74961 4.25146 6.09961 6.82146 6.09961 10.4515C6.09961 12.7915 8.04961 15.8915 12.0996 19.5915C16.1496 15.8915 18.0996 12.7915 18.0996 10.4515ZM12.0996 2.25146C16.2996 2.25146 20.0996 5.47146 20.0996 10.4515C20.0996 13.7715 17.4296 17.7015 12.0996 22.2515C6.76961 17.7015 4.09961 13.7715 4.09961 10.4515C4.09961 5.47146 7.89961 2.25146 12.0996 2.25146Z" />
  </svg>
)

export const IconArrowLeft = () => (
  <svg
    width="23"
    height="9"
    viewBox="0 0 23 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M22.95 3.92122H2.65294L5.03961 1.52789L4.09961 0.587891L0.0996094 4.58789L4.09961 8.58789L5.03961 7.64789L2.65294 5.25456H22.95V3.92122Z" />
  </svg>
)

export const IconArrowLeft2 = () => (
  <svg
    width="13"
    height="11"
    viewBox="0 0 13 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1 5.5H13M1 5.5L9 0.5M1 5.5L9 10.5" stroke="currentColor" />
  </svg>
)

export const IconAddBusiness = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="IconAddBusiness"
    >
      <path d="M33.9998 8H3.99976V12H33.9998V8Z" fill="#FA6100" />
      <path
        d="M29.9999 34H33.9999V28H35.9999V24L33.9999 14H3.99988L1.99988 24V28H3.99988V40H21.9999V28H29.9999V34ZM17.9999 36H7.99988V28H17.9999V36ZM6.07988 24L7.27988 18H30.7199L31.9199 24H6.07988Z"
        fill="#FA6100"
      />
      <path d="M46 36H40V30H36V36H30V40H36V46H40V40H46V36Z" fill="#FA6100" />
    </svg>
  )
}

export const IconTime = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.274 2.563c-5.52 0-9.99 4.48-9.99 10s4.47 10 9.99 10c5.53 0 10.01-4.48 10.01-10s-4.48-10-10.01-10zm.01 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13h-1.5v6l5.25 3.15.75-1.23-4.5-2.67v-5.25z"
        fill="#666"
      />
    </svg>
  )
}

export const IconFasterResponse = () => {
  return (
    <svg
      width="36"
      height="30"
      viewBox="0 0 36 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1996_13413)">
        <path d="M6.02078 17.5391H0.735457C0.540402 17.5391 0.353335 17.6165 0.21541 17.7545C0.0774854 17.8924 0 18.0795 0 18.2745C0 18.4696 0.0774854 18.6566 0.21541 18.7946C0.353335 18.9325 0.540402 19.01 0.735457 19.01H6.02078C6.21583 19.01 6.4029 18.9325 6.54082 18.7946C6.67875 18.6566 6.75623 18.4696 6.75623 18.2745C6.75623 18.0795 6.67875 17.8924 6.54082 17.7545C6.4029 17.6165 6.21583 17.5391 6.02078 17.5391Z" />
        <path d="M35.2644 17.5391H29.9791C29.7841 17.5391 29.597 17.6165 29.4591 17.7545C29.3211 17.8924 29.2437 18.0795 29.2437 18.2745C29.2437 18.4696 29.3211 18.6566 29.4591 18.7946C29.597 18.9325 29.7841 19.01 29.9791 19.01H35.2644C35.4595 19.01 35.6466 18.9325 35.7845 18.7946C35.9224 18.6566 35.9999 18.4696 35.9999 18.2745C35.9999 18.0795 35.9224 17.8924 35.7845 17.7545C35.6466 17.6165 35.4595 17.5391 35.2644 17.5391Z" />
        <path d="M17.9999 6.84349C18.1884 6.83389 18.366 6.75219 18.4959 6.61529C18.6259 6.47839 18.6982 6.29678 18.698 6.10803V0.735457C18.698 0.540402 18.6205 0.353335 18.4826 0.21541C18.3446 0.0774854 18.1576 0 17.9625 0C17.7675 0 17.5804 0.0774854 17.4425 0.21541C17.3045 0.353335 17.2271 0.540402 17.2271 0.735457V6.10803C17.2271 6.30309 17.3045 6.49016 17.4425 6.62808C17.5804 6.76601 17.7675 6.84349 17.9625 6.84349" />
        <path d="M8.83798 9.96957C8.97518 10.1101 9.16257 10.1903 9.35894 10.1927C9.55531 10.195 9.74456 10.1192 9.88507 9.98204C10.0256 9.84484 10.1058 9.65744 10.1082 9.46107C10.1105 9.2647 10.0347 9.07545 9.89754 8.93494L6.31997 5.35738C6.17867 5.22323 5.99127 5.14844 5.79643 5.14844C5.60159 5.14844 5.41418 5.22323 5.27288 5.35738C5.13584 5.49719 5.05908 5.68516 5.05908 5.88093C5.05908 6.0767 5.13584 6.26467 5.27288 6.40447L8.83798 9.96957Z" />
        <path d="M26.6258 10.2485C26.7227 10.2494 26.8189 10.2311 26.9087 10.1948C26.9986 10.1584 27.0803 10.1046 27.1493 10.0366L30.7269 6.39666C30.8639 6.25685 30.9407 6.06889 30.9407 5.87312C30.9407 5.67734 30.8639 5.48938 30.7269 5.34957C30.5856 5.21542 30.3982 5.14062 30.2034 5.14062C30.0085 5.14062 29.8211 5.21542 29.6798 5.34957L26.1023 8.98946C26.0077 9.0949 25.945 9.22503 25.9215 9.3647C25.898 9.50437 25.9146 9.64785 25.9695 9.77843C26.0243 9.90902 26.1151 10.0213 26.2313 10.1023C26.3475 10.1834 26.4843 10.2297 26.6258 10.236" />
        <path d="M26.3394 27.6571C26.3411 27.7389 26.3266 27.8203 26.2968 27.8966C26.267 27.9728 26.2224 28.0425 26.1657 28.1015C26.109 28.1605 26.0412 28.2078 25.9662 28.2406C25.8912 28.2735 25.8105 28.2912 25.7286 28.2928H10.6081C10.5242 28.2945 10.4407 28.2792 10.3628 28.2479C10.2849 28.2165 10.2142 28.1698 10.1548 28.1104C10.0954 28.051 10.0487 27.9803 10.0173 27.9024C9.98598 27.8245 9.97069 27.741 9.97239 27.6571V26.1737C9.97073 26.0919 9.98522 26.0105 10.015 25.9342C10.0448 25.858 10.0894 25.7883 10.1461 25.7293C10.2028 25.6703 10.2706 25.623 10.3456 25.5902C10.4206 25.5573 10.5013 25.5396 10.5832 25.538H25.7286C25.8105 25.5396 25.8912 25.5573 25.9662 25.5902C26.0412 25.623 26.109 25.6703 26.1657 25.7293C26.2224 25.7883 26.267 25.858 26.2968 25.9342C26.3266 26.0105 26.3411 26.0919 26.3394 26.1737V27.6571ZM14.8463 14.182H21.1912L24.0957 24.1543H11.9295L14.8463 14.182ZM25.7286 24.1543H25.604L22.4378 13.2347C22.3938 13.0812 22.3002 12.9466 22.1717 12.8519C22.0431 12.7572 21.8869 12.7077 21.7272 12.7111H14.2854C14.1279 12.7104 13.9745 12.7612 13.8485 12.8557C13.7225 12.9502 13.6308 13.0833 13.5873 13.2347L10.3962 24.1294C9.88904 24.184 9.41922 24.4218 9.07495 24.7982C8.73067 25.1746 8.53562 25.6637 8.5264 26.1737V27.6197C8.52476 27.8947 8.57731 28.1674 8.68103 28.4221C8.78476 28.6768 8.93764 28.9085 9.13095 29.1042C9.32426 29.2998 9.5542 29.4554 9.80766 29.5622C10.0611 29.6689 10.3331 29.7247 10.6081 29.7263H25.7286C26.0036 29.7247 26.2756 29.6689 26.5291 29.5622C26.7825 29.4554 27.0125 29.2998 27.2058 29.1042C27.3991 28.9085 27.552 28.6768 27.6557 28.4221C27.7594 28.1674 27.812 27.8947 27.8103 27.6197V26.1737C27.812 25.8987 27.7594 25.6261 27.6557 25.3713C27.552 25.1166 27.3991 24.8849 27.2058 24.6892C27.0125 24.4936 26.7825 24.338 26.5291 24.2312C26.2756 24.1245 26.0036 24.0687 25.7286 24.0671" />
      </g>
      <defs>
        <clipPath id="clip0_1996_13413">
          <rect width="36" height="29.7673" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconCarbonEmissions = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3.16406 6.32812C4.90873 6.32812 6.32812 4.90873 6.32812 3.16406C6.32812 1.4194 4.90873 0 3.16406 0C1.4194 0 0 1.4194 0 3.16406C0 4.90873 1.4194 6.32812 3.16406 6.32812ZM3.16406 1.05469C4.32717 1.05469 5.27344 2.00095 5.27344 3.16406C5.27344 4.32717 4.32717 5.27344 3.16406 5.27344C2.00095 5.27344 1.05469 4.32717 1.05469 3.16406C1.05469 2.00095 2.00095 1.05469 3.16406 1.05469ZM18 22.227C16.3351 22.227 14.7698 22.8755 13.5925 24.0527C13.216 24.4292 12.8943 24.8457 12.6299 25.2921H6.19664C4.82358 25.2921 3.53236 24.7572 2.56092 23.7857C1.58955 22.815 1.05469 21.5239 1.05469 20.1502C1.05469 19.0289 1.4092 17.9634 2.07991 17.0689C2.7289 16.2034 3.65231 15.5524 4.68 15.2358C5.2032 15.0744 5.55469 14.5934 5.55469 14.033C5.55469 12.2678 6.18293 10.5559 7.32361 9.21227C7.51212 8.99023 7.48491 8.65744 7.26293 8.46893C7.04102 8.28049 6.70816 8.30763 6.51966 8.52961C5.21726 10.0637 4.5 12.0181 4.5 14.0386C4.5 14.1278 4.44741 14.2038 4.36936 14.2278C3.13045 14.6095 2.01776 15.3937 1.23609 16.4362C0.42743 17.5146 0 18.7989 0 20.1502C0 21.8058 0.644695 23.3618 1.81526 24.5315C2.98582 25.702 4.54184 26.3467 6.19664 26.3467H12.1328C11.8924 27.0157 11.7669 27.7282 11.7669 28.4603C11.7669 30.1252 12.4152 31.6904 13.5925 32.8678C14.8077 34.0829 16.4039 34.6905 18.0001 34.6905C19.5962 34.6905 21.1925 34.0829 22.4076 32.8678C23.5849 31.6905 24.2333 30.1252 24.2333 28.4603C24.2333 26.7952 23.5849 25.23 22.4076 24.0526C21.2302 22.8755 19.6649 22.227 18 22.227ZM12.8215 28.4603C12.8215 27.0759 13.3653 25.7715 14.3382 24.7986C15.3163 23.8205 16.6167 23.2818 18 23.2818C19.2059 23.2818 20.3486 23.6914 21.27 24.4446L13.9842 31.7303C13.2311 30.809 12.8215 29.6661 12.8215 28.4603ZM21.6618 32.122C19.7685 34.0153 16.7621 34.1333 14.73 32.476L22.0158 25.1902C22.7689 26.1115 23.1785 27.2543 23.1785 28.4603C23.1785 29.8434 22.6399 31.1439 21.6618 32.122ZM26.7853 22.7599C26.7816 22.471 26.5463 22.2393 26.2581 22.2393C26.2558 22.2393 26.2536 22.2393 26.2513 22.2394C25.8886 22.2439 25.5056 22.247 25.1722 22.2482C25.3916 21.9528 25.6835 21.5515 26.0637 21.0082C26.3289 20.6292 26.5022 20.2699 26.5788 19.9402C26.8018 18.9792 25.9874 18.093 25.0422 18.093C24.2936 18.093 23.6455 18.6256 23.5014 19.3596C23.4453 19.6453 23.6314 19.9225 23.9172 19.9787C24.2031 20.0346 24.4802 19.8486 24.5363 19.5628C24.5836 19.3223 24.7963 19.1478 25.0422 19.1478C25.3543 19.1478 25.6218 19.4295 25.5457 19.725C25.4965 19.9159 25.3773 20.1498 25.1996 20.4035C24.5548 21.3249 24.1701 21.8287 23.9633 22.0992C23.7021 22.4412 23.571 22.6129 23.6597 22.9011C23.7123 23.0721 23.8414 23.2031 24.0141 23.2606C24.0832 23.2836 24.1453 23.3043 24.9525 23.3043C25.2643 23.3043 25.6872 23.3012 26.2645 23.294C26.5558 23.2902 26.7889 23.0512 26.7853 22.7599ZM32.8359 29.6719C31.0913 29.6719 29.6719 31.0913 29.6719 32.8359C29.6719 34.5806 31.0913 36 32.8359 36C34.5806 36 36 34.5806 36 32.8359C36 31.0913 34.5806 29.6719 32.8359 29.6719ZM32.8359 34.9453C31.6728 34.9453 30.7266 33.999 30.7266 32.8359C30.7266 31.6728 31.6728 30.7266 32.8359 30.7266C33.999 30.7266 34.9453 31.6728 34.9453 32.8359C34.9453 33.999 33.999 34.9453 32.8359 34.9453ZM36 20.1502C36 18.4945 35.3553 16.9385 34.1847 15.7688C33.0142 14.5983 31.4582 13.9536 29.8034 13.9536C29.6736 13.9536 29.4941 13.972 29.4427 13.8211C28.4235 10.8226 25.6097 8.80805 22.4409 8.80805C21.6578 8.80805 20.8863 8.93004 20.1475 9.17086C20.0713 9.19596 19.9864 9.16537 19.9367 9.09591C18.3413 6.85997 15.751 5.52516 13.0078 5.52516C11.4045 5.52516 9.84234 5.97375 8.49045 6.82235C8.24379 6.97718 8.16933 7.30273 8.32416 7.54938C8.47891 7.79604 8.80446 7.87036 9.05112 7.71567C10.2349 6.97261 11.603 6.57984 13.0078 6.57984C15.411 6.57984 17.6803 7.74942 19.0786 9.70903C19.3978 10.1552 19.9588 10.3418 20.4746 10.1735C21.1074 9.96722 21.769 9.86266 22.4409 9.86266C25.1578 9.86266 27.5704 11.5898 28.4445 14.1616C28.6268 14.6977 29.2136 15.0082 29.8034 15.0082C31.1764 15.0082 32.4676 15.5431 33.4391 16.5146C34.4104 17.4853 34.9453 18.7764 34.9453 20.1502C34.9453 22.9854 32.6386 25.2921 29.8034 25.2921H26.0324C25.7412 25.2921 25.5051 25.5281 25.5051 25.8195C25.5051 26.1108 25.7412 26.3468 26.0324 26.3468H29.8034C33.2202 26.3468 36 23.567 36 20.1502ZM12.6753 15.1069C13.1575 15.1069 13.6226 15.2489 14.0201 15.5175C14.2615 15.6804 14.5892 15.617 14.7523 15.3757C14.9153 15.1343 14.8518 14.8065 14.6104 14.6435C14.0379 14.2567 13.3687 14.0522 12.6752 14.0522C10.767 14.0522 9.21459 15.6047 9.21459 17.5129C9.21459 19.4211 10.767 20.9735 12.6752 20.9735C13.5811 20.9735 14.3726 20.6183 14.9272 19.9569C15.1144 19.7338 15.0852 19.4012 14.862 19.2141C14.6389 19.0269 14.3063 19.0561 14.1191 19.2793C13.7626 19.7044 13.2732 19.9189 12.6752 19.9189C11.3486 19.9189 10.2693 18.8396 10.2693 17.5129C10.2693 16.1863 11.3487 15.1069 12.6753 15.1069ZM22.6865 17.5128C22.6865 15.6046 21.134 14.0522 19.2258 14.0522C17.3176 14.0522 15.7652 15.6046 15.7652 17.5128C15.7652 19.421 17.3176 20.9734 19.2258 20.9734C21.134 20.9734 22.6865 19.421 22.6865 17.5128ZM16.8199 17.5128C16.8199 16.1861 17.8992 15.1069 19.2259 15.1069C20.5526 15.1069 21.6319 16.1861 21.6319 17.5128C21.6319 18.8395 20.5526 19.9188 19.2259 19.9188C17.8992 19.9188 16.8199 18.8395 16.8199 17.5128Z" />
    </svg>
  )
}

export const IconIncreasedSecurity = () => {
  return (
    <svg
      width="23"
      height="28"
      viewBox="0 0 23 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1996_13441)">
        <path d="M11.5003 20.504C11.385 20.5176 11.2682 20.5065 11.1576 20.4713C11.0469 20.4361 10.9449 20.3777 10.8582 20.3C10.7715 20.2222 10.7022 20.1269 10.6547 20.0201C10.6072 19.9134 10.5826 19.7978 10.5826 19.6808C10.5826 19.5639 10.6072 19.4483 10.6547 19.3416C10.7022 19.2348 10.7715 19.1395 10.8582 19.0617C10.9449 18.984 11.0469 18.9256 11.1576 18.8904C11.2682 18.8552 11.385 18.8441 11.5003 18.8576C11.6155 18.8441 11.7323 18.8552 11.843 18.8904C11.9536 18.9256 12.0556 18.984 12.1423 19.0617C12.229 19.1395 12.2984 19.2348 12.3459 19.3416C12.3934 19.4483 12.4179 19.5639 12.4179 19.6808C12.4179 19.7978 12.3934 19.9134 12.3459 20.0201C12.2984 20.1269 12.229 20.2222 12.1423 20.3C12.0556 20.3777 11.9536 20.4361 11.843 20.4713C11.7323 20.5065 11.6155 20.5176 11.5003 20.504ZM11.5003 17.5472C10.99 17.5376 10.4936 17.7146 10.1028 18.0455C9.71206 18.3764 9.45344 18.8388 9.37482 19.3471C9.2962 19.8553 9.4029 20.3751 9.67518 20.8102C9.94746 21.2453 10.3669 21.5662 10.8558 21.7136V23.1472C10.8765 23.3063 10.9538 23.4523 11.0734 23.5581C11.193 23.6639 11.3467 23.7222 11.5058 23.7222C11.6649 23.7222 11.8186 23.6639 11.9382 23.5581C12.0578 23.4523 12.1352 23.3063 12.1558 23.1472V21.7024C12.6367 21.5477 13.0467 21.2245 13.3114 20.7912C13.5761 20.358 13.6781 19.8435 13.5988 19.341C13.5195 18.8385 13.2643 18.3812 12.8793 18.0522C12.4943 17.7231 12.005 17.544 11.5003 17.5472Z" />
        <path d="M21.7 25.6795C21.7015 25.8114 21.677 25.9422 21.628 26.0644C21.5789 26.1867 21.5063 26.2979 21.4143 26.3916C21.3224 26.4854 21.2129 26.5598 21.0922 26.6106C20.9714 26.6614 20.8419 26.6875 20.7111 26.6875H2.30003C2.03481 26.6875 1.78046 26.5813 1.59292 26.3923C1.40538 26.2033 1.30003 25.9469 1.30003 25.6795V15.6779C1.30002 15.5461 1.32596 15.4155 1.37635 15.2939C1.42674 15.1722 1.50058 15.0618 1.59358 14.9691C1.68659 14.8764 1.79692 14.8032 1.91818 14.7538C2.03945 14.7043 2.16923 14.6796 2.30003 14.6811H20.7111C20.9734 14.6811 21.2249 14.7861 21.4104 14.9731C21.5958 15.16 21.7 15.4136 21.7 15.6779V25.6795ZM5.48892 7.32272C5.48892 5.71572 6.12223 4.17454 7.24953 3.03822C8.37683 1.9019 9.90578 1.26353 11.5 1.26353C13.0943 1.26353 14.6232 1.9019 15.7505 3.03822C16.8778 4.17454 17.5111 5.71572 17.5111 7.32272V13.3483H5.48892V7.32272ZM20.7111 13.3483H18.8111V7.32272C18.8111 5.36819 18.0409 3.4937 16.6698 2.11163C15.2987 0.729563 13.4391 -0.046875 11.5 -0.046875C9.561 -0.046875 7.70139 0.729563 6.33029 2.11163C4.95919 3.4937 4.18892 5.36819 4.18892 7.32272V13.3483H2.30003C1.99705 13.3483 1.69706 13.4087 1.41728 13.5259C1.13751 13.6431 0.883461 13.8149 0.66974 14.0313C0.45602 14.2478 0.286835 14.5047 0.171905 14.7873C0.0569742 15.0698 -0.00143682 15.3725 2.68409e-05 15.6779V25.7579C0.020207 26.3591 0.271408 26.9289 0.700574 27.3468C1.12974 27.7648 1.70327 27.9983 2.30003 27.9979H20.7111C21.3192 27.995 21.9014 27.7494 22.3303 27.3149C22.7592 26.8805 23 26.2925 23 25.6795V15.6779C23 15.066 22.7589 14.4792 22.3296 14.0465C21.9004 13.6138 21.3182 13.3707 20.7111 13.3707" />
      </g>
      <defs>
        <clipPath id="clip0_1996_13441">
          <rect width="23" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconInstantAnalytics = () => {
  return (
    <svg
      width="23"
      height="26"
      viewBox="0 0 23 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1996_13446)">
        <path d="M19.6207 7.80781C19.1801 7.80767 18.7496 7.67531 18.3841 7.42763C18.0186 7.17995 17.7348 6.8282 17.5688 6.41731C17.4028 6.00643 17.3623 5.55506 17.4524 5.12088C17.5425 4.68669 17.7591 4.2894 18.0745 3.97975C18.39 3.6701 18.79 3.46216 19.2234 3.38249C19.6568 3.30281 20.1039 3.35503 20.5077 3.53245C20.9115 3.70988 21.2536 4.00447 21.4903 4.37858C21.727 4.7527 21.8475 5.18936 21.8365 5.63278C21.8365 6.22442 21.603 6.79183 21.1875 7.21019C20.772 7.62855 20.2084 7.86358 19.6207 7.86358V7.80781ZM22.9998 5.68855C22.9998 4.8927 22.7227 4.12204 22.2166 3.51066C21.7105 2.89927 21.0076 2.48586 20.23 2.34234V0.613471C20.23 0.450768 20.1658 0.294729 20.0516 0.179681C19.9373 0.0646333 19.7823 8.85682e-09 19.6207 8.85682e-09C19.5412 -1.37174e-05 19.4625 0.0159274 19.3892 0.0468918C19.3158 0.0778561 19.2494 0.123223 19.1937 0.18034C19.138 0.237457 19.0942 0.305178 19.0648 0.379547C19.0353 0.453916 19.021 0.53344 19.0224 0.613471V2.34234C18.1409 2.34234 17.2955 2.69489 16.6722 3.32242C16.0489 3.94996 15.6987 4.80108 15.6987 5.68855C15.6987 6.57601 16.0489 7.42713 16.6722 8.05467C17.2955 8.6822 18.1409 9.03475 19.0224 9.03475V25.3977C19.0224 25.5574 19.0855 25.7106 19.1977 25.8236C19.3099 25.9365 19.462 26 19.6207 26C19.7804 26 19.9337 25.9369 20.0477 25.8243C20.1617 25.7116 20.2271 25.5584 20.23 25.3977V9.01244C21.0125 8.87937 21.7218 8.46888 22.2298 7.85517C22.7377 7.24146 23.0109 6.46503 22.9998 5.66624" />
        <path d="M11.4999 15.1806C11.0594 15.1805 10.6288 15.0481 10.2633 14.8004C9.89785 14.5527 9.614 14.201 9.44804 13.7901C9.28209 13.3792 9.24156 12.9279 9.33165 12.4937C9.42173 12.0595 9.63833 11.6622 9.95378 11.3526C10.2692 11.0429 10.6692 10.835 11.1026 10.7553C11.536 10.6756 11.9832 10.7278 12.387 10.9053C12.7908 11.0827 13.1329 11.3773 13.3695 11.7514C13.6062 12.1255 13.7268 12.5622 13.7157 13.0056C13.7013 13.5875 13.4615 14.1407 13.0475 14.5471C12.6335 14.9534 12.0781 15.1808 11.4999 15.1806ZM12.1093 9.65937V0.613471C12.1093 0.450768 12.0451 0.294729 11.9308 0.179681C11.8165 0.0646333 11.6615 0 11.4999 0C11.3383 0 11.1833 0.0646333 11.0691 0.179681C10.9548 0.294729 10.8906 0.450768 10.8906 0.613471V9.65937C10.0091 9.65937 9.1637 10.0119 8.54038 10.6395C7.91707 11.267 7.56689 12.1181 7.56689 13.0056C7.56689 13.893 7.91707 14.7442 8.54038 15.3717C9.1637 15.9992 10.0091 16.3518 10.8906 16.3518V25.4088C10.8906 25.5715 10.9548 25.7276 11.0691 25.8426C11.1833 25.9577 11.3383 26.0223 11.4999 26.0223C11.6615 26.0223 11.8165 25.9577 11.9308 25.8426C12.0451 25.7276 12.1093 25.5715 12.1093 25.4088V16.3406C12.9908 16.3406 13.8362 15.9881 14.4595 15.3605C15.0828 14.733 15.433 13.8819 15.433 12.9944C15.433 12.107 15.0828 11.2558 14.4595 10.6283C13.8362 10.0008 12.9908 9.64822 12.1093 9.64822" />
        <path d="M3.37911 22.5088C2.93854 22.5087 2.50801 22.3763 2.14252 22.1286C1.77703 21.8809 1.49318 21.5292 1.32722 21.1183C1.16126 20.7074 1.12074 20.256 1.21082 19.8219C1.3009 19.3877 1.51751 18.9904 1.83296 18.6807C2.14841 18.3711 2.54838 18.1631 2.98179 18.0835C3.4152 18.0038 3.86236 18.056 4.26615 18.2334C4.66994 18.4109 5.01203 18.7055 5.24871 19.0796C5.48539 19.4537 5.60593 19.8903 5.59491 20.3338C5.58087 20.9062 5.34875 21.4512 4.9466 21.8561C4.54445 22.261 4.00306 22.4947 3.43451 22.5088H3.37911ZM4.04385 16.9876V0.613471C4.04385 0.450768 3.97966 0.294729 3.86538 0.179681C3.75111 0.0646333 3.59612 0 3.43451 0C3.2729 0 3.11791 0.0646333 3.00364 0.179681C2.88936 0.294729 2.82516 0.450768 2.82516 0.613471V16.9876C1.94366 16.9876 1.09827 17.3401 0.474954 17.9676C-0.148361 18.5952 -0.498535 19.4463 -0.498535 20.3338C-0.498535 21.2212 -0.148361 22.0723 0.474954 22.6999C1.09827 23.3274 1.94366 23.68 2.82516 23.68C2.82516 23.68 2.82516 23.7469 2.82516 23.7803V25.4088C2.82516 25.5715 2.88936 25.7276 3.00364 25.8426C3.11791 25.9577 3.2729 26.0223 3.43451 26.0223C3.59612 26.0223 3.75111 25.9577 3.86538 25.8426C3.97966 25.7276 4.04385 25.5715 4.04385 25.4088V23.7692C4.04385 23.7692 4.04385 23.7023 4.04385 23.6688C4.92535 23.6688 5.77075 23.3163 6.39406 22.6887C7.01738 22.0612 7.36755 21.2101 7.36755 20.3226C7.36755 19.4351 7.01738 18.584 6.39406 17.9565C5.77075 17.329 4.92535 16.9764 4.04385 16.9764" />
      </g>
      <defs>
        <clipPath id="clip0_1996_13446">
          <rect width="23" height="26" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconCostSavings = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1996_13452)">
        <path d="M20.5692 19.1602C20.4861 19.1607 20.4039 19.1436 20.3278 19.1102C20.2518 19.0768 20.1836 19.0278 20.1277 18.9663L16.4769 15.3263C16.3569 15.2064 16.2896 15.0437 16.2896 14.874C16.2896 14.7044 16.3569 14.5417 16.4769 14.4217C16.5969 14.3018 16.7596 14.2344 16.9292 14.2344C17.0989 14.2344 17.2616 14.3018 17.3815 14.4217L20.6123 17.6525L23.8431 14.4217C23.9025 14.3623 23.973 14.3152 24.0506 14.2831C24.1282 14.2509 24.2114 14.2344 24.2954 14.2344C24.3794 14.2344 24.4625 14.2509 24.5402 14.2831C24.6178 14.3152 24.6883 14.3623 24.7477 14.4217C24.8071 14.4811 24.8542 14.5516 24.8863 14.6292C24.9185 14.7069 24.935 14.79 24.935 14.874C24.935 14.958 24.9185 15.0412 24.8863 15.1188C24.8542 15.1964 24.8071 15.2669 24.7477 15.3263L21.0969 18.9663C21.0394 19.0286 20.9694 19.0781 20.8914 19.1115C20.8135 19.1449 20.7294 19.1615 20.6446 19.1602" />
        <path d="M20.5695 18.5471C20.4018 18.5443 20.2418 18.4765 20.1232 18.3579C20.0047 18.2394 19.9369 18.0794 19.9341 17.9117V9.79173C19.9341 9.62321 20.001 9.4616 20.1202 9.34244C20.2393 9.22329 20.401 9.15634 20.5695 9.15634C20.6533 9.15489 20.7366 9.17032 20.8143 9.20174C20.8921 9.23315 20.9627 9.2799 21.022 9.3392C21.0813 9.39849 21.128 9.46912 21.1595 9.54686C21.1909 9.62461 21.2063 9.70789 21.2049 9.79173V17.9117C21.2049 18.0802 21.1379 18.2419 21.0188 18.361C20.8996 18.4802 20.738 18.5471 20.5695 18.5471Z" />
        <path d="M13.9999 28C10.8856 28 7.86014 26.9615 5.40227 25.049C2.9444 23.1364 1.19443 20.4588 0.4292 17.44C-0.336025 14.4211 -0.0728081 11.2333 1.17721 8.38079C2.42722 5.52832 4.59267 3.17408 7.33095 1.69052C10.0692 0.206972 13.224 -0.321187 16.2962 0.189605C19.3684 0.700396 22.1825 2.22097 24.2934 4.51077C26.4043 6.80057 27.6915 9.72885 27.9512 12.8323C28.211 15.9358 27.4285 19.0373 25.7276 21.6462C25.6348 21.789 25.489 21.8891 25.3224 21.9244C25.1558 21.9598 24.9819 21.9275 24.8391 21.8346C24.6963 21.7418 24.5962 21.5961 24.5609 21.4294C24.5256 21.2628 24.5578 21.089 24.6507 20.9462C26.4383 18.1852 27.0816 14.837 26.4445 11.6101C25.8074 8.38322 23.9399 5.53077 21.2371 3.65632C18.5343 1.78187 15.2083 1.03248 11.9628 1.5667C8.71726 2.10093 5.8069 3.87687 3.84751 6.51875C1.88812 9.16062 1.03342 12.4612 1.46425 15.722C1.89507 18.9829 3.57763 21.9482 6.15591 23.9905C8.73419 26.0329 12.0059 26.992 15.2788 26.665C18.5517 26.338 21.569 24.7506 23.6922 22.2385C23.8024 22.1118 23.9583 22.0339 24.1258 22.0217C24.2933 22.0096 24.4588 22.0643 24.5861 22.1739C24.65 22.2276 24.7026 22.2936 24.7406 22.3681C24.7786 22.4425 24.8013 22.5238 24.8073 22.6071C24.8134 22.6905 24.8026 22.7742 24.7757 22.8533C24.7488 22.9324 24.7063 23.0053 24.6507 23.0677C23.3381 24.6117 21.706 25.8524 19.8671 26.7039C18.0282 27.5555 16.0264 27.9977 13.9999 28Z" />
        <path d="M24.1768 23.2962C24.0273 23.2931 23.8832 23.24 23.7675 23.1454C23.6386 23.0348 23.5583 22.8779 23.5442 22.7085C23.5301 22.5392 23.5833 22.3712 23.6921 22.2408C24.0458 21.8338 24.3697 21.4019 24.6614 20.9485C24.7073 20.8778 24.7668 20.8168 24.8363 20.769C24.9058 20.7213 24.9841 20.6877 25.0666 20.6702C25.1491 20.6527 25.2342 20.6516 25.3171 20.6671C25.4 20.6825 25.4791 20.714 25.5498 20.76C25.6205 20.806 25.6815 20.8654 25.7292 20.9349C25.777 21.0045 25.8106 21.0827 25.8281 21.1652C25.8456 21.2477 25.8466 21.3328 25.8312 21.4158C25.8158 21.4987 25.7843 21.5778 25.7383 21.6485C25.4075 22.143 25.0479 22.6177 24.6614 23.07C24.6002 23.1415 24.5242 23.1988 24.4387 23.2378C24.3531 23.2769 24.26 23.2968 24.166 23.2962" />
        <path d="M5.45996 20.2659H8.21688V14.752H5.78304V13.3305H8.21688V10.0997C8.21688 6.98743 9.95073 5.38281 12.923 5.38281C15.8953 5.38281 17.5323 7.15974 17.5323 9.69051V10.0567H15.863V9.69051C15.8893 9.30005 15.8308 8.90853 15.6916 8.54279C15.5524 8.17706 15.3357 7.84576 15.0565 7.57161C14.7772 7.29746 14.442 7.08695 14.0737 6.95452C13.7055 6.82208 13.3129 6.77086 12.923 6.80435C10.7692 6.80435 9.95073 7.98897 9.95073 10.0351V13.3197H14.7V14.752H9.92919V20.2659H16.6707V21.6874H5.45996V20.2659Z" />
      </g>
      <defs>
        <clipPath id="clip0_1996_13452">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconCuttingEdgeInnovation = () => {
  return (
    <svg
      width="36"
      height="37"
      viewBox="0 0 36 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3.9375 11.5625H2.8125C2.8125 13.1564 4.07419 14.4531 5.625 14.4531V13.2969C4.69463 13.2969 3.9375 12.5187 3.9375 11.5625Z" />
      <path d="M8.39014 6.70567L9.42064 7.16875C10.2273 5.2725 12.0492 4.04688 14.0624 4.04688C14.7666 4.04688 15.4478 4.19256 16.0874 4.47989L16.5374 3.42019C15.7555 3.06869 14.9224 2.89062 14.0624 2.89062C11.602 2.89062 9.37507 4.38797 8.39014 6.70567Z" />
      <path d="M34.1432 25.2276C33.9711 25.1825 33.8265 25.0542 33.7528 24.8709C33.6819 24.6981 33.6943 24.5004 33.7928 24.3304C34.1904 23.643 34.0841 22.7671 33.5334 22.2012L32.3983 21.0345C31.8476 20.4685 30.9966 20.3598 30.3154 20.7749C30.1618 20.8697 29.9678 20.8819 29.7889 20.8044C29.6224 20.7333 29.4969 20.5847 29.4497 20.3945C29.2584 19.6198 28.5812 19.0781 27.8027 19.0781H26.1973C25.4188 19.0781 24.7416 19.6198 24.5458 20.4084C24.5019 20.5853 24.3765 20.7339 24.1993 20.8096C24.0317 20.8825 23.8371 20.8697 23.6722 20.7686C23.004 20.3592 22.1513 20.4685 21.6006 21.0345L20.4654 22.2012C19.9147 22.7671 19.8084 23.6424 20.2129 24.342C20.3046 24.5004 20.3175 24.6981 20.2416 24.8837C20.1724 25.0542 20.0278 25.1831 19.8433 25.2317C19.0896 25.4283 18.5625 26.1249 18.5625 26.925V28.575C18.5625 29.3751 19.0896 30.0712 19.8568 30.2724C20.0295 30.3175 20.1735 30.4464 20.2472 30.6291C20.3181 30.8019 20.3057 30.9996 20.2072 31.1696C19.8096 31.857 19.9159 32.7329 20.4666 33.2988L21.6017 34.4655C22.1529 35.0315 23.004 35.1407 23.6846 34.7251C23.8376 34.6303 24.0317 34.6181 24.2111 34.6956C24.3776 34.7667 24.5031 34.9153 24.5503 35.1055C24.7416 35.8802 25.4188 36.4219 26.1973 36.4219H27.8027C28.5812 36.4219 29.2584 35.8802 29.4542 35.0916C29.4981 34.9147 29.6235 34.7661 29.8007 34.6904C29.9689 34.6175 30.1624 34.6303 30.3278 34.7314C30.996 35.1408 31.8487 35.0309 32.3994 34.4655L33.5346 33.2988C34.0852 32.7329 34.1916 31.8576 33.7871 31.158C33.6954 30.9996 33.6825 30.8019 33.7579 30.6169C33.8271 30.4458 33.9716 30.3169 34.1567 30.2683C34.9104 30.0717 35.4375 29.3751 35.4375 28.575V26.925C35.4375 26.1249 34.9104 25.4283 34.1432 25.2276ZM34.3125 28.575C34.3125 28.8455 34.1342 29.0814 33.8664 29.1514C33.3534 29.2849 32.9242 29.6665 32.7156 30.1799C32.5069 30.6898 32.5457 31.276 32.8258 31.7605C32.9602 31.9929 32.9242 32.2894 32.7381 32.4808L31.6029 33.6475C31.4162 33.84 31.1271 33.8758 30.8908 33.7307C30.4312 33.4497 29.8609 33.4093 29.3552 33.6278C28.8647 33.8382 28.494 34.2793 28.3601 34.8193C28.2954 35.0824 28.0659 35.2656 27.8027 35.2656H26.1973C25.9341 35.2656 25.7046 35.0824 25.6359 34.8072C25.506 34.2793 25.1347 33.8388 24.6347 33.6237C24.4249 33.5336 24.201 33.4885 23.9782 33.4885C23.6739 33.4885 23.3691 33.5723 23.0985 33.7382C22.8718 33.8764 22.5838 33.84 22.3971 33.648L21.2619 32.4814C21.0757 32.2894 21.0392 31.9934 21.1804 31.7495C21.4537 31.2771 21.4931 30.6903 21.2811 30.1718C21.0758 29.6671 20.6466 29.2861 20.1206 29.1485C19.8658 29.0814 19.6875 28.8461 19.6875 28.575V26.925C19.6875 26.6545 19.8658 26.4186 20.1336 26.3486C20.6471 26.2145 21.0763 25.8329 21.2844 25.3201C21.4931 24.8102 21.4543 24.224 21.1742 23.7395C21.0398 23.5071 21.0757 23.2106 21.2619 23.0192L22.3971 21.8525C22.5844 21.6612 22.8735 21.6253 23.1092 21.7693C23.5687 22.0508 24.1391 22.0902 24.6448 21.8722C25.1353 21.6618 25.506 21.2207 25.6399 20.6807C25.7046 20.4176 25.9341 20.2344 26.1973 20.2344H27.8027C28.0659 20.2344 28.2954 20.4176 28.3641 20.6928C28.494 21.2207 28.8653 21.6612 29.3653 21.8763C29.8614 22.0896 30.4324 22.0497 30.9015 21.7624C31.1288 21.6242 31.4173 21.6618 31.6029 21.8525L32.7381 23.0192C32.9242 23.2111 32.9608 23.5071 32.8196 23.7511C32.5463 24.2234 32.5069 24.8102 32.7195 25.3288C32.9237 25.8335 33.3529 26.2151 33.8794 26.3527C34.1342 26.4186 34.3125 26.6539 34.3125 26.925V28.575Z" />
      <path d="M27 22.5469C24.2083 22.5469 21.9375 24.8813 21.9375 27.75C21.9375 30.6187 24.2083 32.9531 27 32.9531C29.7917 32.9531 32.0625 30.6187 32.0625 27.75C32.0625 24.8813 29.7917 22.5469 27 22.5469ZM27 31.7969C24.8293 31.7969 23.0625 29.9816 23.0625 27.75C23.0625 25.5184 24.8293 23.7031 27 23.7031C29.1707 23.7031 30.9375 25.5184 30.9375 27.75C30.9375 29.9816 29.1707 31.7969 27 31.7969Z" />
      <path d="M27 24.8594C25.4492 24.8594 24.1875 26.1561 24.1875 27.75C24.1875 29.3439 25.4492 30.6406 27 30.6406C28.5508 30.6406 29.8125 29.3439 29.8125 27.75C29.8125 26.1561 28.5508 24.8594 27 24.8594ZM27 29.4844C26.0696 29.4844 25.3125 28.7062 25.3125 27.75C25.3125 26.7938 26.0696 26.0156 27 26.0156C27.9304 26.0156 28.6875 26.7938 28.6875 27.75C28.6875 28.7062 27.9304 29.4844 27 29.4844Z" />
      <path d="M14.0625 8.67188H18.5625V9.82812H14.0625V8.67188Z" />
      <path d="M14.0625 10.9844H18.5625V12.1406H14.0625V10.9844Z" />
      <path d="M14.0625 13.2969H18.5625V14.4531H14.0625V13.2969Z" />
      <path d="M14.0625 15.6094H18.5625V16.7656H14.0625V15.6094Z" />
      <path d="M9.5625 17.9219H0.5625V30.6406H9.5625V27.1719H17.4375V26.0156H9.5625V17.9219ZM8.4375 29.4844H1.6875V19.0781H8.4375V29.4844Z" />
      <path d="M2.8125 20.2344H7.3125V21.3906H2.8125V20.2344Z" />
      <path d="M2.8125 22.5469H7.3125V23.7031H2.8125V22.5469Z" />
      <path d="M2.8125 24.8594H7.3125V26.0156H2.8125V24.8594Z" />
      <path d="M2.8125 27.1719H7.3125V28.3281H2.8125V27.1719Z" />
      <path d="M13.5 31.879C12.5319 32.1374 11.8125 33.0352 11.8125 34.1094C11.8125 35.3847 12.8216 36.4219 14.0625 36.4219C15.3034 36.4219 16.3125 35.3847 16.3125 34.1094C16.3125 33.0352 15.5931 32.1374 14.625 31.879V29.4844H17.4375V28.3281H13.5V31.879ZM15.1875 34.1094C15.1875 34.747 14.6829 35.2656 14.0625 35.2656C13.4421 35.2656 12.9375 34.747 12.9375 34.1094C12.9375 33.4717 13.4421 32.9531 14.0625 32.9531C14.6829 32.9531 15.1875 33.4717 15.1875 34.1094Z" />
      <path d="M15.1875 19.0781H20.8125V16.7656H30.9375C33.4187 16.7656 35.4375 14.6907 35.4375 12.1406C35.4375 9.59052 33.4187 7.51562 30.9375 7.51562C30.6292 7.51562 30.3216 7.54916 30.0173 7.61564C29.1026 4.80595 26.5517 2.89062 23.625 2.89062C22.5422 2.89062 21.4774 3.16119 20.5161 3.6763C18.9062 1.70084 16.5814 0.578125 14.0625 0.578125C10.4833 0.578125 7.27875 2.94092 6.10481 6.38366C3.11625 6.09055 0.5625 8.53081 0.5625 11.5625C0.5625 14.4312 2.83331 16.7656 5.625 16.7656H11.8125V19.0781H14.0625V24.8594H17.4375V23.7031H15.1875V19.0781ZM11.8125 15.6094H5.625C3.45431 15.6094 1.6875 13.7941 1.6875 11.5625C1.6875 9.07367 3.91725 7.09475 6.38719 7.59309L6.894 7.69484L7.03631 7.18436C7.92844 3.97577 10.8174 1.73438 14.0625 1.73438C16.389 1.73438 18.5248 2.84091 19.9232 4.77011L20.232 5.19561L20.6707 4.91637C21.5629 4.3475 22.5844 4.04688 23.625 4.04688C26.226 4.04688 28.4715 5.86277 29.0852 8.46259L29.232 9.0835L29.8187 8.87133C30.1854 8.73894 30.5618 8.67188 30.9375 8.67188C32.7988 8.67188 34.3125 10.2276 34.3125 12.1406C34.3125 14.0536 32.7988 15.6094 30.9375 15.6094H20.8125V6.35938H11.8125V15.6094ZM12.9375 17.9219V7.51562H19.6875V17.9219H12.9375Z" />
      <path d="M32.0625 12.1406H33.1875C33.1875 10.8653 32.1784 9.82812 30.9375 9.82812V10.9844C31.5579 10.9844 32.0625 11.503 32.0625 12.1406Z" />
      <path d="M26.8605 8.83664L27.9382 8.50711C27.3752 6.56172 25.6016 5.20312 23.625 5.20312V6.35938C25.1077 6.35938 26.4381 7.37803 26.8605 8.83664Z" />
      <path d="M26.4375 13.2969H27.5625V14.4531H26.4375V13.2969Z" />
      <path d="M24.1875 13.2969H25.3125V14.4531H24.1875V13.2969Z" />
      <path d="M21.9375 13.2969H23.0625V14.4531H21.9375V13.2969Z" />
    </svg>
  )
}

export const IconSmartAccessFooterArrow = () => {
  return (
    <svg
      width="42"
      height="19"
      viewBox="0 0 42 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M41.031 10.5411H0.969449C0.49291 10.5411 0.10791 10.0736 0.10791 9.49495C0.10791 8.9163 0.49291 8.4488 0.969449 8.4488H38.9498L33.7214 2.09995C33.3848 1.6913 33.3848 1.02764 33.7214 0.61899C34.0579 0.210337 34.6045 0.210337 34.941 0.61899L41.6421 8.75611C41.8898 9.05688 41.9625 9.50476 41.8279 9.89707C41.6933 10.2861 41.3783 10.5411 41.031 10.5411Z" />
      <path d="M34.3218 18.687C34.101 18.687 33.8803 18.5856 33.7133 18.3797C33.3768 17.971 33.3768 17.3074 33.7133 16.8987L40.4226 8.7518C40.7591 8.34315 41.3056 8.34315 41.6422 8.7518C41.9787 9.16046 41.9787 9.82411 41.6422 10.2328L34.933 18.3797C34.7633 18.5856 34.5426 18.687 34.3218 18.687Z" />
    </svg>
  )
}

export const IconErrorCircle = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.953 0.378906C4.465 0.378906 0 4.86491 0 10.3789C0 15.8929 4.486 20.3789 10 20.3789C15.514 20.3789 20 15.8929 20 10.3789C20 4.86491 15.493 0.378906 9.953 0.378906ZM11 15.3789H9V13.3789H11V15.3789ZM11 11.3789H9V5.37891H11V11.3789Z"
      fill="#EB5757"
    />
  </svg>
)

export const IconTickInCircle = ({ className }: { className?: string }) => (
  <svg
    className={classNames({ [className!]: !!className })}
    width="35"
    height="36"
    viewBox="0 0 35 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M33.6892 19.9447C32.3817 26.4821 27.4524 32.6378 20.5358 34.0133C17.1625 34.6851 13.6631 34.2755 10.5361 32.8428C7.40909 31.4101 4.81378 29.0274 3.11973 26.0339C1.42567 23.0404 0.719233 19.5888 1.101 16.1704C1.48276 12.7521 2.93327 9.54128 5.24599 6.99527C9.98957 1.77052 17.9993 0.33228 24.5367 2.94727"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.4622 17.3291L17.9996 23.8666L33.6895 6.86914"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const IconTick = ({ className }: { className?: string }) => (
  <svg
    className={classNames({ [className!]: !!className })}
    width="22"
    height="16"
    viewBox="0 0 22 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 1L8.20004 14L1 6.83146"
      stroke="#FA5F00"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
  </svg>
)

export const IconRefresh: React.FC<{ style?: React.CSSProperties }> = ({
  style
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    width={20}
    height={20}
    style={style}
  >
    <path
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
    />
  </svg>
)

export const IconShieldTick: React.FC<{ style?: React.CSSProperties }> = ({
  style
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M18.7022 5.78441L12.7878 3.24968C12.2847 3.03406 11.7153 3.03406 11.2122 3.24968L5.29778 5.78441C4.47855 6.13551 3.99051 6.98635 4.10106 7.87077L4.71405 12.7747C4.9342 14.5359 5.81517 16.1477 7.1787 17.284L10.7196 20.2347C11.4613 20.8528 12.5387 20.8528 13.2804 20.2347L16.8213 17.284C18.1848 16.1477 19.0658 14.5359 19.286 12.7747L19.8989 7.87077C20.0095 6.98635 19.5215 6.13551 18.7022 5.78441Z"
      stroke="#FA5F00"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M9 12L11.5687 14.5687C11.7918 14.7918 12.1633 14.7551 12.3383 14.4925L16 9"
      stroke="#FA5F00"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
)

export const IconBackArrow: React.FC<{ style?: React.CSSProperties }> = ({
  style
}) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M3.40426 7.74468L0.255319 4.59574C-0.0851062 4.25532 -0.0851062 3.74468 0.255319 3.40426L3.40426 0.255319C3.74468 -0.0851065 4.25532 -0.0851066 4.59574 0.255319C4.93617 0.595744 4.93617 1.10638 4.59574 1.44681L2.89362 3.14894L7.14894 3.14894C7.65957 3.14894 8 3.48936 8 4C8 4.51064 7.65957 4.85106 7.14894 4.85106L2.89362 4.85106L4.59574 6.55319C4.76596 6.7234 4.85106 6.97872 4.85106 7.14894C4.85106 7.31915 4.76596 7.57447 4.59574 7.74468C4.25532 8.08511 3.74468 8.08511 3.40426 7.74468Z"
      fill="#FA5F00"
    />
  </svg>
)

export const IconElectronicDevices = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={24}
      viewBox="0 0 24 24"
      width={24}
      className="IconElectronicDevices"
    >
      <path d="M20.916 9.564a.998.998 0 0 0-.513-1.316L7.328 2.492c-.995-.438-2.22.051-2.645 1.042l-2.21 5.154a2.001 2.001 0 0 0 1.052 2.624L9.563 13.9 8.323 17H4v-3H2v8h2v-3h4.323c.823 0 1.552-.494 1.856-1.258l1.222-3.054 5.205 2.23a1 1 0 0 0 1.31-.517l.312-.71 1.701.68 2-5-1.536-.613.523-1.194zm-4.434 5.126L4.313 9.475l2.208-5.152 12.162 5.354-2.201 5.013z" />
    </svg>
  )
}
